export const iconsData: Array<{
    name: string;
    categories: string[];
    tags: string[];
}> = [
  {
    "name": "a-arrow-down",
    "categories": ["text","design"],
    "tags": ["letter","font size","text","formatting","smaller"]
  },
  {
    "name": "a-arrow-up",
    "categories": ["text","design"],
    "tags": ["letter","font size","text","formatting","larger","bigger"]
  },
  {
    "name": "a-large-small",
    "categories": ["text","design"],
    "tags": ["letter","font size","text","formatting"]
  },
  {
    "name": "accessibility",
    "categories": ["accessibility","medical"],
    "tags": ["disability","disabled","dda","wheelchair"]
  },
  {
    "name": "activity",
    "categories": ["medical","account","social","science","multimedia"],
    "tags": ["pulse","action","motion","movement","exercise","fitness","healthcare","heart rate monitor","vital signs","vitals","emergency room","er","intensive care","hospital","defibrillator","earthquake","siesmic","magnitude","richter scale","aftershock","tremor","shockwave","audio","waveform","synthesizer","synthesiser","music"]
  },
  {
    "name": "air-vent",
    "categories": ["home"],
    "tags": ["air conditioner","ac","central air","cooling","climate-control"]
  },
  {
    "name": "airplay",
    "categories": ["multimedia","connectivity","devices","brands"],
    "tags": ["stream","cast","mirroring","screen","monitor","macos","osx"]
  },
  {
    "name": "alarm-clock-check",
    "categories": ["devices","notifications","time"],
    "tags": ["done","todo","tick","complete","task"]
  },
  {
    "name": "alarm-clock-minus",
    "categories": ["devices","notifications","time"],
    "tags": ["remove"]
  },
  {
    "name": "alarm-clock-off",
    "categories": ["devices","notifications","time"],
    "tags": ["morning","turn-off"]
  },
  {
    "name": "alarm-clock-plus",
    "categories": ["devices","notifications","time"],
    "tags": ["add"]
  },
  {
    "name": "alarm-clock",
    "categories": ["devices","notifications","time"],
    "tags": ["morning"]
  },
  {
    "name": "alarm-smoke",
    "categories": ["home","devices","travel"],
    "tags": ["fire","alert","warning","detector","carbon monoxide","safety","equipment","amenities"]
  },
  {
    "name": "album",
    "categories": ["photography","multimedia"],
    "tags": ["photo","book"]
  },
  {
    "name": "align-center-horizontal",
    "categories": ["layout"],
    "tags": ["items","flex","justify"]
  },
  {
    "name": "align-center-vertical",
    "categories": ["layout"],
    "tags": ["items","flex","justify"]
  },
  {
    "name": "align-end-horizontal",
    "categories": ["layout"],
    "tags": ["items","bottom","flex","justify"]
  },
  {
    "name": "align-end-vertical",
    "categories": ["layout"],
    "tags": ["items","right","flex","justify"]
  },
  {
    "name": "align-horizontal-distribute-center",
    "categories": ["layout"],
    "tags": ["items","flex","justify","space","evenly","around"]
  },
  {
    "name": "align-horizontal-distribute-end",
    "categories": ["layout"],
    "tags": ["right","items","flex","justify"]
  },
  {
    "name": "align-horizontal-distribute-start",
    "categories": ["layout"],
    "tags": ["left","items","flex","justify"]
  },
  {
    "name": "align-horizontal-justify-center",
    "categories": ["layout"],
    "tags": ["center","items","flex","justify"]
  },
  {
    "name": "align-horizontal-justify-end",
    "categories": ["layout"],
    "tags": ["right","items","flex","justify"]
  },
  {
    "name": "align-horizontal-justify-start",
    "categories": ["layout"],
    "tags": ["left","items","flex","justify"]
  },
  {
    "name": "align-horizontal-space-around",
    "categories": ["layout"],
    "tags": ["center","items","flex","justify","distribute","between"]
  },
  {
    "name": "align-horizontal-space-between",
    "categories": ["layout"],
    "tags": ["around","items","bottom","flex","justify"]
  },
  {
    "name": "align-start-horizontal",
    "categories": ["layout"],
    "tags": ["top","items","flex","justify"]
  },
  {
    "name": "align-start-vertical",
    "categories": ["layout"],
    "tags": ["left","items","flex","justify"]
  },
  {
    "name": "align-vertical-distribute-center",
    "categories": ["layout"],
    "tags": ["items","flex","justify","space","evenly","around"]
  },
  {
    "name": "align-vertical-distribute-end",
    "categories": ["layout"],
    "tags": ["bottom","items","flex","justify"]
  },
  {
    "name": "align-vertical-distribute-start",
    "categories": ["layout"],
    "tags": ["top","items","flex","justify"]
  },
  {
    "name": "align-vertical-justify-center",
    "categories": ["layout"],
    "tags": ["center","items","flex","justify","distribute","between"]
  },
  {
    "name": "align-vertical-justify-end",
    "categories": ["layout"],
    "tags": ["bottom","items","flex","justify","distribute","between"]
  },
  {
    "name": "align-vertical-justify-start",
    "categories": ["layout"],
    "tags": ["top","items","flex","justify","distribute","between"]
  },
  {
    "name": "align-vertical-space-around",
    "categories": ["layout"],
    "tags": ["center","items","flex","justify","distribute","between"]
  },
  {
    "name": "align-vertical-space-between",
    "categories": ["layout"],
    "tags": ["center","items","flex","justify","distribute","between"]
  },
  {
    "name": "ambulance",
    "categories": ["medical","transportation"],
    "tags": ["ambulance","emergency","medical","vehicle","siren","healthcare","transportation","rescue","urgent","first aid"]
  },
  {
    "name": "ampersand",
    "categories": ["text","development"],
    "tags": ["and","typography","operator","join","concatenate","code","&"]
  },
  {
    "name": "ampersands",
    "categories": ["text","development"],
    "tags": ["and","operator","then","code","&&"]
  },
  {
    "name": "amphora",
    "categories": ["food-beverage","gaming"],
    "tags": ["pottery","artifact","artefact","vase","ceramics","clay","archaeology","museum","wine","oil"]
  },
  {
    "name": "anchor",
    "categories": ["transportation","text"],
    "tags": ["ship"]
  },
  {
    "name": "angry",
    "categories": ["emoji"],
    "tags": ["emoji","anger","face","emotion"]
  },
  {
    "name": "annoyed",
    "categories": ["emoji"],
    "tags": ["emoji","nuisance","face","emotion"]
  },
  {
    "name": "antenna",
    "categories": ["devices","multimedia","communication"],
    "tags": ["signal","connection","connectivity","tv","television","broadcast","live","frequency","tune","scan","channels","aerial","receiver","transmission","transducer","terrestrial","satellite","cable"]
  },
  {
    "name": "anvil",
    "categories": ["buildings","tools","gaming"],
    "tags": ["metal","iron","alloy","materials","heavy","weight","blacksmith","forge","acme"]
  },
  {
    "name": "aperture",
    "categories": ["photography"],
    "tags": ["camera","photo","pictures","shutter","exposure"]
  },
  {
    "name": "app-window-mac",
    "categories": ["layout","design","development","files"],
    "tags": ["application","menu bar","pane","preferences","macos","osx","executable"]
  },
  {
    "name": "app-window",
    "categories": ["layout","design","development","files"],
    "tags": ["application","menu bar","pane","executable"]
  },
  {
    "name": "apple",
    "categories": ["food-beverage"],
    "tags": ["fruit","food","healthy","snack","nutrition","fresh","produce","grocery","organic","harvest","vitamin","red","green","juicy","sweet","tart","bite","orchard","plant","core","raw","diet"]
  },
  {
    "name": "archive-restore",
    "categories": ["files","mail"],
    "tags": ["unarchive","index","backup","box","storage","records"]
  },
  {
    "name": "archive-x",
    "categories": ["files","mail"],
    "tags": ["index","backup","box","storage","records","junk"]
  },
  {
    "name": "archive",
    "categories": ["files","mail"],
    "tags": ["index","backup","box","storage","records"]
  },
  {
    "name": "armchair",
    "categories": ["home"],
    "tags": ["sofa","furniture","leisure","lounge","loveseat","couch"]
  },
  {
    "name": "arrow-big-down-dash",
    "categories": ["arrows","gaming","files"],
    "tags": ["backwards","reverse","slow","direction","south","download"]
  },
  {
    "name": "arrow-big-down",
    "categories": ["arrows","gaming"],
    "tags": ["backwards","reverse","direction","south"]
  },
  {
    "name": "arrow-big-left-dash",
    "categories": ["arrows","gaming"],
    "tags": ["previous","back","direction","west","turn","corner"]
  },
  {
    "name": "arrow-big-left",
    "categories": ["arrows","gaming"],
    "tags": ["previous","back","direction","west","indicate turn"]
  },
  {
    "name": "arrow-big-right-dash",
    "categories": ["arrows","gaming"],
    "tags": ["next","forward","direction","east","turn","corner"]
  },
  {
    "name": "arrow-big-right",
    "categories": ["arrows","gaming"],
    "tags": ["next","forward","direction","east","indicate turn"]
  },
  {
    "name": "arrow-big-up-dash",
    "categories": ["arrows","text","development","gaming"],
    "tags": ["caps lock","capitals","keyboard","button","mac","forward","direction","north","faster","speed","boost"]
  },
  {
    "name": "arrow-big-up",
    "categories": ["arrows","text","development","gaming"],
    "tags": ["shift","keyboard","button","mac","capitalize","capitalise","forward","direction","north"]
  },
  {
    "name": "arrow-down-0-1",
    "categories": ["text","layout","arrows"],
    "tags": ["filter","sort","ascending","descending","increasing","decreasing","rising","falling","numerical"]
  },
  {
    "name": "arrow-down-1-0",
    "categories": ["text","layout","arrows"],
    "tags": ["filter","sort","ascending","descending","increasing","decreasing","rising","falling","numerical"]
  },
  {
    "name": "arrow-down-a-z",
    "categories": ["text","layout","arrows"],
    "tags": ["filter","sort","ascending","descending","increasing","decreasing","rising","falling","alphabetical"]
  },
  {
    "name": "arrow-down-from-line",
    "categories": ["arrows","files"],
    "tags": ["backwards","reverse","direction","south","download","expand","fold","vertical"]
  },
  {
    "name": "arrow-down-left",
    "categories": ["arrows"],
    "tags": ["direction","south-west","diagonal"]
  },
  {
    "name": "arrow-down-narrow-wide",
    "categories": ["text","layout","arrows"],
    "tags": ["filter","sort","ascending","descending","increasing","decreasing","rising","falling"]
  },
  {
    "name": "arrow-down-right",
    "categories": ["arrows"],
    "tags": ["direction","south-east","diagonal"]
  },
  {
    "name": "arrow-down-to-dot",
    "categories": ["arrows"],
    "tags": ["direction","south","waypoint","location","step","into"]
  },
  {
    "name": "arrow-down-to-line",
    "categories": ["arrows","files","development"],
    "tags": ["behind","direction","south","download","save","git","version control","pull","collapse","fold","vertical"]
  },
  {
    "name": "arrow-down-up",
    "categories": ["arrows"],
    "tags": ["bidirectional","two-way","2-way","swap","switch","network","traffic","flow","mobile data","internet","sort","reorder","move"]
  },
  {
    "name": "arrow-down-wide-narrow",
    "categories": ["text","layout","arrows"],
    "tags": ["filter","sort","ascending","descending","increasing","decreasing","rising","falling"]
  },
  {
    "name": "arrow-down-z-a",
    "categories": ["text","layout","arrows"],
    "tags": ["filter","sort","ascending","descending","increasing","decreasing","rising","falling","alphabetical","reverse"]
  },
  {
    "name": "arrow-down",
    "categories": ["arrows"],
    "tags": ["backwards","reverse","direction","south"]
  },
  {
    "name": "arrow-left-from-line",
    "categories": ["arrows"],
    "tags": ["previous","back","direction","west","expand","fold","horizontal","<-|"]
  },
  {
    "name": "arrow-left-right",
    "categories": ["arrows"],
    "tags": ["bidirectional","two-way","2-way","swap","switch","transaction","reorder","move","<-","->"]
  },
  {
    "name": "arrow-left-to-line",
    "categories": ["arrows"],
    "tags": ["previous","back","direction","west","collapse","fold","horizontal","|<-"]
  },
  {
    "name": "arrow-left",
    "categories": ["arrows"],
    "tags": ["previous","back","direction","west","<-"]
  },
  {
    "name": "arrow-right-from-line",
    "categories": ["arrows"],
    "tags": ["next","forward","direction","east","export","expand","fold","horizontal","|->"]
  },
  {
    "name": "arrow-right-left",
    "categories": ["arrows"],
    "tags": ["bidirectional","two-way","2-way","swap","switch","transaction","reorder","move","<-","->"]
  },
  {
    "name": "arrow-right-to-line",
    "categories": ["arrows","development"],
    "tags": ["next","forward","direction","east","tab","keyboard","mac","indent","collapse","fold","horizontal","->|"]
  },
  {
    "name": "arrow-right",
    "categories": ["arrows"],
    "tags": ["forward","next","direction","east","->"]
  },
  {
    "name": "arrow-up-0-1",
    "categories": ["text","layout","arrows"],
    "tags": ["filter","sort","ascending","descending","increasing","decreasing","rising","falling","numerical"]
  },
  {
    "name": "arrow-up-1-0",
    "categories": ["text","layout","arrows"],
    "tags": ["filter","sort","ascending","descending","increasing","decreasing","rising","falling","numerical"]
  },
  {
    "name": "arrow-up-a-z",
    "categories": ["text","layout","arrows"],
    "tags": ["filter","sort","ascending","descending","increasing","decreasing","rising","falling","alphabetical"]
  },
  {
    "name": "arrow-up-down",
    "categories": ["arrows"],
    "tags": ["bidirectional","two-way","2-way","swap","switch","network","mobile data","internet","sort","reorder","move"]
  },
  {
    "name": "arrow-up-from-dot",
    "categories": ["arrows"],
    "tags": ["direction","north","step","out"]
  },
  {
    "name": "arrow-up-from-line",
    "categories": ["arrows","files","development"],
    "tags": ["forward","direction","north","upload","git","version control","push","expand","fold","vertical"]
  },
  {
    "name": "arrow-up-left",
    "categories": ["arrows"],
    "tags": ["direction","north-west","diagonal"]
  },
  {
    "name": "arrow-up-narrow-wide",
    "categories": ["text","layout","arrows"],
    "tags": ["filter","sort","ascending","descending","increasing","decreasing","rising","falling"]
  },
  {
    "name": "arrow-up-right",
    "categories": ["arrows"],
    "tags": ["direction","north-east","diagonal"]
  },
  {
    "name": "arrow-up-to-line",
    "categories": ["arrows","files"],
    "tags": ["forward","direction","north","upload","collapse","fold","vertical"]
  },
  {
    "name": "arrow-up-wide-narrow",
    "categories": ["text","layout","arrows"],
    "tags": ["filter","sort","ascending","descending","increasing","decreasing","rising","falling"]
  },
  {
    "name": "arrow-up-z-a",
    "categories": ["text","layout","arrows"],
    "tags": ["filter","sort","ascending","descending","increasing","decreasing","rising","falling","alphabetical","reverse"]
  },
  {
    "name": "arrow-up",
    "categories": ["arrows"],
    "tags": ["forward","direction","north"]
  },
  {
    "name": "arrows-up-from-line",
    "categories": ["arrows","transportation","mail"],
    "tags": ["direction","orientation","this way up","vertical","package","box","fragile","postage","shipping"]
  },
  {
    "name": "asterisk",
    "categories": ["text","math","development"],
    "tags": ["reference","times","multiply","multiplication","operator","code","glob pattern","wildcard","*"]
  },
  {
    "name": "at-sign",
    "categories": ["text","account"],
    "tags": ["mention","at","email","message","@"]
  },
  {
    "name": "atom",
    "categories": ["science"],
    "tags": ["atomic","nuclear","physics","particle","element","molecule","electricity","energy","chemistry"]
  },
  {
    "name": "audio-lines",
    "categories": ["multimedia","communication"],
    "tags": ["graphic equaliser","sound","noise","listen","hearing","hertz","frequency","wavelength","vibrate","sine","synthesizer","synthesiser","levels","track","music","playback","radio","broadcast","airwaves","voice","vocals","singer","song"]
  },
  {
    "name": "audio-waveform",
    "categories": ["multimedia","communication"],
    "tags": ["sound","noise","listen","hearing","hertz","frequency","wavelength","vibrate","sine","synthesizer","synthesiser","levels","track","music","playback","radio","broadcast","airwaves","voice","vocals","singer","song"]
  },
  {
    "name": "award",
    "categories": ["account","sports","gaming"],
    "tags": ["achievement","badge","rosette","prize","winner"]
  },
  {
    "name": "axe",
    "categories": ["tools","gaming"],
    "tags": ["hatchet","weapon","chop","sharp","equipment","fireman","firefighter","brigade","lumberjack","woodcutter","logger","forestry"]
  },
  {
    "name": "axis-3d",
    "categories": ["design"],
    "tags": ["gizmo","coordinates"]
  },
  {
    "name": "baby",
    "categories": ["accessibility","people"],
    "tags": ["child","childproof","children"]
  },
  {
    "name": "backpack",
    "categories": ["gaming","photography","travel"],
    "tags": ["bag","hiking","travel","camping","school","childhood"]
  },
  {
    "name": "badge-alert",
    "categories": ["account","social"],
    "tags": ["check","verified","unverified","security","safety","issue"]
  },
  {
    "name": "badge-cent",
    "categories": ["shopping","finance"],
    "tags": ["discount","offer","sale","voucher","tag","monetization","marketing","finance","financial","exchange","transaction","payment","cents","dollar","usd","$","¢"]
  },
  {
    "name": "badge-check",
    "categories": ["social"],
    "tags": ["verified","check"]
  },
  {
    "name": "badge-dollar-sign",
    "categories": ["shopping","finance"],
    "tags": ["discount","offer","sale","voucher","tag","monetization","marketing","finance","financial","exchange","transaction","payment","usd","$"]
  },
  {
    "name": "badge-euro",
    "categories": ["shopping","finance"],
    "tags": ["discount","offer","sale","voucher","tag","monetization","marketing","finance","financial","exchange","transaction","payment","€"]
  },
  {
    "name": "badge-indian-rupee",
    "categories": ["shopping","finance"],
    "tags": ["discount","offer","sale","voucher","tag","monetization","marketing","finance","financial","exchange","transaction","payment","inr","₹"]
  },
  {
    "name": "badge-info",
    "categories": ["account","accessibility","social"],
    "tags": ["verified","unverified","help"]
  },
  {
    "name": "badge-japanese-yen",
    "categories": ["shopping","finance"],
    "tags": ["discount","offer","sale","voucher","tag","monetization","marketing","finance","financial","exchange","transaction","payment","jpy","¥"]
  },
  {
    "name": "badge-minus",
    "categories": ["social"],
    "tags": ["verified","unverified","delete","remove","erase"]
  },
  {
    "name": "badge-percent",
    "categories": ["social","finance","shopping","math"],
    "tags": ["verified","unverified","sale","discount","offer","marketing","sticker","price tag"]
  },
  {
    "name": "badge-plus",
    "categories": ["social"],
    "tags": ["verified","unverified","add","create","new"]
  },
  {
    "name": "badge-pound-sterling",
    "categories": ["shopping","finance"],
    "tags": ["discount","offer","sale","voucher","tag","monetization","marketing","finance","financial","exchange","transaction","payment","british","gbp","£"]
  },
  {
    "name": "badge-question-mark",
    "categories": ["accessibility","social","shapes"],
    "tags": ["verified","unverified","help"]
  },
  {
    "name": "badge-russian-ruble",
    "categories": ["shopping","finance"],
    "tags": ["discount","offer","sale","voucher","tag","monetization","marketing","finance","financial","exchange","transaction","payment","rub","₽"]
  },
  {
    "name": "badge-swiss-franc",
    "categories": ["shopping","finance"],
    "tags": ["discount","offer","sale","voucher","tag","monetization","marketing","finance","financial","exchange","transaction","payment","chf","₣"]
  },
  {
    "name": "badge-turkish-lira",
    "categories": ["shopping","finance"],
    "tags": ["discount","offer","sale","voucher","tag","monetization","marketing","finance","financial","exchange","transaction","payment","try","₺"]
  },
  {
    "name": "badge-x",
    "categories": ["social"],
    "tags": ["verified","unverified","lost","delete","remove"]
  },
  {
    "name": "badge",
    "categories": ["account","social","shapes"],
    "tags": ["check","verified","unverified"]
  },
  {
    "name": "baggage-claim",
    "categories": ["transportation","travel"],
    "tags": ["baggage","luggage","travel","cart","trolley","suitcase"]
  },
  {
    "name": "balloon",
    "categories": ["emoji"],
    "tags": ["party","festival","congratulations","celebration","decoration","colorful","floating","fun","birthday","event","entertainment"]
  },
  {
    "name": "ban",
    "categories": ["account"],
    "tags": ["cancel","no","stop","forbidden","prohibited","error","incorrect","mistake","wrong","failure","circle","slash","null","void"]
  },
  {
    "name": "banana",
    "categories": ["food-beverage"],
    "tags": ["fruit","food"]
  },
  {
    "name": "bandage",
    "categories": ["medical"],
    "tags": ["plaster","band-aid","first aid","medical","health","wound","injury","care","treatment","healing","protection","emergency","aid","safety","patch"]
  },
  {
    "name": "banknote-arrow-down",
    "categories": ["finance"],
    "tags": ["bill","currency","money","payment","funds","transaction","cash","finance","withdraw","expense","out","payout","refund","debit","spending","decrease"]
  },
  {
    "name": "banknote-arrow-up",
    "categories": ["finance"],
    "tags": ["bill","currency","money","payment","funds","transaction","cash","finance","deposit","earnings","income","in","credit","prepaid","growth","increase"]
  },
  {
    "name": "banknote-x",
    "categories": ["finance"],
    "tags": ["bill","currency","money","payment","funds","transaction","cash","finance","error","failed","rejected","canceled","declined","lost","delete","remove"]
  },
  {
    "name": "banknote",
    "categories": ["finance"],
    "tags": ["currency","money","payment"]
  },
  {
    "name": "barcode",
    "categories": ["shopping"],
    "tags": ["scan","checkout","till","cart","transaction","purchase","buy","product","packaging","retail","consumer"]
  },
  {
    "name": "barrel",
    "categories": ["food-beverage","navigation"],
    "tags": ["keg","drum","tank","wine","beer","oak","wood","firkin","hogshead","kilderkin","barrique","solera","aging","whiskey","brewery","distillery","winery","vineyard"]
  },
  {
    "name": "baseline",
    "categories": ["text"],
    "tags": ["text","format","color"]
  },
  {
    "name": "bath",
    "categories": ["travel"],
    "tags": ["amenities","services","bathroom","shower"]
  },
  {
    "name": "battery-charging",
    "categories": ["connectivity","devices"],
    "tags": ["power","electricity","energy","accumulator","charge"]
  },
  {
    "name": "battery-full",
    "categories": ["connectivity","devices"],
    "tags": ["power","electricity","energy","accumulator","charge"]
  },
  {
    "name": "battery-low",
    "categories": ["connectivity","devices"],
    "tags": ["power","electricity","energy","accumulator","charge"]
  },
  {
    "name": "battery-medium",
    "categories": ["connectivity","devices"],
    "tags": ["power","electricity","energy","accumulator","charge"]
  },
  {
    "name": "battery-plus",
    "categories": ["devices"],
    "tags": ["power","electricity","energy","accumulator","charge","plus","economy","health","add","new","maximum","upgrade","extra","+"]
  },
  {
    "name": "battery-warning",
    "categories": ["connectivity","devices"],
    "tags": ["power","electricity","energy","accumulator","charge","exclamation mark"]
  },
  {
    "name": "battery",
    "categories": ["connectivity","devices"],
    "tags": ["power","electricity","energy","accumulator","charge"]
  },
  {
    "name": "beaker",
    "categories": ["science","gaming"],
    "tags": ["cup","lab","chemistry","experiment","test"]
  },
  {
    "name": "bean-off",
    "categories": ["food-beverage"],
    "tags": ["soy free","legume","soy","food","seed","allergy","intolerance","diet"]
  },
  {
    "name": "bean",
    "categories": ["food-beverage"],
    "tags": ["legume","soy","food","seed"]
  },
  {
    "name": "bed-double",
    "categories": ["home"],
    "tags": ["sleep","hotel","furniture"]
  },
  {
    "name": "bed-single",
    "categories": ["home"],
    "tags": ["sleep","hotel","furniture"]
  },
  {
    "name": "bed",
    "categories": ["home"],
    "tags": ["sleep","hotel","furniture"]
  },
  {
    "name": "beef",
    "categories": ["food-beverage"],
    "tags": ["food","dish","restaurant","course","meal","meat","bbq","steak"]
  },
  {
    "name": "beer-off",
    "categories": ["food-beverage"],
    "tags": ["alcohol","bar","beverage","brewery","drink"]
  },
  {
    "name": "beer",
    "categories": ["food-beverage"],
    "tags": ["alcohol","bar","beverage","brewery","drink"]
  },
  {
    "name": "bell-dot",
    "categories": ["account","notifications"],
    "tags": ["alarm","notification","sound","reminder","unread"]
  },
  {
    "name": "bell-electric",
    "categories": ["devices","notifications","home"],
    "tags": ["fire alarm","flames","smoke","firefighter","fireman","department","brigade","station","emergency","alert","safety","school bell","period break","recess","doorbell","entrance","entry","ring","reception"]
  },
  {
    "name": "bell-minus",
    "categories": ["notifications"],
    "tags": ["alarm","notification","silent","reminder","delete","remove","erase"]
  },
  {
    "name": "bell-off",
    "categories": ["notifications"],
    "tags": ["alarm","notification","silent","reminder"]
  },
  {
    "name": "bell-plus",
    "categories": ["notifications"],
    "tags": ["notification","silent","reminder","add","create","new"]
  },
  {
    "name": "bell-ring",
    "categories": ["notifications"],
    "tags": ["alarm","notification","sound","reminder"]
  },
  {
    "name": "bell",
    "categories": ["account","notifications"],
    "tags": ["alarm","notification","sound","reminder"]
  },
  {
    "name": "between-horizontal-end",
    "categories": ["layout","design","tools"],
    "tags": ["insert","add","left","slot","squeeze","space","vertical","grid","table","rows","cells","excel","spreadsheet","accountancy","data","enter","entry","entries","blocks","rectangles","chevron"]
  },
  {
    "name": "between-horizontal-start",
    "categories": ["layout","design","tools"],
    "tags": ["insert","add","right","slot","squeeze","space","vertical","grid","table","rows","cells","excel","spreadsheet","accountancy","data","enter","entry","entries","blocks","rectangles","chevron"]
  },
  {
    "name": "between-vertical-end",
    "categories": ["layout","design","tools"],
    "tags": ["insert","add","top","slot","squeeze","space","vertical","grid","table","columns","cells","data","enter","entry","entries","blocks","rectangles","chevron"]
  },
  {
    "name": "between-vertical-start",
    "categories": ["layout","design","tools"],
    "tags": ["insert","add","bottom","slot","squeeze","space","vertical","grid","table","columns","cells","data","enter","entry","entries","blocks","rectangles","chevron"]
  },
  {
    "name": "biceps-flexed",
    "categories": ["emoji"],
    "tags": ["arm","muscle","strong","working out","athletic","toned","muscular","forelimb","curled"]
  },
  {
    "name": "bike",
    "categories": ["transportation"],
    "tags": ["bicycle","transport","trip"]
  },
  {
    "name": "binary",
    "categories": ["text","development"],
    "tags": ["code","digits","computer","zero","one","boolean"]
  },
  {
    "name": "binoculars",
    "categories": ["navigation","nature","photography","science","travel","development"],
    "tags": ["field glasses","lorgnette","pince-nez","observation","sightseeing","nature","wildlife","birdwatching","scouting","surveillance","search","discovery","monitoring","lookout","viewpoint","travel","tourism","research"]
  },
  {
    "name": "biohazard",
    "categories": ["science"],
    "tags": ["fallout","waste","biology","chemistry","chemical","element"]
  },
  {
    "name": "bird",
    "categories": ["animals"],
    "tags": ["peace","freedom","wing","avian","tweet"]
  },
  {
    "name": "birdhouse",
    "categories": ["nature","animals","navigation","home"],
    "tags": ["birdhouse","bird","garden","home","house","woodwork"]
  },
  {
    "name": "bitcoin",
    "categories": ["brands","development","finance"],
    "tags": ["currency","money","payment"]
  },
  {
    "name": "blend",
    "categories": ["design","photography","tools","development"],
    "tags": ["mode","overlay","multiply","screen","opacity","transparency","alpha","filters","lenses","mixed","shades","tints","hues","saturation","brightness","overlap","colors","colours"]
  },
  {
    "name": "blinds",
    "categories": ["home"],
    "tags": ["shades","screen","curtain","shutter","roller blind","window","lighting","household","home"]
  },
  {
    "name": "blocks",
    "categories": ["development","layout","shapes"],
    "tags": ["addon","plugin","integration","extension","package","build","stack","toys","kids","children","learning","squares","corner"]
  },
  {
    "name": "bluetooth-connected",
    "categories": ["connectivity","devices"],
    "tags": ["paired"]
  },
  {
    "name": "bluetooth-off",
    "categories": ["connectivity","devices"],
    "tags": ["lost"]
  },
  {
    "name": "bluetooth-searching",
    "categories": ["connectivity","devices"],
    "tags": ["pairing"]
  },
  {
    "name": "bluetooth",
    "categories": ["connectivity","devices"],
    "tags": ["wireless"]
  },
  {
    "name": "bold",
    "categories": ["text"],
    "tags": ["text","strong","format"]
  },
  {
    "name": "bolt",
    "categories": ["tools","home"],
    "tags": ["nut","screw","settings","preferences","configuration","controls","edit","diy","fixed","build","construction","parts"]
  },
  {
    "name": "bomb",
    "categories": ["security","tools"],
    "tags": ["fatal","error","crash","blockbuster","mine","explosion","explode","explosive"]
  },
  {
    "name": "bone",
    "categories": ["animals","medical","gaming"],
    "tags": ["health","skeleton","skull","death","pets","dog"]
  },
  {
    "name": "book-a",
    "categories": ["text","gaming"],
    "tags": ["dictionary","define","definition","thesaurus","encyclopedia","encyclopaedia","reading","booklet","magazine","leaflet","pamphlet","tome","library","writing","written","writer","author","story","script","fiction","novel","information","knowledge","education","high school","university","college","academy","student","study","learning","homework","research","language","translate","alphabetical","a-z","ordered"]
  },
  {
    "name": "book-alert",
    "categories": ["text","development","gaming"],
    "tags": ["reading","paperback","booklet","magazine","leaflet","pamphlet","tome","library","writing","written","writer","author","story","script","fiction","novel","information","knowledge","education","high school","university","college","academy","student","study","learning","homework","research","documentation","warning","alert","danger","exclamation mark"]
  },
  {
    "name": "book-audio",
    "categories": ["multimedia","text"],
    "tags": ["audiobook","reading","listening","sound","story","fiction","novel","information","knowledge","education","student","study","learning","research"]
  },
  {
    "name": "book-check",
    "categories": ["text","development","gaming"],
    "tags": ["read","booklet","magazine","leaflet","pamphlet","library","written","authored","published","informed","knowledgeable","educated","schooled","homework","examined","tested","marked","passed","graduated","studied","learned","lesson","researched","documented","revealed","blank","plain language","true","truth","verified","corrected","task","todo","done","completed","finished","ticked"]
  },
  {
    "name": "book-copy",
    "categories": ["development","text","gaming"],
    "tags": ["code","coding","version control","git","repository","clone","fork","duplicate","multiple","books","library","copies","copied","plagiarism","plagiarised","plagiarized","reading list","information","informed","knowledge","knowledgeable","knowledgable","education","high school","university","college","academy","student","study","learning","research","smart","intelligent","intellectual"]
  },
  {
    "name": "book-dashed",
    "categories": ["development"],
    "tags": ["code","coding","version control","git","repository","template","draft","script","screenplay","writing","writer","author","unwritten","unpublished","untold"]
  },
  {
    "name": "book-down",
    "categories": ["development"],
    "tags": ["code","coding","version control","git","repository","pull"]
  },
  {
    "name": "book-headphones",
    "categories": ["multimedia","text"],
    "tags": ["audiobook","reading","listening","sound","story","fiction","novel","information","knowledge","education","student","study","learning","research"]
  },
  {
    "name": "book-heart",
    "categories": ["social","text","gaming"],
    "tags": ["diary","romance","novel","journal","entry","entries","personal","private","secret","crush","like","love","emotion","feminine","girls","teens","teenager","therapy","theraputic","therapist","planner","organizer","organiser","notes","notepad","stationery","sketchbook","writing","written","reading","favorite","favourite","high school"]
  },
  {
    "name": "book-image",
    "categories": ["photography","text","multimedia","files","social","shopping","travel"],
    "tags": ["images","pictures","photos","album","collection","event","magazine","catalog","catalogue","brochure","browse","gallery"]
  },
  {
    "name": "book-key",
    "categories": ["development","security","gaming"],
    "tags": ["code","coding","version control","git","repository","private","public","secret","unlocked","hidden","revealed","knowledge","learning"]
  },
  {
    "name": "book-lock",
    "categories": ["development","security","gaming"],
    "tags": ["code","coding","version control","git","repository","private","secret","hidden","knowledge"]
  },
  {
    "name": "book-marked",
    "categories": ["text","development","gaming"],
    "tags": ["dictionary","reading","booklet","magazine","leaflet","pamphlet","tome","library","writing","written","writer","author","story","script","fiction","novel","information","knowledge","education","high school","university","college","academy","student","study","learning","homework","research","documentation","saved","later","future","reference","index","code","coding","version control","git","repository"]
  },
  {
    "name": "book-minus",
    "categories": ["development","text","gaming"],
    "tags": ["code","coding","version control","git","repository","remove","delete","censor","cancel","forbid","prohibit","ban","uneducated","re-educate","unlearn","downgrade"]
  },
  {
    "name": "book-open-check",
    "categories": ["text","development","gaming"],
    "tags": ["read","pages","booklet","magazine","leaflet","pamphlet","library","written","authored","published","informed","knowledgeable","educated","schooled","homework","examined","tested","marked","passed","graduated","studied","learned","lesson","researched","documented","revealed","blank","plain language","true","truth","verified","corrected","task","todo","done","completed","finished","ticked"]
  },
  {
    "name": "book-open-text",
    "categories": ["text","development"],
    "tags": ["reading","pages","booklet","magazine","leaflet","pamphlet","library","writing","written","writer","author","story","script","fiction","novel","information","knowledge","education","high school","university","college","academy","student","study","learning","homework","research","documentation","revealed"]
  },
  {
    "name": "book-open",
    "categories": ["text","development","gaming"],
    "tags": ["reading","pages","booklet","magazine","leaflet","pamphlet","library","writing","written","writer","author","story","script","screenplay","fiction","novel","information","knowledge","education","high school","university","college","academy","student","study","learning","homework","research","documentation","revealed","blank","plain"]
  },
  {
    "name": "book-plus",
    "categories": ["development","text","gaming"],
    "tags": ["code","coding","version control","git","repository","remove","delete","read","write","author","publish","inform","graduate","re-educate","study","learn","research","knowledge","improve","upgrade","level up"]
  },
  {
    "name": "book-search",
    "categories": ["text","development","gaming"],
    "tags": ["reading","library","study","education","research","knowledge","discover","browsing","lookup","finding","scanning"]
  },
  {
    "name": "book-text",
    "categories": ["text","gaming"],
    "tags": ["reading","booklet","magazine","leaflet","pamphlet","tome","library","writing","written","writer","author","story","script","fiction","novel","information","knowledge","education","high school","university","college","academy","student","study","learning","homework","research","documentation"]
  },
  {
    "name": "book-type",
    "categories": ["text","design","gaming"],
    "tags": ["thesaurus","synonym","reading","booklet","magazine","leaflet","pamphlet","tome","library","writing","written","writer","author","story","script","fiction","novel","information","knowledge","education","high school","university","college","academy","student","study","learning","homework","research","language","translate","typography","fonts","collection"]
  },
  {
    "name": "book-up-2",
    "categories": ["development"],
    "tags": ["code","coding","version control","git","repository","push","force"]
  },
  {
    "name": "book-up",
    "categories": ["development"],
    "tags": ["code","coding","version control","git","repository","push"]
  },
  {
    "name": "book-user",
    "categories": ["account","connectivity","communication","social"],
    "tags": ["person","people","family","friends","acquaintances","contacts","details","addresses","phone numbers","directory","listing","networking"]
  },
  {
    "name": "book-x",
    "categories": ["text","gaming"],
    "tags": ["code","coding","version control","git","repository","remove","delete","reading","misinformation","disinformation","misinformed","charlatan","sophistry","false","lies","untruth","propaganda","censored","cancelled","forbidden","prohibited","banned","uneducated","re-education","unlearn"]
  },
  {
    "name": "book",
    "categories": ["text","development","gaming"],
    "tags": ["reading","paperback","booklet","magazine","leaflet","pamphlet","tome","library","writing","written","writer","author","story","script","fiction","novel","information","knowledge","education","high school","university","college","academy","student","study","learning","homework","research","documentation"]
  },
  {
    "name": "bookmark-check",
    "categories": ["account"],
    "tags": ["read","finished","complete","clip","marker","tag","task","todo"]
  },
  {
    "name": "bookmark-minus",
    "categories": ["account"],
    "tags": ["delete","remove"]
  },
  {
    "name": "bookmark-plus",
    "categories": ["account"],
    "tags": ["add"]
  },
  {
    "name": "bookmark-x",
    "categories": ["account"],
    "tags": ["read","clip","marker","tag","cancel","close","delete","remove","clear"]
  },
  {
    "name": "bookmark",
    "categories": ["account"],
    "tags": ["save","favorite","mark","label","attachment","file","stick","pin","read","clip","marker","tag"]
  },
  {
    "name": "boom-box",
    "categories": ["devices","multimedia","social"],
    "tags": ["radio","speakers","audio","music","sound","broadcast","live","frequency"]
  },
  {
    "name": "bot-message-square",
    "categories": ["development","social"],
    "tags": ["robot","ai","chat","assistant"]
  },
  {
    "name": "bot-off",
    "categories": ["development","social"],
    "tags": ["robot","ai","chat","assistant"]
  },
  {
    "name": "bot",
    "categories": ["development","social"],
    "tags": ["robot","ai","chat","assistant"]
  },
  {
    "name": "bottle-wine",
    "categories": ["food-beverage"],
    "tags": ["alcohol","drink","glass","goblet","chalice","vineyard","winery","red","white","rose","dry","sparkling","bar","party","nightclub","nightlife","sommelier","restaurant","dinner","meal"]
  },
  {
    "name": "bow-arrow",
    "categories": ["gaming","tools"],
    "tags": ["archer","archery","game","war","weapon"]
  },
  {
    "name": "box",
    "categories": ["shapes","gaming","development","math"],
    "tags": ["cube","package","container","storage","geometry","3d","isometric"]
  },
  {
    "name": "boxes",
    "categories": ["shapes","gaming","development"],
    "tags": ["cubes","packages","parts","group","units","collection","cluster","geometry"]
  },
  {
    "name": "braces",
    "categories": ["development","files"],
    "tags": ["json","code","token","curly brackets","data","{","}"]
  },
  {
    "name": "brackets",
    "categories": ["development","files"],
    "tags": ["code","token","array","list","square","[","]"]
  },
  {
    "name": "brain-circuit",
    "categories": ["science","development"],
    "tags": ["mind","intellect","artificial intelligence","ai","deep learning","machine learning","computing"]
  },
  {
    "name": "brain-cog",
    "categories": ["science","development"],
    "tags": ["mind","intellect","artificial intelligence","ai","deep learning","machine learning","computing"]
  },
  {
    "name": "brain",
    "categories": ["medical","science"],
    "tags": ["medical","mind","mental","intellect","cerebral","consciousness","genius","artificial intelligence","ai","think","thought","insight","intelligent","smart"]
  },
  {
    "name": "brick-wall-fire",
    "categories": ["security","home","connectivity"],
    "tags": ["firewall","security","bricks","mortar","cement","materials","construction","builder","labourer","quantity surveyor","blocks","stone","campfire","camping","wilderness","outdoors","lit","warmth","wood","twigs","sticks"]
  },
  {
    "name": "brick-wall-shield",
    "categories": ["security","home","connectivity"],
    "tags": ["firewall","security","bricks","mortar","cement","materials","construction","builder","labourer","quantity surveyor","blocks","stone","cybersecurity","secure","safety","protection","guardian","armored","armoured","defense","defence","defender","block","threat","prevention","antivirus","vigilance","vigilant","detection","scan","find","strength","strong","tough","invincible","invincibility","invulnerable","undamaged","audit","admin","verification","crest","bravery","knight","foot soldier","infantry","trooper","pawn","battle","war","military","army","cadet","scout"]
  },
  {
    "name": "brick-wall",
    "categories": ["buildings","home"],
    "tags": ["bricks","mortar","cement","materials","construction","builder","labourer","quantity surveyor","blocks","stone"]
  },
  {
    "name": "briefcase-business",
    "categories": ["transportation"],
    "tags": ["work","bag","baggage","folder","portfolio"]
  },
  {
    "name": "briefcase-conveyor-belt",
    "categories": ["travel","transportation"],
    "tags": ["baggage","luggage","travel","suitcase","conveyor","carousel"]
  },
  {
    "name": "briefcase-medical",
    "categories": ["medical","transportation"],
    "tags": ["doctor","medicine","first aid"]
  },
  {
    "name": "briefcase",
    "categories": ["transportation"],
    "tags": ["work","bag","baggage","folder"]
  },
  {
    "name": "bring-to-front",
    "categories": ["design","layout"],
    "tags": ["bring","send","move","over","forward","front","overlap","layer","order"]
  },
  {
    "name": "brush-cleaning",
    "categories": ["home","tools","design"],
    "tags": ["cleaning","utensil","housekeeping","tool","sweeping","scrubbing","hygiene","maintenance","household","cleaner","chores","equipment","sanitation","bristles","handle","home care","sanitize","purify","wash","disinfect","sterilize","scrub","polish","decontaminate","wipe","spotless","remove","empty","erase","purge","eliminate"]
  },
  {
    "name": "brush",
    "categories": ["text","design","tools"],
    "tags": ["clean","sweep","refactor","remove","draw","paint","color","artist"]
  },
  {
    "name": "bubbles",
    "categories": ["weather"],
    "tags": ["water","cleaning","soap","bath","hygiene","freshness","wash","foam","cleanliness","shampoo","purity","splash","lightness","airy","relaxation","spa","bubbly","fluid","floating","drop"]
  },
  {
    "name": "bug-off",
    "categories": ["development","animals"],
    "tags": ["issue","fixed","resolved","testing","debug","code","insect","kill","exterminate","pest control"]
  },
  {
    "name": "bug-play",
    "categories": ["development","animals"],
    "tags": ["issue","testing","debug","reproduce","code","insect"]
  },
  {
    "name": "bug",
    "categories": ["development","animals"],
    "tags": ["issue","error","defect","testing","troubleshoot","problem","report","debug","code","insect","beetle"]
  },
  {
    "name": "building-2",
    "categories": ["account","buildings"],
    "tags": ["business","company","enterprise","skyscraper","organisation","organization","city"]
  },
  {
    "name": "building",
    "categories": ["account","buildings"],
    "tags": ["organisation","organization"]
  },
  {
    "name": "bus-front",
    "categories": ["transportation"],
    "tags": ["coach","vehicle","trip","road"]
  },
  {
    "name": "bus",
    "categories": ["transportation"],
    "tags": ["bus","vehicle","transport","trip"]
  },
  {
    "name": "cable-car",
    "categories": ["transportation","travel"],
    "tags": ["ski lift","winter holiday","alpine","resort","mountains"]
  },
  {
    "name": "cable",
    "categories": ["connectivity","devices","multimedia"],
    "tags": ["cord","wire","connector","connection","link","signal","console","computer","equipment","electricity","energy","electronics","recharging","charger","power","supply","disconnected","unplugged","plugs","interface","input","output","audio video","av","rca","scart","tv","television","optical"]
  },
  {
    "name": "cake-slice",
    "categories": ["food-beverage","social"],
    "tags": ["birthday","birthdate","celebration","party","surprise","gateaux","dessert","candles","wish","fondant","icing sugar","sweet","baking"]
  },
  {
    "name": "cake",
    "categories": ["food-beverage","social","account"],
    "tags": ["birthday","birthdate","celebration","party","surprise","gateaux","dessert","fondant","icing sugar","sweet","baking"]
  },
  {
    "name": "calculator",
    "categories": ["math","devices"],
    "tags": ["count","calculating machine"]
  },
  {
    "name": "calendar-1",
    "categories": ["time"],
    "tags": ["date","month","year","event","single","singular","once","1","first"]
  },
  {
    "name": "calendar-arrow-down",
    "categories": ["time"],
    "tags": ["date","month","year","event","sort","order","ascending","descending","increasing","decreasing","rising","falling"]
  },
  {
    "name": "calendar-arrow-up",
    "categories": ["time"],
    "tags": ["date","month","year","event","sort","order","ascending","descending","increasing","decreasing","rising","falling"]
  },
  {
    "name": "calendar-check-2",
    "categories": ["time"],
    "tags": ["date","day","month","year","event","confirm","subscribe","schedule","done","todo","tick","complete","task"]
  },
  {
    "name": "calendar-check",
    "categories": ["time"],
    "tags": ["date","day","month","year","event","confirm","subscribe","schedule","done","todo","tick","complete","task"]
  },
  {
    "name": "calendar-clock",
    "categories": ["time"],
    "tags": ["date","day","month","year","event","clock","hour"]
  },
  {
    "name": "calendar-cog",
    "categories": ["time"],
    "tags": ["date","day","month","year","events","settings","gear","cog"]
  },
  {
    "name": "calendar-days",
    "categories": ["time"],
    "tags": ["date","month","year","event"]
  },
  {
    "name": "calendar-fold",
    "categories": ["time","files"],
    "tags": ["date","month","year","event","birthday","birthdate","ics"]
  },
  {
    "name": "calendar-heart",
    "categories": ["time"],
    "tags": ["date","month","year","event","heart","favourite","subscribe","valentines day"]
  },
  {
    "name": "calendar-minus-2",
    "categories": ["time"],
    "tags": ["date","day","month","year","event","delete","remove"]
  },
  {
    "name": "calendar-minus",
    "categories": ["time"],
    "tags": ["date","day","month","year","event","delete","remove"]
  },
  {
    "name": "calendar-off",
    "categories": ["time"],
    "tags": ["date","day","month","year","event","delete","remove"]
  },
  {
    "name": "calendar-plus-2",
    "categories": ["time"],
    "tags": ["date","day","month","year","event","add","subscribe","create","new"]
  },
  {
    "name": "calendar-plus",
    "categories": ["time"],
    "tags": ["date","day","month","year","event","add","subscribe","create","new"]
  },
  {
    "name": "calendar-range",
    "categories": ["time"],
    "tags": ["date","day","month","year","event","range","period"]
  },
  {
    "name": "calendar-search",
    "categories": ["time"],
    "tags": ["date","day","month","year","events","search","lens"]
  },
  {
    "name": "calendar-sync",
    "categories": ["arrows","time"],
    "tags": ["repeat","refresh","reconnect","transfer","backup","date","month","year","event","subscribe","recurring","schedule","reminder","automatic","auto"]
  },
  {
    "name": "calendar-x-2",
    "categories": ["time"],
    "tags": ["date","day","month","year","event","remove"]
  },
  {
    "name": "calendar-x",
    "categories": ["time"],
    "tags": ["date","day","month","year","event","remove","busy"]
  },
  {
    "name": "calendar",
    "categories": ["time"],
    "tags": ["date","month","year","event","birthday","birthdate"]
  },
  {
    "name": "calendars",
    "categories": ["time"],
    "tags": ["date","month","year","event","dates","months","years","events"]
  },
  {
    "name": "camera-off",
    "categories": ["photography","devices","communication"],
    "tags": ["photo","webcam","video"]
  },
  {
    "name": "camera",
    "categories": ["photography","devices","communication"],
    "tags": ["photography","lens","focus","capture","shot","visual","image","device","equipment","photo","webcam","video"]
  },
  {
    "name": "candy-cane",
    "categories": ["food-beverage"],
    "tags": ["sugar","food","sweet","christmas","xmas"]
  },
  {
    "name": "candy-off",
    "categories": ["food-beverage"],
    "tags": ["sugar free","food","sweet","allergy","intolerance","diet"]
  },
  {
    "name": "candy",
    "categories": ["food-beverage"],
    "tags": ["sugar","food","sweet"]
  },
  {
    "name": "cannabis-off",
    "categories": ["nature"],
    "tags": ["cannabis","weed","leaf"]
  },
  {
    "name": "cannabis",
    "categories": ["nature"],
    "tags": ["cannabis","weed","leaf"]
  },
  {
    "name": "captions-off",
    "categories": ["multimedia"],
    "tags": ["closed captions","subtitles","subhead","transcription","transcribe","dialogue","accessibility"]
  },
  {
    "name": "captions",
    "categories": ["multimedia"],
    "tags": ["closed captions","subtitles","subhead","transcription","transcribe","dialogue","accessibility"]
  },
  {
    "name": "car-front",
    "categories": ["transportation"],
    "tags": ["vehicle","drive","trip","journey"]
  },
  {
    "name": "car-taxi-front",
    "categories": ["transportation"],
    "tags": ["cab","vehicle","drive","trip","journey"]
  },
  {
    "name": "car",
    "categories": ["transportation"],
    "tags": ["vehicle","drive","trip","journey"]
  },
  {
    "name": "caravan",
    "categories": ["transportation","travel","nature"],
    "tags": ["trailer","tow","camping","campsite","mobile home","holiday","nomadic","wilderness","outdoors"]
  },
  {
    "name": "card-sim",
    "categories": ["connectivity","communication","multimedia","devices"],
    "tags": ["cellphone","smartphone","mobile","network","cellular","service","provider","signal","coverage","disk","data","format","storage","flash","digital","contacts","phone book","contractual","circuit board","chip"]
  },
  {
    "name": "carrot",
    "categories": ["food-beverage"],
    "tags": ["vegetable","food","eat"]
  },
  {
    "name": "case-lower",
    "categories": ["text","development"],
    "tags": ["text","letters","characters","font","typography"]
  },
  {
    "name": "case-sensitive",
    "categories": ["text"],
    "tags": ["text","letters","characters","font","typography"]
  },
  {
    "name": "case-upper",
    "categories": ["text","development"],
    "tags": ["text","letters","characters","font","typography"]
  },
  {
    "name": "cassette-tape",
    "categories": ["connectivity","devices","multimedia","communication","files"],
    "tags": ["audio","music","recording","play"]
  },
  {
    "name": "cast",
    "categories": ["devices","connectivity"],
    "tags": ["chromecast","airplay","screen"]
  },
  {
    "name": "castle",
    "categories": ["buildings","gaming","navigation"],
    "tags": ["fortress","stronghold","palace","chateau","building"]
  },
  {
    "name": "cat",
    "categories": ["animals"],
    "tags": ["animal","pet","kitten","feline"]
  },
  {
    "name": "cctv",
    "categories": ["security","devices","communication","connectivity","photography"],
    "tags": ["camera","surveillance","recording","film","videotape","crime","watching"]
  },
  {
    "name": "chart-area",
    "categories": ["charts"],
    "tags": ["statistics","analytics","diagram","graph","area"]
  },
  {
    "name": "chart-bar-big",
    "categories": ["charts"],
    "tags": ["statistics","analytics","diagram","graph"]
  },
  {
    "name": "chart-bar-decreasing",
    "categories": ["charts"],
    "tags": ["statistics","analytics","diagram","graph","trending down"]
  },
  {
    "name": "chart-bar-increasing",
    "categories": ["charts"],
    "tags": ["statistics","analytics","diagram","graph","trending up"]
  },
  {
    "name": "chart-bar-stacked",
    "categories": ["charts"],
    "tags": ["statistics","analytics","diagram","graph","multivariate","categorical","comparison"]
  },
  {
    "name": "chart-bar",
    "categories": ["charts"],
    "tags": ["statistics","analytics","diagram","graph"]
  },
  {
    "name": "chart-candlestick",
    "categories": ["charts","finance"],
    "tags": ["trading","trader","financial","markets","portfolio","assets","prices","value","valuation","commodities","currencies","currency","stocks","exchange","hedge fund","statistics","analytics","diagram","graph"]
  },
  {
    "name": "chart-column-big",
    "categories": ["charts"],
    "tags": ["statistics","analytics","diagram","graph"]
  },
  {
    "name": "chart-column-decreasing",
    "categories": ["charts"],
    "tags": ["statistics","analytics","diagram","graph","trending down"]
  },
  {
    "name": "chart-column-increasing",
    "categories": ["charts"],
    "tags": ["statistics","analytics","diagram","graph","trending up"]
  },
  {
    "name": "chart-column-stacked",
    "categories": ["charts"],
    "tags": ["statistics","analytics","diagram","graph","multivariate","categorical","comparison"]
  },
  {
    "name": "chart-column",
    "categories": ["charts"],
    "tags": ["statistics","analytics","diagram","graph"]
  },
  {
    "name": "chart-gantt",
    "categories": ["charts"],
    "tags": ["diagram","graph","timeline","planning"]
  },
  {
    "name": "chart-line",
    "categories": ["charts"],
    "tags": ["statistics","analytics","diagram","graph"]
  },
  {
    "name": "chart-network",
    "categories": ["charts"],
    "tags": ["statistics","analytics","diagram","graph","topology","cluster","web","nodes","connections","edges"]
  },
  {
    "name": "chart-no-axes-column-decreasing",
    "categories": ["charts"],
    "tags": ["statistics","analytics","diagram","graph","trending down"]
  },
  {
    "name": "chart-no-axes-column-increasing",
    "categories": ["charts"],
    "tags": ["statistics","analytics","diagram","graph","trending up"]
  },
  {
    "name": "chart-no-axes-column",
    "categories": ["charts"],
    "tags": ["statistics","analytics","diagram","graph"]
  },
  {
    "name": "chart-no-axes-combined",
    "categories": ["charts"],
    "tags": ["statistics","analytics","diagram","graph","trending up"]
  },
  {
    "name": "chart-no-axes-gantt",
    "categories": ["charts","time","development","design"],
    "tags": ["projects","manage","overview","roadmap","plan","intentions","timeline","deadline","date","event","range","period","productivity","work","agile","code","coding"]
  },
  {
    "name": "chart-pie",
    "categories": ["charts","files"],
    "tags": ["statistics","analytics","diagram","presentation"]
  },
  {
    "name": "chart-scatter",
    "categories": ["charts"],
    "tags": ["statistics","analytics","diagram","graph"]
  },
  {
    "name": "chart-spline",
    "categories": ["charts"],
    "tags": ["statistics","analytics","diagram","graph","curve","continuous","smooth","polynomial","quadratic","function","interpolation"]
  },
  {
    "name": "check-check",
    "categories": ["notifications"],
    "tags": ["done","received","double","todo","tick","complete","task"]
  },
  {
    "name": "check-line",
    "categories": ["notifications"],
    "tags": ["done","todo","tick","complete","task"]
  },
  {
    "name": "check",
    "categories": ["notifications"],
    "tags": ["done","todo","tick","complete","task"]
  },
  {
    "name": "chef-hat",
    "categories": ["food-beverage"],
    "tags": ["cooking","food","kitchen","restaurant"]
  },
  {
    "name": "cherry",
    "categories": ["food-beverage"],
    "tags": ["fruit","food"]
  },
  {
    "name": "chess-bishop",
    "categories": ["gaming","emoji"],
    "tags": ["mitre","miter","piece","board game","religion"]
  },
  {
    "name": "chess-king",
    "categories": ["gaming","emoji"],
    "tags": ["ruler","crown","piece","board game","stalemate"]
  },
  {
    "name": "chess-knight",
    "categories": ["gaming","emoji"],
    "tags": ["piece","horse","board game"]
  },
  {
    "name": "chess-pawn",
    "categories": ["gaming","emoji"],
    "tags": ["piece","board game"]
  },
  {
    "name": "chess-queen",
    "categories": ["gaming","emoji"],
    "tags": ["ruler","crown","piece","board game","stalemate"]
  },
  {
    "name": "chess-rook",
    "categories": ["gaming","emoji"],
    "tags": ["castle","piece","board game"]
  },
  {
    "name": "chevron-down",
    "categories": ["arrows","gaming"],
    "tags": ["backwards","reverse","slow","dropdown"]
  },
  {
    "name": "chevron-first",
    "categories": ["arrows","multimedia"],
    "tags": ["previous","music"]
  },
  {
    "name": "chevron-last",
    "categories": ["arrows","multimedia"],
    "tags": ["skip","next","music"]
  },
  {
    "name": "chevron-left",
    "categories": ["arrows"],
    "tags": ["back","previous","less than","fewer","menu","<"]
  },
  {
    "name": "chevron-right",
    "categories": ["arrows","math","development"],
    "tags": ["forward","next","more than","greater","menu","code","coding","command line","terminal","prompt","shell",">"]
  },
  {
    "name": "chevron-up",
    "categories": ["arrows","math","gaming"],
    "tags": ["caret","keyboard","mac","control","ctrl","superscript","exponential","power","ahead","fast","^","dropdown"]
  },
  {
    "name": "chevrons-down-up",
    "categories": ["arrows"],
    "tags": ["collapse","fold","vertical"]
  },
  {
    "name": "chevrons-down",
    "categories": ["arrows","gaming"],
    "tags": ["backwards","reverse","slower"]
  },
  {
    "name": "chevrons-left-right-ellipsis",
    "categories": ["communication","devices","multimedia","gaming"],
    "tags": ["internet","network","connection","cable","lan","port","router","switch","hub","modem","web","online","networking","communication","socket","plug","slot","controller","connector","interface","console","signal","data","input","output"]
  },
  {
    "name": "chevrons-left-right",
    "categories": ["arrows"],
    "tags": ["expand","horizontal","unfold"]
  },
  {
    "name": "chevrons-left",
    "categories": ["arrows","gaming"],
    "tags": ["turn","corner"]
  },
  {
    "name": "chevrons-right-left",
    "categories": ["arrows"],
    "tags": ["collapse","fold","horizontal"]
  },
  {
    "name": "chevrons-right",
    "categories": ["arrows","gaming"],
    "tags": ["turn","corner"]
  },
  {
    "name": "chevrons-up-down",
    "categories": ["arrows"],
    "tags": ["expand","unfold","vertical"]
  },
  {
    "name": "chevrons-up",
    "categories": ["arrows","gaming"],
    "tags": ["forward","ahead","faster","speed","boost"]
  },
  {
    "name": "chromium",
    "categories": ["brands"],
    "tags": ["browser","logo"]
  },
  {
    "name": "church",
    "categories": ["buildings","navigation"],
    "tags": ["temple","building"]
  },
  {
    "name": "cigarette-off",
    "categories": ["travel","transportation","medical"],
    "tags": ["smoking","no-smoking"]
  },
  {
    "name": "cigarette",
    "categories": ["travel","transportation","medical"],
    "tags": ["smoking"]
  },
  {
    "name": "circle-alert",
    "categories": ["notifications"],
    "tags": ["warning","alert","danger","exclamation mark"]
  },
  {
    "name": "circle-arrow-down",
    "categories": ["arrows","gaming"],
    "tags": ["backwards","reverse","direction","south","sign","button"]
  },
  {
    "name": "circle-arrow-left",
    "categories": ["arrows","gaming"],
    "tags": ["previous","back","direction","west","sign","turn","button","<-"]
  },
  {
    "name": "circle-arrow-out-down-left",
    "categories": ["arrows"],
    "tags": ["outwards","direction","south-west","diagonal"]
  },
  {
    "name": "circle-arrow-out-down-right",
    "categories": ["arrows"],
    "tags": ["outwards","direction","south-east","diagonal"]
  },
  {
    "name": "circle-arrow-out-up-left",
    "categories": ["arrows","development"],
    "tags": ["outwards","direction","north-west","diagonal","keyboard","button","escape"]
  },
  {
    "name": "circle-arrow-out-up-right",
    "categories": ["arrows"],
    "tags": ["outwards","direction","north-east","diagonal"]
  },
  {
    "name": "circle-arrow-right",
    "categories": ["arrows","gaming"],
    "tags": ["next","forward","direction","east","sign","turn","button","->"]
  },
  {
    "name": "circle-arrow-up",
    "categories": ["arrows","gaming"],
    "tags": ["forward","direction","north","sign","button"]
  },
  {
    "name": "circle-check-big",
    "categories": ["notifications"],
    "tags": ["done","todo","tick","complete","task"]
  },
  {
    "name": "circle-check",
    "categories": ["notifications"],
    "tags": ["done","todo","tick","complete","task"]
  },
  {
    "name": "circle-chevron-down",
    "categories": ["arrows"],
    "tags": ["back","menu"]
  },
  {
    "name": "circle-chevron-left",
    "categories": ["arrows"],
    "tags": ["back","previous","less than","fewer","menu","<"]
  },
  {
    "name": "circle-chevron-right",
    "categories": ["arrows"],
    "tags": ["back","more than","greater","menu",">"]
  },
  {
    "name": "circle-chevron-up",
    "categories": ["arrows"],
    "tags": ["caret","ahead","menu","^"]
  },
  {
    "name": "circle-dashed",
    "categories": ["development","shapes"],
    "tags": ["pending","dot","progress","issue","draft","code","coding","version control"]
  },
  {
    "name": "circle-divide",
    "categories": ["math"],
    "tags": ["calculate","math","÷","/"]
  },
  {
    "name": "circle-dollar-sign",
    "categories": ["finance"],
    "tags": ["monetization","marketing","currency","money","payment"]
  },
  {
    "name": "circle-dot-dashed",
    "categories": ["development","shapes"],
    "tags": ["pending","dot","progress","issue","draft","code","coding","version control"]
  },
  {
    "name": "circle-dot",
    "categories": ["development","shapes"],
    "tags": ["pending","dot","progress","issue","code","coding","version control","choices","multiple choice","choose"]
  },
  {
    "name": "circle-ellipsis",
    "categories": ["layout","development"],
    "tags": ["ellipsis","et cetera","etc","loader","loading","progress","pending","throbber","menu","options","operator","code","spread","rest","more","further","extra","overflow","dots","…","..."]
  },
  {
    "name": "circle-equal",
    "categories": ["math"],
    "tags": ["calculate","shape","="]
  },
  {
    "name": "circle-fading-arrow-up",
    "categories": ["arrows","development"],
    "tags": ["north","up","upgrade","improve","circle","button"]
  },
  {
    "name": "circle-fading-plus",
    "categories": ["communication","social"],
    "tags": ["stories","social media","instagram","facebook","meta","snapchat","sharing","content"]
  },
  {
    "name": "circle-gauge",
    "categories": ["transportation","sports","science"],
    "tags": ["dashboard","dial","meter","speed","pressure","measure","level"]
  },
  {
    "name": "circle-minus",
    "categories": ["math"],
    "tags": ["subtract","remove","decrease","reduce","calculate","line","operator","code","coding","minimum","downgrade","-"]
  },
  {
    "name": "circle-off",
    "categories": ["shapes"],
    "tags": ["diameter","zero","Ø","nothing","null","void","cancel","ban","no","stop","forbidden","prohibited","error","incorrect","mistake","wrong","failure"]
  },
  {
    "name": "circle-parking-off",
    "categories": ["transportation","navigation"],
    "tags": ["parking lot","car park","no parking"]
  },
  {
    "name": "circle-parking",
    "categories": ["transportation","navigation"],
    "tags": ["parking lot","car park"]
  },
  {
    "name": "circle-pause",
    "categories": ["multimedia"],
    "tags": ["music","audio","stop"]
  },
  {
    "name": "circle-percent",
    "categories": ["social","finance","shopping","math"],
    "tags": ["verified","unverified","sale","discount","offer","marketing","sticker","price tag"]
  },
  {
    "name": "circle-pile",
    "categories": ["shapes"],
    "tags": ["off","zero","record","shape","circle-pile","circle","pile","stack","layer","structure","form","group","collection","stock","inventory","materials","warehouse"]
  },
  {
    "name": "circle-play",
    "categories": ["multimedia"],
    "tags": ["music","start","run"]
  },
  {
    "name": "circle-plus",
    "categories": ["math","development","cursors","gaming"],
    "tags": ["add","new","increase","increment","positive","calculate","crosshair","aim","target","scope","sight","reticule","maximum","upgrade","extra","operator","join","concatenate","code","coding","+"]
  },
  {
    "name": "circle-pound-sterling",
    "categories": ["finance"],
    "tags": ["monetization","coin","penny","marketing","currency","money","payment","british","gbp","£"]
  },
  {
    "name": "circle-power",
    "categories": ["connectivity"],
    "tags": ["on","off","device","switch","toggle","binary","boolean","reboot","restart","button","keyboard","troubleshoot"]
  },
  {
    "name": "circle-question-mark",
    "categories": ["accessibility","text","notifications"],
    "tags": ["question mark"]
  },
  {
    "name": "circle-slash-2",
    "categories": ["shapes","math","development"],
    "tags": ["diameter","zero","ø","nothing","null","void","ban","math","divide","division","half","split","/","average","avg","mean","median","normal"]
  },
  {
    "name": "circle-slash",
    "categories": ["development","math"],
    "tags": ["diameter","zero","Ø","nothing","null","void","cancel","ban","no","stop","forbidden","prohibited","error","incorrect","mistake","wrong","failure","divide","division","or","/"]
  },
  {
    "name": "circle-small",
    "categories": ["shapes","medical"],
    "tags": ["shape","bullet","gender","genderless"]
  },
  {
    "name": "circle-star",
    "categories": ["sports","gaming"],
    "tags": ["badge","medal","honour","decoration","order","pin","laurel","trophy","medallion","insignia","bronze","silver","gold"]
  },
  {
    "name": "circle-stop",
    "categories": ["multimedia"],
    "tags": ["media","music"]
  },
  {
    "name": "circle-user-round",
    "categories": ["account"],
    "tags": ["person","account","contact"]
  },
  {
    "name": "circle-user",
    "categories": ["account"],
    "tags": ["person","account","contact"]
  },
  {
    "name": "circle-x",
    "categories": ["math","development"],
    "tags": ["cancel","close","delete","remove","times","clear","error","incorrect","wrong","mistake","failure","linter","multiply","multiplication"]
  },
  {
    "name": "circle",
    "categories": ["shapes"],
    "tags": ["off","zero","record","shape"]
  },
  {
    "name": "circuit-board",
    "categories": ["science","development"],
    "tags": ["computing","electricity","electronics"]
  },
  {
    "name": "citrus",
    "categories": ["food-beverage"],
    "tags": ["lemon","orange","grapefruit","fruit"]
  },
  {
    "name": "clapperboard",
    "categories": ["multimedia"],
    "tags": ["movie","film","video","camera","cinema","cut","action","television","tv","show","entertainment"]
  },
  {
    "name": "clipboard-check",
    "categories": ["text"],
    "tags": ["copied","pasted","done","todo","tick","complete","task"]
  },
  {
    "name": "clipboard-clock",
    "categories": ["time","text"],
    "tags": ["copy","paste","history","log","clock","time","watch","alarm","hour","minute","reminder","scheduled","deadline","pending","time tracking","timesheets","appointment","logbook"]
  },
  {
    "name": "clipboard-copy",
    "categories": ["text","arrows"],
    "tags": ["copy","paste"]
  },
  {
    "name": "clipboard-list",
    "categories": ["text"],
    "tags": ["copy","paste","tasks"]
  },
  {
    "name": "clipboard-minus",
    "categories": ["text","medical"],
    "tags": ["copy","delete","remove","erase","document","medical","report","doctor"]
  },
  {
    "name": "clipboard-paste",
    "categories": ["text","arrows"],
    "tags": ["copy","paste"]
  },
  {
    "name": "clipboard-pen-line",
    "categories": ["text"],
    "tags": ["paste"]
  },
  {
    "name": "clipboard-pen",
    "categories": ["text"],
    "tags": ["paste","signature"]
  },
  {
    "name": "clipboard-plus",
    "categories": ["text","medical"],
    "tags": ["copy","paste","add","create","new","document","medical","report","doctor"]
  },
  {
    "name": "clipboard-type",
    "categories": ["text"],
    "tags": ["paste","format","text"]
  },
  {
    "name": "clipboard-x",
    "categories": ["text"],
    "tags": ["copy","paste","discard","remove"]
  },
  {
    "name": "clipboard",
    "categories": ["text"],
    "tags": ["copy","paste"]
  },
  {
    "name": "clock-1",
    "categories": ["time"],
    "tags": ["time","watch","alarm"]
  },
  {
    "name": "clock-10",
    "categories": ["time"],
    "tags": ["time","watch","alarm"]
  },
  {
    "name": "clock-11",
    "categories": ["time"],
    "tags": ["time","watch","alarm"]
  },
  {
    "name": "clock-12",
    "categories": ["time"],
    "tags": ["time","watch","alarm","noon","midnight"]
  },
  {
    "name": "clock-2",
    "categories": ["time"],
    "tags": ["time","watch","alarm"]
  },
  {
    "name": "clock-3",
    "categories": ["time"],
    "tags": ["time","watch","alarm"]
  },
  {
    "name": "clock-4",
    "categories": ["time"],
    "tags": ["time","watch","alarm"]
  },
  {
    "name": "clock-5",
    "categories": ["time"],
    "tags": ["time","watch","alarm"]
  },
  {
    "name": "clock-6",
    "categories": ["time"],
    "tags": ["time","watch","alarm"]
  },
  {
    "name": "clock-7",
    "categories": ["time"],
    "tags": ["time","watch","alarm"]
  },
  {
    "name": "clock-8",
    "categories": ["time"],
    "tags": ["time","watch","alarm"]
  },
  {
    "name": "clock-9",
    "categories": ["time"],
    "tags": ["time","watch","alarm"]
  },
  {
    "name": "clock-alert",
    "categories": ["time"],
    "tags": ["time","watch","alarm","warning","wrong"]
  },
  {
    "name": "clock-arrow-down",
    "categories": ["time"],
    "tags": ["time","watch","alarm","sort","order","ascending","descending","increasing","decreasing","rising","falling"]
  },
  {
    "name": "clock-arrow-up",
    "categories": ["time"],
    "tags": ["time","watch","alarm","sort","order","ascending","descending","increasing","decreasing","rising","falling"]
  },
  {
    "name": "clock-check",
    "categories": ["time"],
    "tags": ["time","watch","alarm"]
  },
  {
    "name": "clock-fading",
    "categories": ["time"],
    "tags": ["time","watch","alarm"]
  },
  {
    "name": "clock-plus",
    "categories": ["time"],
    "tags": ["time","watch","alarm","add","create","new"]
  },
  {
    "name": "clock",
    "categories": ["time"],
    "tags": ["time","watch","alarm"]
  },
  {
    "name": "closed-caption",
    "categories": ["accessibility","multimedia"],
    "tags": ["tv","movie","video","closed captions","subtitles","subhead","transcription","transcribe","dialogue","accessibility"]
  },
  {
    "name": "cloud-alert",
    "categories": ["development"],
    "tags": ["weather","danger","warning","alert","error","sync","network","exclamation"]
  },
  {
    "name": "cloud-backup",
    "categories": ["arrows","files"],
    "tags": ["storage","memory","bytes","servers","backup","timemachine","rotate","synchronize","synchronise","refresh","reconnect","transfer","data","security","upload","save","remote","safety"]
  },
  {
    "name": "cloud-check",
    "categories": ["development"],
    "tags": ["sync","network","success","done","completed","saved","persisted"]
  },
  {
    "name": "cloud-cog",
    "categories": ["development"],
    "tags": ["computing","ai","cluster","network"]
  },
  {
    "name": "cloud-download",
    "categories": ["arrows","files"],
    "tags": ["import"]
  },
  {
    "name": "cloud-drizzle",
    "categories": ["weather"],
    "tags": ["weather","shower"]
  },
  {
    "name": "cloud-fog",
    "categories": ["weather"],
    "tags": ["weather","mist"]
  },
  {
    "name": "cloud-hail",
    "categories": ["weather"],
    "tags": ["weather","rainfall"]
  },
  {
    "name": "cloud-lightning",
    "categories": ["weather"],
    "tags": ["weather","bolt"]
  },
  {
    "name": "cloud-moon-rain",
    "categories": ["weather"],
    "tags": ["weather","partly","night","rainfall"]
  },
  {
    "name": "cloud-moon",
    "categories": ["weather"],
    "tags": ["weather","night"]
  },
  {
    "name": "cloud-off",
    "categories": ["connectivity","weather"],
    "tags": ["disconnect"]
  },
  {
    "name": "cloud-rain-wind",
    "categories": ["weather"],
    "tags": ["weather","rainfall"]
  },
  {
    "name": "cloud-rain",
    "categories": ["weather"],
    "tags": ["weather","rainfall"]
  },
  {
    "name": "cloud-snow",
    "categories": ["weather"],
    "tags": ["weather","blizzard"]
  },
  {
    "name": "cloud-sun-rain",
    "categories": ["weather"],
    "tags": ["weather","partly","rainfall"]
  },
  {
    "name": "cloud-sun",
    "categories": ["weather"],
    "tags": ["weather","partly"]
  },
  {
    "name": "cloud-sync",
    "categories": ["arrows","files"],
    "tags": ["synchronize","synchronise","refresh","reconnect","transfer","backup","storage","upload","download","connection","network","data"]
  },
  {
    "name": "cloud-upload",
    "categories": ["arrows","files"],
    "tags": ["file"]
  },
  {
    "name": "cloud",
    "categories": ["weather"],
    "tags": ["weather"]
  },
  {
    "name": "cloudy",
    "categories": ["weather"],
    "tags": ["weather","clouds"]
  },
  {
    "name": "clover",
    "categories": ["gaming"],
    "tags": ["leaf","luck","plant"]
  },
  {
    "name": "club",
    "categories": ["shapes","gaming"],
    "tags": ["shape","suit","playing","cards"]
  },
  {
    "name": "code-xml",
    "categories": ["text","development"],
    "tags": ["source","programming","html","xml"]
  },
  {
    "name": "code",
    "categories": ["text","development"],
    "tags": ["source","programming","html","xml"]
  },
  {
    "name": "codepen",
    "categories": ["brands","development"],
    "tags": ["logo"]
  },
  {
    "name": "codesandbox",
    "categories": ["brands","development"],
    "tags": ["logo"]
  },
  {
    "name": "coffee",
    "categories": ["food-beverage"],
    "tags": ["drink","cup","mug","tea","cafe","hot","beverage"]
  },
  {
    "name": "cog",
    "categories": ["account"],
    "tags": ["computing","settings","cog","edit","gear","preferences","controls","configuration","fixed","build","construction","parts"]
  },
  {
    "name": "coins",
    "categories": ["gaming"],
    "tags": ["money","cash","finance","gamble"]
  },
  {
    "name": "columns-2",
    "categories": ["layout","design","text"],
    "tags": ["lines","list","queue","preview","panel","parallel","series","split","vertical","horizontal","half","center","middle","even","sidebar","drawer","gutter","fold","reflow","typography","pagination","pages"]
  },
  {
    "name": "columns-3-cog",
    "categories": ["layout","design"],
    "tags": ["columns","settings","customize","table","grid","adjust","configuration","panel","layout"]
  },
  {
    "name": "columns-3",
    "categories": ["layout","design","text"],
    "tags": ["lines","list","queue","preview","parallel","series","split","vertical","horizontal","thirds","triple","center","middle","alignment","even","sidebars","drawers","gutters","fold","reflow","typography","pagination","pages"]
  },
  {
    "name": "columns-4",
    "categories": ["layout","design","text","security"],
    "tags": ["lines","list","queue","preview","parallel","series","split","vertical","horizontal","thirds","triple","center","middle","alignment","even","sidebars","drawers","gutters","fold","reflow","typography","pagination","pages","prison","jail","bars","sentence","police","cops","cell","crime","criminal","justice","law","enforcement","grill"]
  },
  {
    "name": "combine",
    "categories": ["development","files"],
    "tags": ["cubes","packages","parts","units","collection","cluster","combine","gather","merge"]
  },
  {
    "name": "command",
    "categories": ["development"],
    "tags": ["keyboard","key","mac","cmd","button"]
  },
  {
    "name": "compass",
    "categories": ["navigation","travel"],
    "tags": ["direction","north","east","south","west","safari","browser"]
  },
  {
    "name": "component",
    "categories": ["design","development"],
    "tags": ["design","element","group","module","part","symbol"]
  },
  {
    "name": "computer",
    "categories": ["devices","development","gaming"],
    "tags": ["pc","chassis","codespaces","github"]
  },
  {
    "name": "concierge-bell",
    "categories": ["travel"],
    "tags": ["reception","bell","porter"]
  },
  {
    "name": "cone",
    "categories": ["shapes","math"],
    "tags": ["conical","triangle","triangular","geometry","filter","funnel","hopper","spotlight","searchlight"]
  },
  {
    "name": "construction",
    "categories": ["development"],
    "tags": ["roadwork","maintenance","blockade","barricade"]
  },
  {
    "name": "contact-round",
    "categories": ["account","connectivity","communication","social"],
    "tags": ["user","person","family","friend","acquaintance","listing","networking"]
  },
  {
    "name": "contact",
    "categories": ["account","connectivity","communication","social"],
    "tags": ["user","person","family","friend","acquaintance","listing","networking"]
  },
  {
    "name": "container",
    "categories": ["development","transportation","mail"],
    "tags": ["storage","shipping","freight","supply chain","docker","environment","devops","code","coding"]
  },
  {
    "name": "contrast",
    "categories": ["photography","accessibility","design"],
    "tags": ["display","accessibility"]
  },
  {
    "name": "cookie",
    "categories": ["account","food-beverage"],
    "tags": ["biscuit","privacy","legal","food"]
  },
  {
    "name": "cooking-pot",
    "categories": ["food-beverage","home"],
    "tags": ["pod","cooking","recipe","food","kitchen","chef","restaurant","dinner","lunch","breakfast","meal","eat"]
  },
  {
    "name": "copy-check",
    "categories": ["text","notifications"],
    "tags": ["clone","duplicate","done","multiple"]
  },
  {
    "name": "copy-minus",
    "categories": ["text","math"],
    "tags": ["clone","duplicate","remove","delete","collapse","subtract","multiple","-"]
  },
  {
    "name": "copy-plus",
    "categories": ["text","math"],
    "tags": ["clone","duplicate","add","multiple","expand","+"]
  },
  {
    "name": "copy-slash",
    "categories": ["text","development","math"],
    "tags": ["clone","duplicate","cancel","ban","no","stop","forbidden","prohibited","error","multiple","divide","division","split","or","/"]
  },
  {
    "name": "copy-x",
    "categories": ["notifications","math"],
    "tags": ["cancel","close","delete","remove","clear","multiple","multiply","multiplication","times"]
  },
  {
    "name": "copy",
    "categories": ["text"],
    "tags": ["clone","duplicate","multiple"]
  },
  {
    "name": "copyleft",
    "categories": ["text"],
    "tags": ["licence"]
  },
  {
    "name": "copyright",
    "categories": ["text"],
    "tags": ["licence","license"]
  },
  {
    "name": "corner-down-left",
    "categories": ["arrows"],
    "tags": ["arrow","return"]
  },
  {
    "name": "corner-down-right",
    "categories": ["arrows","text","development"],
    "tags": ["arrow","indent","tab"]
  },
  {
    "name": "corner-left-down",
    "categories": ["arrows"],
    "tags": ["arrow"]
  },
  {
    "name": "corner-left-up",
    "categories": ["arrows"],
    "tags": ["arrow"]
  },
  {
    "name": "corner-right-down",
    "categories": ["arrows"],
    "tags": ["arrow"]
  },
  {
    "name": "corner-right-up",
    "categories": ["arrows"],
    "tags": ["arrow"]
  },
  {
    "name": "corner-up-left",
    "categories": ["arrows"],
    "tags": ["arrow"]
  },
  {
    "name": "corner-up-right",
    "categories": ["arrows"],
    "tags": ["arrow"]
  },
  {
    "name": "cpu",
    "categories": ["devices"],
    "tags": ["processor","cores","technology","computer","chip","circuit","memory","ram","specs","gigahertz","ghz"]
  },
  {
    "name": "creative-commons",
    "categories": ["text"],
    "tags": ["licence","license"]
  },
  {
    "name": "credit-card",
    "categories": ["account","finance"],
    "tags": ["bank","purchase","payment","cc"]
  },
  {
    "name": "croissant",
    "categories": ["food-beverage"],
    "tags": ["bakery","cooking","food","pastry"]
  },
  {
    "name": "crop",
    "categories": ["photography","design"],
    "tags": ["photo","image"]
  },
  {
    "name": "cross",
    "categories": ["shapes"],
    "tags": ["healthcare","first aid"]
  },
  {
    "name": "crosshair",
    "categories": ["photography"],
    "tags": ["aim","target"]
  },
  {
    "name": "crown",
    "categories": ["gaming"],
    "tags": ["diadem","tiara","circlet","corona","king","ruler","winner","favourite"]
  },
  {
    "name": "cuboid",
    "categories": ["shapes","math","buildings"],
    "tags": ["brick","block","container","storage","geometry","rectangular","hexahedron"]
  },
  {
    "name": "cup-soda",
    "categories": ["food-beverage"],
    "tags": ["beverage","cup","drink","soda","straw","water"]
  },
  {
    "name": "currency",
    "categories": ["finance"],
    "tags": ["finance","money"]
  },
  {
    "name": "cylinder",
    "categories": ["shapes","design","math"],
    "tags": ["shape","elliptical","geometry","container","storage","tin","pot"]
  },
  {
    "name": "dam",
    "categories": ["buildings","sustainability","navigation"],
    "tags": ["electricity","energy","water"]
  },
  {
    "name": "database-backup",
    "categories": ["devices","arrows","design","development","photography"],
    "tags": ["storage","memory","bytes","servers","backup","timemachine","rotate","arrow","left"]
  },
  {
    "name": "database-zap",
    "categories": ["devices","development"],
    "tags": ["cache busting","storage","memory","bytes","servers","power","crash"]
  },
  {
    "name": "database",
    "categories": ["devices","development"],
    "tags": ["storage","memory","container","tin","pot","bytes","servers"]
  },
  {
    "name": "decimals-arrow-left",
    "categories": ["design","text","arrows","math"],
    "tags": ["numerical","decimal","decrease","less","fewer","precision","rounding","digits","fraction","float","number"]
  },
  {
    "name": "decimals-arrow-right",
    "categories": ["design","text","arrows","math"],
    "tags": ["numerical","decimal","increase","more","precision","rounding","digits","fraction","float","number"]
  },
  {
    "name": "delete",
    "categories": ["text","arrows"],
    "tags": ["backspace","remove"]
  },
  {
    "name": "dessert",
    "categories": ["food-beverage"],
    "tags": ["pudding","christmas","xmas","custard","iced bun","icing","fondant","cake","ice cream","gelato","sundae","scoop","dollop","sugar","food","sweet"]
  },
  {
    "name": "diameter",
    "categories": ["shapes","math","design","tools"],
    "tags": ["shape","circle","geometry","trigonometry","width","height","size","calculate","measure"]
  },
  {
    "name": "diamond-minus",
    "categories": ["multimedia","photography","tools","devices"],
    "tags": ["keyframe","subtract","remove","decrease","reduce","calculator","button","keyboard","line","divider","separator","horizontal rule","hr","html","markup","markdown","---","toolbar","operator","code","coding","minimum","downgrade"]
  },
  {
    "name": "diamond-percent",
    "categories": ["social","finance","shopping","math"],
    "tags": ["verified","unverified","sale","discount","offer","marketing","sticker","price tag"]
  },
  {
    "name": "diamond-plus",
    "categories": ["multimedia","photography","tools","devices"],
    "tags": ["keyframe","add","new","increase","increment","positive","calculate","toolbar","crosshair","aim","target","scope","sight","reticule","maximum","upgrade","extra","+"]
  },
  {
    "name": "diamond",
    "categories": ["shapes","gaming"],
    "tags": ["square","rectangle","oblique","rhombus","shape","suit","playing","cards"]
  },
  {
    "name": "dice-1",
    "categories": ["gaming"],
    "tags": ["dice","random","tabletop","1","board","game"]
  },
  {
    "name": "dice-2",
    "categories": ["gaming"],
    "tags": ["dice","random","tabletop","2","board","game"]
  },
  {
    "name": "dice-3",
    "categories": ["gaming"],
    "tags": ["dice","random","tabletop","3","board","game"]
  },
  {
    "name": "dice-4",
    "categories": ["gaming"],
    "tags": ["dice","random","tabletop","4","board","game"]
  },
  {
    "name": "dice-5",
    "categories": ["gaming"],
    "tags": ["dice","random","tabletop","5","board","game"]
  },
  {
    "name": "dice-6",
    "categories": ["gaming"],
    "tags": ["dice","random","tabletop","6","board","game"]
  },
  {
    "name": "dices",
    "categories": ["gaming"],
    "tags": ["dice","random","tabletop","board","game"]
  },
  {
    "name": "diff",
    "categories": ["development","files"],
    "tags": ["patch","difference","compare","plus","minus","plus-minus","math"]
  },
  {
    "name": "disc-2",
    "categories": ["devices","multimedia"],
    "tags": ["album","music","vinyl","record","cd","dvd","format","dj","spin","rotate","rpm"]
  },
  {
    "name": "disc-3",
    "categories": ["devices","multimedia"],
    "tags": ["album","music","vinyl","record","cd","dvd","format","dj","spin","rotate","rpm"]
  },
  {
    "name": "disc-album",
    "categories": ["devices","multimedia"],
    "tags": ["album","music","songs","format","cd","dvd","vinyl","sleeve","cover","platinum","compilation","ep","recording","playback","spin","rotate","rpm","dj"]
  },
  {
    "name": "disc",
    "categories": ["devices","multimedia"],
    "tags": ["album","music","songs","format","cd","dvd","vinyl","sleeve","cover","platinum","compilation","ep","recording","playback","spin","rotate","rpm","dj"]
  },
  {
    "name": "divide",
    "categories": ["math","development"],
    "tags": ["calculate","math","division","operator","code","÷","/"]
  },
  {
    "name": "dna-off",
    "categories": ["medical","food-beverage"],
    "tags": ["gene","gmo free","helix","heredity","chromosome","nucleic acid"]
  },
  {
    "name": "dna",
    "categories": ["medical"],
    "tags": ["gene","gmo","helix","heredity","chromosome","nucleic acid"]
  },
  {
    "name": "dock",
    "categories": ["layout","design","development","files"],
    "tags": ["desktop","applications","launch","home","menu bar","bottom","line","macos","osx"]
  },
  {
    "name": "dog",
    "categories": ["animals"],
    "tags": ["animal","pet","puppy","hound","canine"]
  },
  {
    "name": "dollar-sign",
    "categories": ["finance"],
    "tags": ["currency","money","payment"]
  },
  {
    "name": "donut",
    "categories": ["food-beverage"],
    "tags": ["doughnut","sprinkles","topping","fast food","junk food","snack","treat","sweet","sugar","dessert","hollow","ring"]
  },
  {
    "name": "door-closed-locked",
    "categories": ["home","travel","security"],
    "tags": ["entrance","entry","exit","ingress","egress","gate","gateway","emergency exit","lock"]
  },
  {
    "name": "door-closed",
    "categories": ["home","travel","security"],
    "tags": ["entrance","entry","exit","ingress","egress","gate","gateway","emergency exit"]
  },
  {
    "name": "door-open",
    "categories": ["home","travel","security"],
    "tags": ["entrance","entry","exit","ingress","egress","gate","gateway","emergency exit"]
  },
  {
    "name": "dot",
    "categories": ["shapes","text"],
    "tags": ["interpunct","interpoint","middot","step","punctuation","period","full stop","end","finish","final","characters","font","typography","type","center","."]
  },
  {
    "name": "download",
    "categories": ["arrows","files"],
    "tags": ["import","export","save"]
  },
  {
    "name": "drafting-compass",
    "categories": ["math","design","tools"],
    "tags": ["geometry","trigonometry","radius","diameter","circumference","calculate","measure","arc","curve","draw","sketch"]
  },
  {
    "name": "drama",
    "categories": ["multimedia"],
    "tags": ["drama","masks","theater","theatre","entertainment","show"]
  },
  {
    "name": "dribbble",
    "categories": ["brands","social","design"],
    "tags": ["design","social"]
  },
  {
    "name": "drill",
    "categories": ["tools","home","devices"],
    "tags": ["power","bit","head","hole","diy","toolbox","build","construction"]
  },
  {
    "name": "drone",
    "categories": ["transportation","devices"],
    "tags": ["quadcopter","uav","aerial","flight","flying","technology","airborne","robotics"]
  },
  {
    "name": "droplet-off",
    "categories": ["weather","gaming"],
    "tags": ["water","weather","liquid","fluid","wet","moisture","damp","bead","globule"]
  },
  {
    "name": "droplet",
    "categories": ["weather","gaming"],
    "tags": ["water","weather","liquid","fluid","wet","moisture","damp","bead","globule"]
  },
  {
    "name": "droplets",
    "categories": ["weather"],
    "tags": ["water","weather","liquid","fluid","wet","moisture","damp","bead","globule"]
  },
  {
    "name": "drum",
    "categories": ["multimedia","devices"],
    "tags": ["drummer","kit","sticks","instrument","beat","bang","bass","backing track","band","play","performance","concert","march","music","audio","sound","noise","loud"]
  },
  {
    "name": "drumstick",
    "categories": ["food-beverage"],
    "tags": ["food","chicken","meat"]
  },
  {
    "name": "dumbbell",
    "categories": ["navigation","sports"],
    "tags": ["barbell","weight","workout","gym"]
  },
  {
    "name": "ear-off",
    "categories": ["medical","accessibility"],
    "tags": ["hearing","hard of hearing","hearing loss","deafness","noise","silence","audio","accessibility"]
  },
  {
    "name": "ear",
    "categories": ["medical","accessibility"],
    "tags": ["hearing","noise","audio","accessibility"]
  },
  {
    "name": "earth-lock",
    "categories": ["security","development","devices"],
    "tags": ["vpn","private","privacy","network","world","browser","security","encryption","protection","connection"]
  },
  {
    "name": "earth",
    "categories": ["navigation"],
    "tags": ["world","browser","language","translate","globe"]
  },
  {
    "name": "eclipse",
    "categories": ["science","design","development","accessibility","photography"],
    "tags": ["lunar","solar","crescent moon","sun","earth","day","night","planet","space","mode","dark","light","toggle","switch","color","css","styles","display","accessibility","contrast","brightness","blend","shade"]
  },
  {
    "name": "egg-fried",
    "categories": ["food-beverage"],
    "tags": ["food","breakfast"]
  },
  {
    "name": "egg-off",
    "categories": ["food-beverage"],
    "tags": ["egg free","vegan","hatched","bad egg"]
  },
  {
    "name": "egg",
    "categories": ["food-beverage","animals"],
    "tags": ["bird","chicken","nest","hatch","shell","incubate","soft boiled","hard","breakfast","brunch","morning","easter"]
  },
  {
    "name": "ellipsis-vertical",
    "categories": ["layout"],
    "tags": ["menu","options","spread","more","further","extra","overflow","dots","…","..."]
  },
  {
    "name": "ellipsis",
    "categories": ["layout","development"],
    "tags": ["et cetera","etc","loader","loading","progress","pending","throbber","menu","options","operator","code","coding","spread","rest","more","further","extra","overflow","dots","…","..."]
  },
  {
    "name": "equal-approximately",
    "categories": ["math"],
    "tags": ["about","calculate","math","operater"]
  },
  {
    "name": "equal-not",
    "categories": ["math","development"],
    "tags": ["calculate","off","math","operator","code","≠"]
  },
  {
    "name": "equal",
    "categories": ["math","development"],
    "tags": ["calculate","math","operator","assignment","code","="]
  },
  {
    "name": "eraser",
    "categories": ["text"],
    "tags": ["pencil","drawing","undo","delete","clear","trash","remove"]
  },
  {
    "name": "ethernet-port",
    "categories": ["communication","devices","multimedia","gaming"],
    "tags": ["internet","network","connection","cable","lan","port","router","switch","hub","modem","web","online","networking","communication","socket","plug","slot","controller","connector","interface","console","signal","data","input","output"]
  },
  {
    "name": "euro",
    "categories": ["finance"],
    "tags": ["currency","money","payment"]
  },
  {
    "name": "ev-charger",
    "categories": ["transportation","navigation"],
    "tags": ["electric","charger","station","vehicle","fast","plug","ev","power","electricity","energy","accumulator","charge"]
  },
  {
    "name": "expand",
    "categories": ["text","arrows"],
    "tags": ["scale","fullscreen","maximize","minimize","contract"]
  },
  {
    "name": "external-link",
    "categories": ["arrows","text","social"],
    "tags": ["outbound","open","share"]
  },
  {
    "name": "eye-closed",
    "categories": ["accessibility","photography","design","security"],
    "tags": ["view","watch","see","hide","conceal","mask","hidden","visibility","vision"]
  },
  {
    "name": "eye-off",
    "categories": ["accessibility","photography","design","security"],
    "tags": ["view","watch","see","hide","conceal","mask","hidden","visibility","vision"]
  },
  {
    "name": "eye",
    "categories": ["accessibility","photography","design","security"],
    "tags": ["view","watch","see","show","expose","reveal","display","visible","visibility","vision","preview","read"]
  },
  {
    "name": "facebook",
    "categories": ["social","brands"],
    "tags": ["logo","social"]
  },
  {
    "name": "factory",
    "categories": ["buildings","navigation"],
    "tags": ["building","business","energy","industry","manufacture","sector"]
  },
  {
    "name": "fan",
    "categories": ["home"],
    "tags": ["air","cooler","ventilation","ventilator","blower"]
  },
  {
    "name": "fast-forward",
    "categories": ["multimedia","arrows"],
    "tags": ["music"]
  },
  {
    "name": "feather",
    "categories": ["gaming"],
    "tags": ["logo"]
  },
  {
    "name": "fence",
    "categories": ["home","buildings"],
    "tags": ["picket","panels","woodwork","diy","materials","suburban","garden","property","territory"]
  },
  {
    "name": "ferris-wheel",
    "categories": ["navigation"],
    "tags": ["big wheel","daisy wheel","observation","attraction","entertainment","amusement park","theme park","funfair"]
  },
  {
    "name": "figma",
    "categories": ["brands","design"],
    "tags": ["logo","design","tool"]
  },
  {
    "name": "file-archive",
    "categories": ["files"],
    "tags": ["zip","package","archive"]
  },
  {
    "name": "file-axis-3d",
    "categories": ["design","files"],
    "tags": ["model","3d","axis","coordinates"]
  },
  {
    "name": "file-badge",
    "categories": ["files"],
    "tags": ["award","achievement","badge","rosette","prize","winner"]
  },
  {
    "name": "file-box",
    "categories": ["files"],
    "tags": ["box","package","model"]
  },
  {
    "name": "file-braces-corner",
    "categories": ["files","development"],
    "tags": ["code","json","curly braces","curly brackets"]
  },
  {
    "name": "file-braces",
    "categories": ["files","development"],
    "tags": ["code","json","curly braces","curly brackets"]
  },
  {
    "name": "file-chart-column-increasing",
    "categories": ["files"],
    "tags": ["statistics","analytics","diagram","graph","presentation","trending up"]
  },
  {
    "name": "file-chart-column",
    "categories": ["files"],
    "tags": ["statistics","analytics","diagram","graph","presentation"]
  },
  {
    "name": "file-chart-line",
    "categories": ["files"],
    "tags": ["statistics","analytics","diagram","graph","presentation"]
  },
  {
    "name": "file-chart-pie",
    "categories": ["files"],
    "tags": ["statistics","analytics","diagram","graph","presentation"]
  },
  {
    "name": "file-check-corner",
    "categories": ["files"],
    "tags": ["done","document","todo","tick","complete","task"]
  },
  {
    "name": "file-check",
    "categories": ["files"],
    "tags": ["done","document","todo","tick","complete","task"]
  },
  {
    "name": "file-clock",
    "categories": ["files","time"],
    "tags": ["history","log","clock"]
  },
  {
    "name": "file-code-corner",
    "categories": ["files","development"],
    "tags": ["script","document","html","xml","property list","plist"]
  },
  {
    "name": "file-code",
    "categories": ["files","development"],
    "tags": ["script","document","gist","html","xml","property list","plist"]
  },
  {
    "name": "file-cog",
    "categories": ["files"],
    "tags": ["executable","settings","cog","edit","gear"]
  },
  {
    "name": "file-diff",
    "categories": ["files","development"],
    "tags": ["diff","patch"]
  },
  {
    "name": "file-digit",
    "categories": ["files","development"],
    "tags": ["number","document"]
  },
  {
    "name": "file-down",
    "categories": ["files","arrows"],
    "tags": ["download","import","export"]
  },
  {
    "name": "file-exclamation-point",
    "categories": ["files","notifications"],
    "tags": ["hidden","warning","alert","danger","protected","exclamation mark"]
  },
  {
    "name": "file-headphone",
    "categories": ["files"],
    "tags": ["music","audio","sound","headphones"]
  },
  {
    "name": "file-heart",
    "categories": ["files"],
    "tags": ["heart","favourite","bookmark","quick link"]
  },
  {
    "name": "file-image",
    "categories": ["files"],
    "tags": ["image","graphics","photo","picture"]
  },
  {
    "name": "file-input",
    "categories": ["files","arrows"],
    "tags": ["document"]
  },
  {
    "name": "file-key",
    "categories": ["files","security"],
    "tags": ["key","private","public","security"]
  },
  {
    "name": "file-lock",
    "categories": ["files","security"],
    "tags": ["lock","password","security"]
  },
  {
    "name": "file-minus-corner",
    "categories": ["files"],
    "tags": ["document"]
  },
  {
    "name": "file-minus",
    "categories": ["files"],
    "tags": ["delete","remove","erase","document"]
  },
  {
    "name": "file-music",
    "categories": ["files","multimedia"],
    "tags": ["audio","sound","noise","track","digital","recording","playback","piano","keyboard","keys","notes","chord","midi","octave"]
  },
  {
    "name": "file-output",
    "categories": ["files","arrows"],
    "tags": ["document"]
  },
  {
    "name": "file-pen-line",
    "categories": ["files"],
    "tags": ["edit"]
  },
  {
    "name": "file-pen",
    "categories": ["files"],
    "tags": ["signature"]
  },
  {
    "name": "file-play",
    "categories": ["files"],
    "tags": ["movie","video","film"]
  },
  {
    "name": "file-plus-corner",
    "categories": ["files"],
    "tags": ["add","create","new","document"]
  },
  {
    "name": "file-plus",
    "categories": ["files"],
    "tags": ["add","create","new","document"]
  },
  {
    "name": "file-question-mark",
    "categories": ["files"],
    "tags": ["readme","help","question"]
  },
  {
    "name": "file-scan",
    "categories": ["files"],
    "tags": ["scan","code","qr-code"]
  },
  {
    "name": "file-search-corner",
    "categories": ["files"],
    "tags": ["lost","document","find","browser","lens"]
  },
  {
    "name": "file-search",
    "categories": ["files"],
    "tags": ["lost","document","find","browser","lens"]
  },
  {
    "name": "file-signal",
    "categories": ["files"],
    "tags": ["audio","music","volume"]
  },
  {
    "name": "file-sliders",
    "categories": ["files","development"],
    "tags": ["cogged","gear","mechanical","machinery","configuration","controls","preferences","settings","system","admin","edit","executable"]
  },
  {
    "name": "file-spreadsheet",
    "categories": ["files"],
    "tags": ["spreadsheet","sheet","table"]
  },
  {
    "name": "file-stack",
    "categories": ["files","development"],
    "tags": ["versions","multiple","copy","documents","revisions","version control","history"]
  },
  {
    "name": "file-symlink",
    "categories": ["files"],
    "tags": ["symlink","symbolic","link"]
  },
  {
    "name": "file-terminal",
    "categories": ["files","development"],
    "tags": ["terminal","bash","script","executable"]
  },
  {
    "name": "file-text",
    "categories": ["files","text"],
    "tags": ["data","txt","pdf","document"]
  },
  {
    "name": "file-type-corner",
    "categories": ["files","text"],
    "tags": ["font","text","typography","type"]
  },
  {
    "name": "file-type",
    "categories": ["files","text"],
    "tags": ["font","text","typography","type"]
  },
  {
    "name": "file-up",
    "categories": ["files","arrows"],
    "tags": ["upload","import","export"]
  },
  {
    "name": "file-user",
    "categories": ["account","files"],
    "tags": ["person","personal information","people","listing","networking","document","contact","cover letter","resume","cv","curriculum vitae","application form"]
  },
  {
    "name": "file-video-camera",
    "categories": ["files"],
    "tags": ["movie","video","film"]
  },
  {
    "name": "file-volume",
    "categories": ["files"],
    "tags": ["audio","music","volume"]
  },
  {
    "name": "file-x-corner",
    "categories": ["files"],
    "tags": ["lost","delete","remove","document"]
  },
  {
    "name": "file-x",
    "categories": ["files"],
    "tags": ["lost","delete","remove","document"]
  },
  {
    "name": "file",
    "categories": ["files"],
    "tags": ["document"]
  },
  {
    "name": "files",
    "categories": ["files"],
    "tags": ["multiple","copy","documents"]
  },
  {
    "name": "film",
    "categories": ["photography","multimedia"],
    "tags": ["movie","video","reel","camera","cinema","entertainment"]
  },
  {
    "name": "fingerprint-pattern",
    "categories": ["account","security","medical","devices"],
    "tags": ["2fa","authentication","biometric","identity","security"]
  },
  {
    "name": "fire-extinguisher",
    "categories": ["home","tools","travel"],
    "tags": ["flames","smoke","foam","water","spray","hose","firefighter","fireman","department","brigade","station","emergency","suppress","compressed","tank","cylinder","safety","equipment","amenities"]
  },
  {
    "name": "fish-off",
    "categories": ["food-beverage","animals"],
    "tags": ["food","dish","restaurant","course","meal","seafood","animal","pet","sea","marine","allergy","intolerance","diet"]
  },
  {
    "name": "fish-symbol",
    "categories": ["food-beverage","animals"],
    "tags": ["dish","restaurant","course","meal","seafood","pet","sea","marine"]
  },
  {
    "name": "fish",
    "categories": ["food-beverage","animals"],
    "tags": ["dish","restaurant","course","meal","seafood","pet","sea","marine"]
  },
  {
    "name": "fishing-hook",
    "categories": ["sports","travel"],
    "tags": ["sea","boating","angler","bait","reel","tackle","marine","outdoors","fish","fishing","hook","sports","travel"]
  },
  {
    "name": "flag-off",
    "categories": ["account","social"],
    "tags": ["unflag","unmark","report","marker","notification","warning","milestone","goal","notice","signal","attention","banner"]
  },
  {
    "name": "flag-triangle-left",
    "categories": ["development","navigation"],
    "tags": ["report","timeline","marker","pin"]
  },
  {
    "name": "flag-triangle-right",
    "categories": ["development","navigation"],
    "tags": ["report","timeline","marker","pin"]
  },
  {
    "name": "flag",
    "categories": ["account","social"],
    "tags": ["report","marker","notification","warning","milestone","goal","notice","signal","attention","banner"]
  },
  {
    "name": "flame-kindling",
    "categories": ["nature","social","gaming"],
    "tags": ["campfire","camping","wilderness","outdoors","lit","warmth","wood","twigs","sticks"]
  },
  {
    "name": "flame",
    "categories": ["weather","social","gaming"],
    "tags": ["heat","burn","light","glow","ignite","passion","ember","fire","lit","burning","spark","embers","smoke","firefighter","fireman","department","brigade","station","emergency"]
  },
  {
    "name": "flashlight-off",
    "categories": ["photography","devices"],
    "tags": ["torch","light","beam","emergency","safety","tool","bright"]
  },
  {
    "name": "flashlight",
    "categories": ["photography","devices"],
    "tags": ["torch","light","beam","emergency","safety","tool","bright"]
  },
  {
    "name": "flask-conical-off",
    "categories": ["science","gaming"],
    "tags": ["beaker","erlenmeyer","non toxic","lab","chemistry","experiment","test"]
  },
  {
    "name": "flask-conical",
    "categories": ["science","gaming"],
    "tags": ["beaker","erlenmeyer","lab","chemistry","experiment","test"]
  },
  {
    "name": "flask-round",
    "categories": ["science","gaming"],
    "tags": ["beaker","lab","chemistry","experiment","test"]
  },
  {
    "name": "flip-horizontal-2",
    "categories": ["design","photography"],
    "tags": ["reflect","mirror","alignment","dashed"]
  },
  {
    "name": "flip-horizontal",
    "categories": ["design","photography"],
    "tags": ["reflect","mirror","alignment","dashed"]
  },
  {
    "name": "flip-vertical-2",
    "categories": ["design","photography"],
    "tags": ["reflect","mirror","alignment","dashed"]
  },
  {
    "name": "flip-vertical",
    "categories": ["design","photography"],
    "tags": ["reflect","mirror","alignment","dashed"]
  },
  {
    "name": "flower-2",
    "categories": ["nature","sustainability","seasons"],
    "tags": ["sustainability","nature","plant"]
  },
  {
    "name": "flower",
    "categories": ["nature","gaming","sustainability"],
    "tags": ["sustainability","nature","plant","spring"]
  },
  {
    "name": "focus",
    "categories": ["photography"],
    "tags": ["camera","lens","photo","dashed"]
  },
  {
    "name": "fold-horizontal",
    "categories": ["arrows","layout"],
    "tags": ["arrow","collapse","fold","vertical","dashed"]
  },
  {
    "name": "fold-vertical",
    "categories": ["arrows","layout"],
    "tags": ["arrow","collapse","fold","vertical","dashed"]
  },
  {
    "name": "folder-archive",
    "categories": ["files"],
    "tags": ["archive","zip","package"]
  },
  {
    "name": "folder-check",
    "categories": ["files"],
    "tags": ["done","directory","todo","tick","complete","task"]
  },
  {
    "name": "folder-clock",
    "categories": ["files","time"],
    "tags": ["history","directory","clock"]
  },
  {
    "name": "folder-closed",
    "categories": ["files"],
    "tags": ["directory","closed"]
  },
  {
    "name": "folder-code",
    "categories": ["files","development"],
    "tags": ["directory","coding","develop","software"]
  },
  {
    "name": "folder-cog",
    "categories": ["files"],
    "tags": ["directory","settings","control","preferences","cog","edit","gear"]
  },
  {
    "name": "folder-dot",
    "categories": ["files","development"],
    "tags": ["directory","root","project","pinned","active","current","cogged","gear","mechanical","machinery","configuration","controls","preferences","settings","system","admin","edit"]
  },
  {
    "name": "folder-down",
    "categories": ["files","arrows"],
    "tags": ["directory","download","import","export"]
  },
  {
    "name": "folder-git-2",
    "categories": ["files"],
    "tags": ["directory","root","project","git","repo"]
  },
  {
    "name": "folder-git",
    "categories": ["files"],
    "tags": ["directory","root","project","git","repo"]
  },
  {
    "name": "folder-heart",
    "categories": ["files"],
    "tags": ["directory","heart","favourite","bookmark","quick link"]
  },
  {
    "name": "folder-input",
    "categories": ["files","arrows"],
    "tags": ["directory","import","export"]
  },
  {
    "name": "folder-kanban",
    "categories": ["charts","development","design","files"],
    "tags": ["projects","manage","overview","board","tickets","issues","roadmap","plan","intentions","productivity","work","agile","code","coding","directory","project","root"]
  },
  {
    "name": "folder-key",
    "categories": ["files","security"],
    "tags": ["directory","key","private","security","protected"]
  },
  {
    "name": "folder-lock",
    "categories": ["files","security"],
    "tags": ["directory","lock","private","security","protected"]
  },
  {
    "name": "folder-minus",
    "categories": ["files"],
    "tags": ["directory","remove","delete"]
  },
  {
    "name": "folder-open-dot",
    "categories": ["files","development"],
    "tags": ["directory","root","project","active","current","pinned"]
  },
  {
    "name": "folder-open",
    "categories": ["files"],
    "tags": ["directory"]
  },
  {
    "name": "folder-output",
    "categories": ["files","arrows"],
    "tags": ["directory","import","export"]
  },
  {
    "name": "folder-pen",
    "categories": ["files"],
    "tags": ["directory","rename"]
  },
  {
    "name": "folder-plus",
    "categories": ["files"],
    "tags": ["directory","add","create","new"]
  },
  {
    "name": "folder-root",
    "categories": ["files","development"],
    "tags": ["directory","root","project","git","repo"]
  },
  {
    "name": "folder-search-2",
    "categories": ["files"],
    "tags": ["directory","search","find","lost","browser","lens"]
  },
  {
    "name": "folder-search",
    "categories": ["files"],
    "tags": ["directory","search","find","lost","browser","lens"]
  },
  {
    "name": "folder-symlink",
    "categories": ["files"],
    "tags": ["directory","symlink","symbolic","link"]
  },
  {
    "name": "folder-sync",
    "categories": ["files","arrows"],
    "tags": ["directory","synchronize","synchronise","refresh","reconnect","transfer","backup"]
  },
  {
    "name": "folder-tree",
    "categories": ["files"],
    "tags": ["directory","tree","browser"]
  },
  {
    "name": "folder-up",
    "categories": ["files","arrows"],
    "tags": ["directory","upload","import","export"]
  },
  {
    "name": "folder-x",
    "categories": ["files"],
    "tags": ["directory","remove","delete"]
  },
  {
    "name": "folder",
    "categories": ["files"],
    "tags": ["directory"]
  },
  {
    "name": "folders",
    "categories": ["files"],
    "tags": ["multiple","copy","directories"]
  },
  {
    "name": "footprints",
    "categories": ["navigation"],
    "tags": ["steps","walking","foot","feet","trail","shoe"]
  },
  {
    "name": "forklift",
    "categories": ["transportation"],
    "tags": ["vehicle","transport","logistics"]
  },
  {
    "name": "form",
    "categories": ["development"],
    "tags": ["document","page","file","layout","paper","stub","formality","structure","template","inputs","design","components"]
  },
  {
    "name": "forward",
    "categories": ["mail"],
    "tags": ["send","share","email"]
  },
  {
    "name": "frame",
    "categories": ["design","photography"],
    "tags": ["logo","design","tool"]
  },
  {
    "name": "framer",
    "categories": ["brands","design"],
    "tags": ["logo","design","tool"]
  },
  {
    "name": "frown",
    "categories": ["emoji","account"],
    "tags": ["emoji","face","bad","sad","emotion"]
  },
  {
    "name": "fuel",
    "categories": ["transportation","navigation"],
    "tags": ["filling-station","gas","petrol","tank"]
  },
  {
    "name": "fullscreen",
    "categories": ["layout","multimedia","design","photography"],
    "tags": ["expand","zoom","preview","focus","camera","lens","image"]
  },
  {
    "name": "funnel-plus",
    "categories": ["layout"],
    "tags": ["filter","hopper","add","create","new"]
  },
  {
    "name": "funnel-x",
    "categories": ["layout"],
    "tags": ["filter","hopper","remove","delete"]
  },
  {
    "name": "funnel",
    "categories": ["layout"],
    "tags": ["filter","hopper"]
  },
  {
    "name": "gallery-horizontal-end",
    "categories": ["layout","design","development","photography","multimedia","files"],
    "tags": ["carousel","pictures","images","scroll","swipe","album","portfolio","history","versions","backup","time machine"]
  },
  {
    "name": "gallery-horizontal",
    "categories": ["layout","design","development","photography","multimedia"],
    "tags": ["carousel","pictures","images","scroll","swipe","album","portfolio"]
  },
  {
    "name": "gallery-thumbnails",
    "categories": ["layout","design","development","photography","multimedia"],
    "tags": ["carousel","pictures","images","album","portfolio","preview"]
  },
  {
    "name": "gallery-vertical-end",
    "categories": ["layout","design","development","photography","multimedia","files"],
    "tags": ["carousel","pictures","images","scroll","swipe","album","portfolio","history","versions","backup","time machine"]
  },
  {
    "name": "gallery-vertical",
    "categories": ["layout","design","development","photography","multimedia"],
    "tags": ["carousel","pictures","images","scroll","swipe","album","portfolio"]
  },
  {
    "name": "gamepad-2",
    "categories": ["gaming","devices"],
    "tags": ["console"]
  },
  {
    "name": "gamepad-directional",
    "categories": ["gaming","devices"],
    "tags": ["direction","arrow","controller","navigation","button","move","pointer","arrowhead","console","game","gaming"]
  },
  {
    "name": "gamepad",
    "categories": ["gaming","devices"],
    "tags": ["console"]
  },
  {
    "name": "gauge",
    "categories": ["transportation","sports","science"],
    "tags": ["dashboard","dial","meter","speed","pressure","measure","level"]
  },
  {
    "name": "gavel",
    "categories": ["navigation","tools"],
    "tags": ["justice","law","court","judgment","legal","hands","penalty","decision","authority","hammer","mallet"]
  },
  {
    "name": "gem",
    "categories": ["gaming","development","finance"],
    "tags": ["diamond","crystal","ruby","jewellery","price","special","present","gift","ring","wedding","proposal","marriage","rubygems"]
  },
  {
    "name": "georgian-lari",
    "categories": ["finance"],
    "tags": ["currency","money","payment"]
  },
  {
    "name": "ghost",
    "categories": ["gaming"],
    "tags": ["pac-man","spooky"]
  },
  {
    "name": "gift",
    "categories": ["gaming","account"],
    "tags": ["present","box","birthday","party"]
  },
  {
    "name": "git-branch-minus",
    "categories": ["development"],
    "tags": ["code","version control","vcs","repository","delete","remove","-"]
  },
  {
    "name": "git-branch-plus",
    "categories": ["development"],
    "tags": ["code","version control","vcs","repository","add","create","+"]
  },
  {
    "name": "git-branch",
    "categories": ["development"],
    "tags": ["code","version control","vcs","repository"]
  },
  {
    "name": "git-commit-horizontal",
    "categories": ["development","navigation"],
    "tags": ["code","version control","waypoint","stop","station"]
  },
  {
    "name": "git-commit-vertical",
    "categories": ["development","navigation"],
    "tags": ["code","version control","waypoint","stop","station"]
  },
  {
    "name": "git-compare-arrows",
    "categories": ["development","arrows"],
    "tags": ["code","version control","diff"]
  },
  {
    "name": "git-compare",
    "categories": ["development"],
    "tags": ["code","version control","diff"]
  },
  {
    "name": "git-fork",
    "categories": ["development"],
    "tags": ["code","version control"]
  },
  {
    "name": "git-graph",
    "categories": ["development"],
    "tags": ["code","version control","commit graph","commits","gitlens"]
  },
  {
    "name": "git-merge",
    "categories": ["development"],
    "tags": ["code","version control"]
  },
  {
    "name": "git-pull-request-arrow",
    "categories": ["development","arrows"],
    "tags": ["code","version control","open"]
  },
  {
    "name": "git-pull-request-closed",
    "categories": ["development"],
    "tags": ["code","version control","rejected","closed","cancelled","x"]
  },
  {
    "name": "git-pull-request-create-arrow",
    "categories": ["development","arrows"],
    "tags": ["code","version control","open","plus","add","+"]
  },
  {
    "name": "git-pull-request-create",
    "categories": ["development"],
    "tags": ["code","version control","open","plus","add","+"]
  },
  {
    "name": "git-pull-request-draft",
    "categories": ["development"],
    "tags": ["code","version control","open","draft","dashed"]
  },
  {
    "name": "git-pull-request",
    "categories": ["development"],
    "tags": ["code","version control","open"]
  },
  {
    "name": "github",
    "categories": ["brands","development"],
    "tags": ["logo","version control"]
  },
  {
    "name": "gitlab",
    "categories": ["brands","development"],
    "tags": ["logo","version control"]
  },
  {
    "name": "glass-water",
    "categories": ["food-beverage"],
    "tags": ["beverage","drink","glass","water"]
  },
  {
    "name": "glasses",
    "categories": ["accessibility"],
    "tags": ["glasses","spectacles"]
  },
  {
    "name": "globe-lock",
    "categories": ["security","development","devices"],
    "tags": ["vpn","private","privacy","network","world","browser","security","encryption","protection","connection"]
  },
  {
    "name": "globe-x",
    "categories": ["connectivity","devices","navigation"],
    "tags": ["globe","internet","offline","disconnected","network","connection","world","no connection","network failure","signal off"]
  },
  {
    "name": "globe",
    "categories": ["navigation"],
    "tags": ["world","browser","language","translate"]
  },
  {
    "name": "goal",
    "categories": ["gaming"],
    "tags": ["flag","bullseye"]
  },
  {
    "name": "gpu",
    "categories": ["devices","gaming"],
    "tags": ["processor","cores","technology","computer","chip","circuit","specs","graphics processing unit","video card","display adapter","gddr","rendering","digital image processing","crypto mining"]
  },
  {
    "name": "graduation-cap",
    "categories": ["buildings"],
    "tags": ["school","university","learn","study","mortarboard","education","ceremony","academic","hat","diploma","bachlor's","master's","doctorate"]
  },
  {
    "name": "grape",
    "categories": ["food-beverage"],
    "tags": ["fruit","wine","food"]
  },
  {
    "name": "grid-2x2-check",
    "categories": ["text","layout","math"],
    "tags": ["table","rows","columns","blocks","plot","land","geometry","measure","data","size","width","height","distance","surface area","square meter","acre"]
  },
  {
    "name": "grid-2x2-plus",
    "categories": ["text","layout","math"],
    "tags": ["table","rows","columns","blocks","plot","land","geometry","measure","data","size","width","height","distance","surface area","square meter","acre"]
  },
  {
    "name": "grid-2x2-x",
    "categories": ["text","layout","math"],
    "tags": ["table","rows","columns","data","blocks","plot","land","geometry","measure","size","width","height","distance","surface area","square meter","acre"]
  },
  {
    "name": "grid-2x2",
    "categories": ["text","layout","design","math"],
    "tags": ["table","rows","columns","blocks","plot","land","geometry","measure","size","width","height","distance","surface area","square meter","acre","window","skylight"]
  },
  {
    "name": "grid-3x2",
    "categories": ["text","math","layout","design"],
    "tags": ["table","rows","columns","blocks","plot","land","geometry","measure","size","width","height","distance","surface area","square meter","acre","window"]
  },
  {
    "name": "grid-3x3",
    "categories": ["text","layout","design"],
    "tags": ["table","rows","columns"]
  },
  {
    "name": "grip-horizontal",
    "categories": ["layout"],
    "tags": ["grab","dots","handle","move","drag"]
  },
  {
    "name": "grip-vertical",
    "categories": ["layout"],
    "tags": ["grab","dots","handle","move","drag"]
  },
  {
    "name": "grip",
    "categories": ["layout"],
    "tags": ["grab","dots","handle","move","drag"]
  },
  {
    "name": "group",
    "categories": ["files"],
    "tags": ["cubes","packages","parts","units","collection","cluster","gather","dashed"]
  },
  {
    "name": "guitar",
    "categories": ["multimedia"],
    "tags": ["acoustic","instrument","strings","riff","rock","band","country","concert","performance","play","lead","loud","music","audio","sound","noise"]
  },
  {
    "name": "ham",
    "categories": ["food-beverage"],
    "tags": ["food","pork","pig","meat","bone","hock","knuckle","gammon","cured"]
  },
  {
    "name": "hamburger",
    "categories": ["food-beverage"],
    "tags": ["burger","cheeseburger","meat","beef","patty","bun","fast food","junk food","takeaway","takeout","snack","dish","restaurant","lunch","meal","savory","savoury","cookery","cooking","grilled","barbecue","barbeque","bbq","lettuce","tomato","relish","pickles","onions","ketchup","mustard","mayonnaise"]
  },
  {
    "name": "hammer",
    "categories": ["tools","home"],
    "tags": ["mallet","nails","diy","toolbox","build","construction"]
  },
  {
    "name": "hand-coins",
    "categories": ["finance","account"],
    "tags": ["savings","banking","money","finance","offers","mortgage","payment","received","wage","payroll","allowance","pocket money","handout","pennies"]
  },
  {
    "name": "hand-fist",
    "categories": ["social","emoji","communication","sports"],
    "tags": ["clench","strength","power","unity","solidarity","rebellion","victory","triumph","support","fight","combat","brawl"]
  },
  {
    "name": "hand-grab",
    "categories": ["cursors","design","layout"],
    "tags": ["hand"]
  },
  {
    "name": "hand-heart",
    "categories": ["social"],
    "tags": ["love","like","emotion"]
  },
  {
    "name": "hand-helping",
    "categories": ["emoji"],
    "tags": ["agreement","help","proposal","charity","begging","terms"]
  },
  {
    "name": "hand-metal",
    "categories": ["emoji","multimedia"],
    "tags": ["rock"]
  },
  {
    "name": "hand-platter",
    "categories": ["food-beverage","people"],
    "tags": ["waiter","waitress","restaurant","table service","served","dinner","dining","meal","course","luxury"]
  },
  {
    "name": "hand",
    "categories": ["cursors","accessibility"],
    "tags": ["wave","move","mouse","grab"]
  },
  {
    "name": "handbag",
    "categories": ["shopping","transportation"],
    "tags": ["bag","baggage","carry","clutch","fashion","luggage","purse","tote","travel"]
  },
  {
    "name": "handshake",
    "categories": ["account","social","communication","finance","security"],
    "tags": ["agreement","partnership","deal","business","assistance","cooperation","friendship","union","terms"]
  },
  {
    "name": "hard-drive-download",
    "categories": ["development","devices","arrows","files"],
    "tags": ["computer","server","memory","data","ssd","disk","hard disk","save"]
  },
  {
    "name": "hard-drive-upload",
    "categories": ["development","devices","arrows","files"],
    "tags": ["computer","server","memory","data","ssd","disk","hard disk","save"]
  },
  {
    "name": "hard-drive",
    "categories": ["development","devices"],
    "tags": ["computer","server","memory","data","ssd","disk","hard disk"]
  },
  {
    "name": "hard-hat",
    "categories": ["tools"],
    "tags": ["helmet","construction","safety","savety"]
  },
  {
    "name": "hash",
    "categories": ["text","social"],
    "tags": ["hashtag","number","pound"]
  },
  {
    "name": "hat-glasses",
    "categories": ["social","account","security"],
    "tags": ["incognito","disguise","costume","masked","anonymous","anonymity","privacy","private browsing","stealth","hidden","undercover","cloak","invisible","ghost","spy","agent","detective","identity","cap","fedora","spectacles","shades","sunglasses","eyewear"]
  },
  {
    "name": "haze",
    "categories": ["weather"],
    "tags": ["mist","fog"]
  },
  {
    "name": "hd",
    "categories": ["devices","multimedia"],
    "tags": ["tv","resolution","video","high definition","720p","1080p"]
  },
  {
    "name": "hdmi-port",
    "categories": ["devices","multimedia","gaming"],
    "tags": ["socket","plug","slot","controller","connector","interface","console","signal","audio","video","visual","av","data","input","output"]
  },
  {
    "name": "heading-1",
    "categories": ["text"],
    "tags": ["h1","html","markup","markdown"]
  },
  {
    "name": "heading-2",
    "categories": ["text"],
    "tags": ["h2","html","markup","markdown"]
  },
  {
    "name": "heading-3",
    "categories": ["text"],
    "tags": ["h3","html","markup","markdown"]
  },
  {
    "name": "heading-4",
    "categories": ["text"],
    "tags": ["h4","html","markup","markdown"]
  },
  {
    "name": "heading-5",
    "categories": ["text"],
    "tags": ["h5","html","markup","markdown"]
  },
  {
    "name": "heading-6",
    "categories": ["text"],
    "tags": ["h6","html","markup","markdown"]
  },
  {
    "name": "heading",
    "categories": ["text"],
    "tags": ["h1","html","markup","markdown"]
  },
  {
    "name": "headphone-off",
    "categories": ["multimedia","connectivity","communication","devices","gaming"],
    "tags": ["music","audio","sound","mute","off"]
  },
  {
    "name": "headphones",
    "categories": ["multimedia","connectivity","devices","files","gaming"],
    "tags": ["music","audio","sound"]
  },
  {
    "name": "headset",
    "categories": ["multimedia","connectivity","devices","files","gaming"],
    "tags": ["music","audio","sound","gaming","headphones","headset","call","center","phone","telephone","voip","video"]
  },
  {
    "name": "heart-crack",
    "categories": ["emoji"],
    "tags": ["heartbreak","sadness","emotion"]
  },
  {
    "name": "heart-handshake",
    "categories": ["emoji","account","security"],
    "tags": ["agreement","charity","help","deal","terms","emotion","together","handshake"]
  },
  {
    "name": "heart-minus",
    "categories": ["medical","account","multimedia","gaming","social"],
    "tags": ["unlike","unfavorite","remove","damage","ui & ux"]
  },
  {
    "name": "heart-off",
    "categories": ["social","multimedia"],
    "tags": ["unlike","dislike","hate","emotion"]
  },
  {
    "name": "heart-plus",
    "categories": ["medical","account","multimedia","gaming","social"],
    "tags": ["plus","like","favorite","add","health","support"]
  },
  {
    "name": "heart-pulse",
    "categories": ["medical"],
    "tags": ["heartbeat","pulse","health","medical","blood pressure","cardiac","systole","diastole"]
  },
  {
    "name": "heart",
    "categories": ["medical","social","multimedia","emoji","gaming","shapes"],
    "tags": ["like","love","emotion","suit","playing","cards"]
  },
  {
    "name": "heater",
    "categories": ["home","devices","travel"],
    "tags": ["heating","warmth","comfort","fire","stove","electric","electronics","amenities"]
  },
  {
    "name": "helicopter",
    "categories": ["transportation","travel"],
    "tags": ["transport","flying","rotor","aviation","helipad","gear","flyer","technology","helicopter","aircraft","vehicle"]
  },
  {
    "name": "hexagon",
    "categories": ["shapes","brands","development"],
    "tags": ["shape","node.js","logo"]
  },
  {
    "name": "highlighter",
    "categories": ["text","design"],
    "tags": ["mark","text"]
  },
  {
    "name": "history",
    "categories": ["arrows","time"],
    "tags": ["time","redo","undo","rewind","timeline","version","time machine","backup","rotate","ccw"]
  },
  {
    "name": "hop-off",
    "categories": ["food-beverage"],
    "tags": ["beer","brewery","drink","hop free","allergy","intolerance","diet"]
  },
  {
    "name": "hop",
    "categories": ["food-beverage"],
    "tags": ["beer","brewery","drink"]
  },
  {
    "name": "hospital",
    "categories": ["medical","buildings","navigation","travel"],
    "tags": ["infirmary","sanatorium","healthcare","doctor","hospice","clinic","emergency room","ward","building","medical","vet"]
  },
  {
    "name": "hotel",
    "categories": ["buildings","navigation","travel"],
    "tags": ["building","hostel","motel","inn"]
  },
  {
    "name": "hourglass",
    "categories": ["time","gaming"],
    "tags": ["timer","time","sandglass"]
  },
  {
    "name": "house-heart",
    "categories": ["home","buildings","medical"],
    "tags": ["home sweet home","abode","building","residence","healthy living","lifestyle"]
  },
  {
    "name": "house-plug",
    "categories": ["buildings","home","sustainability"],
    "tags": ["home","living","building","residence","architecture","autarky","energy"]
  },
  {
    "name": "house-plus",
    "categories": ["buildings","medical"],
    "tags": ["home","living","medical","new","addition","building","residence","architecture"]
  },
  {
    "name": "house-wifi",
    "categories": ["home","buildings","connectivity"],
    "tags": ["home","living","building","wifi","connectivity"]
  },
  {
    "name": "house",
    "categories": ["buildings","home","navigation"],
    "tags": ["home","living","building","residence","architecture"]
  },
  {
    "name": "ice-cream-bowl",
    "categories": ["food-beverage"],
    "tags": ["gelato","food","dessert","dish","restaurant","course","meal"]
  },
  {
    "name": "ice-cream-cone",
    "categories": ["food-beverage"],
    "tags": ["gelato","food"]
  },
  {
    "name": "id-card-lanyard",
    "categories": ["security","account"],
    "tags": ["id-card","id-card-lanyard","identity","employee","gate-pass","badge"]
  },
  {
    "name": "id-card",
    "categories": ["security","account"],
    "tags": ["card","badge","identity","authentication","secure"]
  },
  {
    "name": "image-down",
    "categories": ["photography","text","multimedia","files"],
    "tags": ["picture","photo","download","save","export"]
  },
  {
    "name": "image-minus",
    "categories": ["photography","multimedia","files"],
    "tags": ["remove","delete"]
  },
  {
    "name": "image-off",
    "categories": ["photography","multimedia","files"],
    "tags": ["picture","photo"]
  },
  {
    "name": "image-play",
    "categories": ["photography","text","multimedia","files"],
    "tags": ["picture","gif","photo"]
  },
  {
    "name": "image-plus",
    "categories": ["photography","multimedia","files"],
    "tags": ["add","create","picture"]
  },
  {
    "name": "image-up",
    "categories": ["photography","text","multimedia","files"],
    "tags": ["picture","photo","upload","import"]
  },
  {
    "name": "image-upscale",
    "categories": ["photography","multimedia"],
    "tags": ["resize","picture","sharpen","increase"]
  },
  {
    "name": "image",
    "categories": ["photography","text","multimedia","files"],
    "tags": ["picture","photo"]
  },
  {
    "name": "images",
    "categories": ["photography","text","multimedia","files"],
    "tags": ["picture","photo","multiple","copy","gallery","album","collection","slideshow","showcase"]
  },
  {
    "name": "import",
    "categories": ["arrows","files"],
    "tags": ["save"]
  },
  {
    "name": "inbox",
    "categories": ["account","mail"],
    "tags": ["email"]
  },
  {
    "name": "indian-rupee",
    "categories": ["finance"],
    "tags": ["currency","money","payment"]
  },
  {
    "name": "infinity",
    "categories": ["multimedia"],
    "tags": ["unlimited","forever","loop","math"]
  },
  {
    "name": "info",
    "categories": ["accessibility","notifications"],
    "tags": ["help"]
  },
  {
    "name": "inspection-panel",
    "categories": ["tools"],
    "tags": ["access","cover","tile","metal","materials","screws"]
  },
  {
    "name": "instagram",
    "categories": ["brands","social","photography"],
    "tags": ["logo","camera","social"]
  },
  {
    "name": "italic",
    "categories": ["text"],
    "tags": ["oblique","text","format"]
  },
  {
    "name": "iteration-ccw",
    "categories": ["arrows","design"],
    "tags": ["arrow","right"]
  },
  {
    "name": "iteration-cw",
    "categories": ["arrows","design"],
    "tags": ["arrow","left"]
  },
  {
    "name": "japanese-yen",
    "categories": ["finance"],
    "tags": ["currency","money","payment"]
  },
  {
    "name": "joystick",
    "categories": ["gaming","devices"],
    "tags": ["game","console","control stick"]
  },
  {
    "name": "kanban",
    "categories": ["charts","development","design"],
    "tags": ["projects","manage","overview","board","tickets","issues","roadmap","plan","intentions","productivity","work","agile","code","coding"]
  },
  {
    "name": "kayak",
    "categories": ["transportation"],
    "tags": ["kayak","boat","paddle","water","sport","recreation","adventure","outdoors","equipment","lake","ocean"]
  },
  {
    "name": "key-round",
    "categories": ["security","account"],
    "tags": ["password","login","authentication","secure","unlock"]
  },
  {
    "name": "key-square",
    "categories": ["security","account"],
    "tags": ["password","login","authentication","secure","unlock","car key"]
  },
  {
    "name": "key",
    "categories": ["security","account"],
    "tags": ["password","login","authentication","secure","unlock","keychain","key ring","fob"]
  },
  {
    "name": "keyboard-music",
    "categories": ["multimedia","devices"],
    "tags": ["music","audio","sound","noise","notes","keys","chord","octave","midi","controller","instrument","electric","signal","digital","studio","production","producer","pianist","piano","play","performance","concert"]
  },
  {
    "name": "keyboard-off",
    "categories": ["devices","text","development"],
    "tags": ["unkeys","layout","spell","settings","mouse"]
  },
  {
    "name": "keyboard",
    "categories": ["text","devices","development"],
    "tags": ["layout","spell","settings","mouse"]
  },
  {
    "name": "lamp-ceiling",
    "categories": ["home"],
    "tags": ["lighting","household","home","furniture"]
  },
  {
    "name": "lamp-desk",
    "categories": ["home"],
    "tags": ["lighting","household","office","desk","home","furniture"]
  },
  {
    "name": "lamp-floor",
    "categories": ["home"],
    "tags": ["lighting","household","floor","home","furniture"]
  },
  {
    "name": "lamp-wall-down",
    "categories": ["home"],
    "tags": ["lighting","household","wall","home","furniture"]
  },
  {
    "name": "lamp-wall-up",
    "categories": ["home"],
    "tags": ["lighting","household","wall","home","furniture"]
  },
  {
    "name": "lamp",
    "categories": ["home"],
    "tags": ["lighting","household","home","furniture"]
  },
  {
    "name": "land-plot",
    "categories": ["design","tools","math","sports","gaming"],
    "tags": ["area","surface","square metres","allotment","parcel","property","plane","acres","measure","distance","isometric","flag","golf course","hole"]
  },
  {
    "name": "landmark",
    "categories": ["finance","navigation","buildings"],
    "tags": ["bank","building","capitol","finance","money","museum","art gallery","hall","institute","pediment","portico","columns","pillars","classical","architecture","government","institution"]
  },
  {
    "name": "languages",
    "categories": ["text"],
    "tags": ["translate"]
  },
  {
    "name": "laptop-minimal-check",
    "categories": ["devices","notifications"],
    "tags": ["computer","screen","remote","success","done","todo","tick","complete","task"]
  },
  {
    "name": "laptop-minimal",
    "categories": ["devices"],
    "tags": ["computer","screen","remote"]
  },
  {
    "name": "laptop",
    "categories": ["devices"],
    "tags": ["computer","screen","remote"]
  },
  {
    "name": "lasso-select",
    "categories": ["arrows","design","cursors"],
    "tags": ["select","cursor"]
  },
  {
    "name": "lasso",
    "categories": ["design","cursors"],
    "tags": ["select","cursor"]
  },
  {
    "name": "laugh",
    "categories": ["emoji"],
    "tags": ["emoji","face","happy","good","emotion"]
  },
  {
    "name": "layers-2",
    "categories": ["design","layout"],
    "tags": ["stack","pile","pages","sheets","paperwork","copies","copy","duplicate","double","shortcuts"]
  },
  {
    "name": "layers-plus",
    "categories": ["design","layout"],
    "tags": ["stack","layers","add","new","increase","create","positive","copy","upgrade"]
  },
  {
    "name": "layers",
    "categories": ["design","layout"],
    "tags": ["stack","pile","pages","sheets","paperwork","copies","copy"]
  },
  {
    "name": "layout-dashboard",
    "categories": ["design","layout"],
    "tags": ["masonry","brick"]
  },
  {
    "name": "layout-grid",
    "categories": ["design","layout"],
    "tags": ["app","home","start"]
  },
  {
    "name": "layout-list",
    "categories": ["design","layout","photography","text"],
    "tags": ["todo","tasks","items","pending","image","photo"]
  },
  {
    "name": "layout-panel-left",
    "categories": ["design","layout"],
    "tags": ["app","home","start","grid"]
  },
  {
    "name": "layout-panel-top",
    "categories": ["layout"],
    "tags": ["window","webpage","block","section","grid","template","structure"]
  },
  {
    "name": "layout-template",
    "categories": ["layout"],
    "tags": ["window","webpage","block","section"]
  },
  {
    "name": "leaf",
    "categories": ["nature","sustainability","seasons"],
    "tags": ["sustainability","nature","energy","plant","autumn"]
  },
  {
    "name": "leafy-green",
    "categories": ["food-beverage","emoji","sustainability"],
    "tags": ["salad","lettuce","vegetable","chard","cabbage","bok choy"]
  },
  {
    "name": "lectern",
    "categories": ["communication","multimedia"],
    "tags": ["pulpit","podium","stand"]
  },
  {
    "name": "library-big",
    "categories": ["text","photography","multimedia","navigation","development"],
    "tags": ["books","reading","written","authors","stories","fiction","novels","information","knowledge","education","high school","university","college","academy","learning","study","research","collection","vinyl","records","albums","music","package"]
  },
  {
    "name": "library",
    "categories": ["text","photography","multimedia","navigation","development"],
    "tags": ["books","reading","written","authors","stories","fiction","novels","information","knowledge","education","high school","university","college","academy","learning","study","research","collection","vinyl","records","albums","music","package"]
  },
  {
    "name": "life-buoy",
    "categories": ["accessibility","medical"],
    "tags": ["preserver","life belt","lifesaver","help","rescue","ship","ring","raft","inflatable","wheel","donut"]
  },
  {
    "name": "ligature",
    "categories": ["text"],
    "tags": ["text","font","typography","alternates","alternatives"]
  },
  {
    "name": "lightbulb-off",
    "categories": ["photography"],
    "tags": ["lights"]
  },
  {
    "name": "lightbulb",
    "categories": ["photography"],
    "tags": ["idea","bright","lights"]
  },
  {
    "name": "line-squiggle",
    "categories": ["shapes","math","design"],
    "tags": ["line","snakes","annotate","curve","doodle","stroke","pen","tool","gesture","draw","wave","art","road"]
  },
  {
    "name": "link-2-off",
    "categories": ["text"],
    "tags": ["unchain","chain"]
  },
  {
    "name": "link-2",
    "categories": ["text","account"],
    "tags": ["chain","url"]
  },
  {
    "name": "link",
    "categories": ["text","account"],
    "tags": ["chain","url"]
  },
  {
    "name": "linkedin",
    "categories": ["social","brands"],
    "tags": ["logo","social media","social"]
  },
  {
    "name": "list-check",
    "categories": ["text"],
    "tags": ["done","check","tick","complete","list","to-do","bom"]
  },
  {
    "name": "list-checks",
    "categories": ["text"],
    "tags": ["todo","done","check","tick","complete","tasks","items","pending"]
  },
  {
    "name": "list-chevrons-down-up",
    "categories": ["text","arrows"],
    "tags": ["options","items","collapse","expand","details","disclosure","show","hide","toggle","accordion","more","less","fold","unfold","vertical"]
  },
  {
    "name": "list-chevrons-up-down",
    "categories": ["text","arrows"],
    "tags": ["options","items","collapse","expand","details","disclosure","show","hide","toggle","accordion","more","less","fold","unfold","vertical"]
  },
  {
    "name": "list-collapse",
    "categories": ["text"],
    "tags": ["items","collapse","expand","details","disclosure","show","hide","toggle","accordion","more","less","fold","unfold"]
  },
  {
    "name": "list-end",
    "categories": ["multimedia","text"],
    "tags": ["queue","bottom","end","playlist"]
  },
  {
    "name": "list-filter-plus",
    "categories": ["text","layout"],
    "tags": ["filter","plus","options","add"]
  },
  {
    "name": "list-filter",
    "categories": ["text"],
    "tags": ["options"]
  },
  {
    "name": "list-indent-decrease",
    "categories": ["text","development"],
    "tags": ["text","tab"]
  },
  {
    "name": "list-indent-increase",
    "categories": ["text","development"],
    "tags": ["text","tab"]
  },
  {
    "name": "list-minus",
    "categories": ["multimedia","text"],
    "tags": ["playlist","remove","song","subtract","delete","unqueue"]
  },
  {
    "name": "list-music",
    "categories": ["multimedia"],
    "tags": ["playlist","queue","music","audio","playback"]
  },
  {
    "name": "list-ordered",
    "categories": ["text"],
    "tags": ["number","order","queue"]
  },
  {
    "name": "list-plus",
    "categories": ["multimedia","text"],
    "tags": ["playlist","add","song","track","new"]
  },
  {
    "name": "list-restart",
    "categories": ["multimedia","text"],
    "tags": ["reset","refresh","reload","playlist","replay"]
  },
  {
    "name": "list-start",
    "categories": ["multimedia","text"],
    "tags": ["queue","top","start","next","playlist"]
  },
  {
    "name": "list-todo",
    "categories": ["text"],
    "tags": ["todo","done","check","tick","complete","tasks","items","pending"]
  },
  {
    "name": "list-tree",
    "categories": ["files","text","layout"],
    "tags": ["tree","browser"]
  },
  {
    "name": "list-video",
    "categories": ["multimedia"],
    "tags": ["playlist","video","playback"]
  },
  {
    "name": "list-x",
    "categories": ["multimedia","text"],
    "tags": ["playlist","subtract","remove","delete","unqueue"]
  },
  {
    "name": "list",
    "categories": ["text"],
    "tags": ["options"]
  },
  {
    "name": "loader-circle",
    "categories": ["cursors","multimedia","layout"],
    "tags": ["loading","wait","busy","progress","spinner","spinning","throbber","circle"]
  },
  {
    "name": "loader-pinwheel",
    "categories": ["cursors","design"],
    "tags": ["loading","wait","busy","progress","throbber","spinner","spinning","beach ball","frozen","freeze"]
  },
  {
    "name": "loader",
    "categories": ["cursors","multimedia","layout","design"],
    "tags": ["loading","wait","busy","progress","spinner","spinning","throbber"]
  },
  {
    "name": "locate-fixed",
    "categories": ["navigation"],
    "tags": ["map","gps","location","cross"]
  },
  {
    "name": "locate-off",
    "categories": ["navigation"],
    "tags": ["map","gps","location","cross"]
  },
  {
    "name": "locate",
    "categories": ["navigation"],
    "tags": ["map","gps","location","cross"]
  },
  {
    "name": "lock-keyhole-open",
    "categories": ["security"],
    "tags": ["security"]
  },
  {
    "name": "lock-keyhole",
    "categories": ["security"],
    "tags": ["security","password","secure","admin"]
  },
  {
    "name": "lock-open",
    "categories": ["security"],
    "tags": ["security"]
  },
  {
    "name": "lock",
    "categories": ["security"],
    "tags": ["security","password","secure","admin"]
  },
  {
    "name": "log-in",
    "categories": ["arrows","account"],
    "tags": ["sign in","arrow","enter","auth"]
  },
  {
    "name": "log-out",
    "categories": ["arrows","account"],
    "tags": ["sign out","arrow","exit","auth"]
  },
  {
    "name": "logs",
    "categories": ["text"],
    "tags": ["options","list","menu","order","queue","tasks","logs"]
  },
  {
    "name": "lollipop",
    "categories": ["food-beverage"],
    "tags": ["lolly","candy","sugar","food","sweet","dessert","spiral"]
  },
  {
    "name": "luggage",
    "categories": ["travel","transportation"],
    "tags": ["baggage","luggage","travel","suitcase"]
  },
  {
    "name": "magnet",
    "categories": ["design"],
    "tags": ["horseshoe","lock","science","snap"]
  },
  {
    "name": "mail-check",
    "categories": ["mail"],
    "tags": ["email","message","letter","subscribe","delivered","success","read","done","todo","tick","complete","task"]
  },
  {
    "name": "mail-minus",
    "categories": ["mail"],
    "tags": ["email","message","letter","remove","delete"]
  },
  {
    "name": "mail-open",
    "categories": ["mail"],
    "tags": ["email","message","letter","read"]
  },
  {
    "name": "mail-plus",
    "categories": ["mail"],
    "tags": ["email","message","letter","add","create","new","compose"]
  },
  {
    "name": "mail-question-mark",
    "categories": ["mail"],
    "tags": ["email","message","letter","delivery","undelivered"]
  },
  {
    "name": "mail-search",
    "categories": ["mail"],
    "tags": ["email","message","letter","search","lens"]
  },
  {
    "name": "mail-warning",
    "categories": ["mail"],
    "tags": ["email","message","letter","delivery error","exclamation mark"]
  },
  {
    "name": "mail-x",
    "categories": ["mail"],
    "tags": ["email","message","letter","remove","delete"]
  },
  {
    "name": "mail",
    "categories": ["text","account","mail"],
    "tags": ["email","message","letter","unread"]
  },
  {
    "name": "mailbox",
    "categories": ["mail"],
    "tags": ["emails","messages","letters","mailing list","newsletter"]
  },
  {
    "name": "mails",
    "categories": ["mail"],
    "tags": ["emails","messages","letters","multiple","mailing list","newsletter","copy"]
  },
  {
    "name": "map-minus",
    "categories": ["navigation","travel"],
    "tags": ["location","navigation","travel","drop","delete","remove","erase"]
  },
  {
    "name": "map-pin-check-inside",
    "categories": ["navigation","travel","account"],
    "tags": ["location","waypoint","marker","drop","done","tick","complete","task","added"]
  },
  {
    "name": "map-pin-check",
    "categories": ["navigation","travel","account"],
    "tags": ["location","waypoint","marker","drop","done","tick","complete","task","added"]
  },
  {
    "name": "map-pin-house",
    "categories": ["navigation","travel","account"],
    "tags": ["location","waypoint","marker","drop","home","living","building","residence","architecture","address","poi","real estate","property","navigation","destination","geolocation","place","landmark"]
  },
  {
    "name": "map-pin-minus-inside",
    "categories": ["navigation","travel","account"],
    "tags": ["location","waypoint","marker","drop","delete","remove","erase"]
  },
  {
    "name": "map-pin-minus",
    "categories": ["navigation","travel","account"],
    "tags": ["location","waypoint","marker","drop","delete","remove","erase"]
  },
  {
    "name": "map-pin-off",
    "categories": ["navigation","travel"],
    "tags": ["location","waypoint","marker","remove"]
  },
  {
    "name": "map-pin-pen",
    "categories": ["navigation","travel","account"],
    "tags": ["location","waypoint","marker","drop","edit"]
  },
  {
    "name": "map-pin-plus-inside",
    "categories": ["navigation","travel","account"],
    "tags": ["location","waypoint","marker","drop","add","create","new"]
  },
  {
    "name": "map-pin-plus",
    "categories": ["navigation","travel","account"],
    "tags": ["location","waypoint","marker","drop","add","create","new"]
  },
  {
    "name": "map-pin-x-inside",
    "categories": ["navigation","travel","account"],
    "tags": ["location","waypoint","marker","drop","delete","remove","erase"]
  },
  {
    "name": "map-pin-x",
    "categories": ["navigation","travel","account"],
    "tags": ["location","waypoint","marker","drop","delete","remove","erase"]
  },
  {
    "name": "map-pin",
    "categories": ["navigation","travel","account"],
    "tags": ["location","waypoint","marker","drop"]
  },
  {
    "name": "map-pinned",
    "categories": ["navigation","travel","account"],
    "tags": ["location","waypoint","marker","drop"]
  },
  {
    "name": "map-plus",
    "categories": ["navigation"],
    "tags": ["location","navigation","travel","new","add","create"]
  },
  {
    "name": "map",
    "categories": ["text","navigation"],
    "tags": ["location","navigation","travel"]
  },
  {
    "name": "mars-stroke",
    "categories": ["medical"],
    "tags": ["gender","androgyne","transgender"]
  },
  {
    "name": "mars",
    "categories": ["medical"],
    "tags": ["gender","sex","male","masculine","man","boy"]
  },
  {
    "name": "martini",
    "categories": ["food-beverage"],
    "tags": ["cocktail","alcohol","beverage","bar","drink","glass"]
  },
  {
    "name": "maximize-2",
    "categories": ["arrows","layout","design"],
    "tags": ["fullscreen","arrows","expand"]
  },
  {
    "name": "maximize",
    "categories": ["layout","design"],
    "tags": ["fullscreen","expand","dashed"]
  },
  {
    "name": "medal",
    "categories": ["sports","gaming"],
    "tags": ["prize","sports","winner","trophy","award","achievement"]
  },
  {
    "name": "megaphone-off",
    "categories": ["multimedia","notifications"],
    "tags": ["advertisement","announcement","attention","alert","loudspeaker","megaphone","notification","disable","silent"]
  },
  {
    "name": "megaphone",
    "categories": ["multimedia","notifications"],
    "tags": ["advertisement","announcement","attention","alert","loudspeaker","megaphone","notification"]
  },
  {
    "name": "meh",
    "categories": ["emoji"],
    "tags": ["emoji","face","neutral","emotion"]
  },
  {
    "name": "memory-stick",
    "categories": ["devices","gaming"],
    "tags": ["ram","random access","technology","computer","chip","circuit","specs","capacity","gigabytes","gb"]
  },
  {
    "name": "menu",
    "categories": ["layout","account"],
    "tags": ["bars","navigation","hamburger","options"]
  },
  {
    "name": "merge",
    "categories": ["development","arrows"],
    "tags": ["combine","join","unite"]
  },
  {
    "name": "message-circle-code",
    "categories": ["development","social"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubble","code review","coding"]
  },
  {
    "name": "message-circle-dashed",
    "categories": ["social"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubble","draft"]
  },
  {
    "name": "message-circle-heart",
    "categories": ["social"],
    "tags": ["comment","chat","conversation","dialog","feedback","positive","like","love","interest","valentine","dating","date","speech bubble"]
  },
  {
    "name": "message-circle-more",
    "categories": ["social"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubble","typing","writing","responding","ellipsis","etc","et cetera","...","…"]
  },
  {
    "name": "message-circle-off",
    "categories": ["social"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubble","clear","close","delete","remove","cancel","silence","mute","moderate"]
  },
  {
    "name": "message-circle-plus",
    "categories": ["social"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubble","add"]
  },
  {
    "name": "message-circle-question-mark",
    "categories": ["social"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubble","help"]
  },
  {
    "name": "message-circle-reply",
    "categories": ["social"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubble","reply","response"]
  },
  {
    "name": "message-circle-warning",
    "categories": ["social","notifications"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubble","report","abuse","offense","alert","danger","caution","protected","exclamation mark"]
  },
  {
    "name": "message-circle-x",
    "categories": ["account","social"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubble","clear","close","delete","remove","cancel","silence","mute","moderate"]
  },
  {
    "name": "message-circle",
    "categories": ["social"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubble"]
  },
  {
    "name": "message-square-code",
    "categories": ["development","social"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubble","code review","coding"]
  },
  {
    "name": "message-square-dashed",
    "categories": ["social"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubble","draft"]
  },
  {
    "name": "message-square-diff",
    "categories": ["development","files","social"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubble","add","patch","difference","plus","minus","plus-minus","math","code review","coding","version control","git"]
  },
  {
    "name": "message-square-dot",
    "categories": ["social","notifications"],
    "tags": ["unread","unresolved","comment","chat","conversation","dialog","feedback","speech bubble"]
  },
  {
    "name": "message-square-heart",
    "categories": ["social"],
    "tags": ["comment","chat","conversation","dialog","feedback","positive","like","love","interest","valentine","dating","date","speech bubble"]
  },
  {
    "name": "message-square-lock",
    "categories": ["social"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubble","secure","encrypted"]
  },
  {
    "name": "message-square-more",
    "categories": ["social"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubble","typing","writing","responding","ellipsis","etc","et cetera","...","…"]
  },
  {
    "name": "message-square-off",
    "categories": ["social"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubble","clear","close","delete","remove","cancel","silence","mute","moderate"]
  },
  {
    "name": "message-square-plus",
    "categories": ["social"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubble","add"]
  },
  {
    "name": "message-square-quote",
    "categories": ["social","text"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubble","blockquote","quotation","indent","reply","response"]
  },
  {
    "name": "message-square-reply",
    "categories": ["social"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubble","reply","response"]
  },
  {
    "name": "message-square-share",
    "categories": ["social"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubble","network","forward"]
  },
  {
    "name": "message-square-text",
    "categories": ["social"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubble"]
  },
  {
    "name": "message-square-warning",
    "categories": ["social","notifications"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubble","report","abuse","offense","alert","danger","caution","protected","exclamation mark"]
  },
  {
    "name": "message-square-x",
    "categories": ["social"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubble","clear","close","delete","remove","cancel","silence","mute","moderate"]
  },
  {
    "name": "message-square",
    "categories": ["social"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubble"]
  },
  {
    "name": "messages-square",
    "categories": ["social"],
    "tags": ["comment","chat","conversation","dialog","feedback","speech bubbles","copy","multiple","discussion","interview","debate"]
  },
  {
    "name": "mic-off",
    "categories": ["devices","communication","connectivity","multimedia"],
    "tags": ["record","sound","mute","microphone"]
  },
  {
    "name": "mic-vocal",
    "categories": ["devices","multimedia"],
    "tags": ["lyrics","voice","listen","sound","music","radio","podcast","karaoke","singing","microphone"]
  },
  {
    "name": "mic",
    "categories": ["devices","communication","connectivity","multimedia"],
    "tags": ["record","sound","listen","radio","podcast","microphone"]
  },
  {
    "name": "microchip",
    "categories": ["devices"],
    "tags": ["processor","cores","technology","computer","chip","integrated circuit","memory","ram","specs","gpu","gigahertz","ghz"]
  },
  {
    "name": "microscope",
    "categories": ["science","medical"],
    "tags": ["medical","education","science","imaging","research"]
  },
  {
    "name": "microwave",
    "categories": ["food-beverage","home"],
    "tags": ["oven","cooker","toaster oven","bake"]
  },
  {
    "name": "milestone",
    "categories": ["arrows","navigation","development","gaming"],
    "tags": ["signpost","direction","right","east","forward","version control","waypoint"]
  },
  {
    "name": "milk-off",
    "categories": ["food-beverage"],
    "tags": ["lactose free","bottle","beverage","drink","water","allergy","intolerance","diet"]
  },
  {
    "name": "milk",
    "categories": ["food-beverage"],
    "tags": ["lactose","bottle","beverage","drink","water","diet"]
  },
  {
    "name": "minimize-2",
    "categories": ["arrows","layout","design"],
    "tags": ["exit fullscreen","arrows","close","shrink"]
  },
  {
    "name": "minimize",
    "categories": ["layout","design"],
    "tags": ["exit fullscreen","close","shrink"]
  },
  {
    "name": "minus",
    "categories": ["math","development","text","tools"],
    "tags": ["subtract","remove","decrease","decrement","reduce","negative","calculate","line","divider","separator","horizontal rule","hr","html","markup","markdown","---","toolbar","operator","code","coding","minimum","downgrade"]
  },
  {
    "name": "monitor-check",
    "categories": ["connectivity","devices"],
    "tags": ["tv","screen","display","desktop","running","active","virtual machine","vm"]
  },
  {
    "name": "monitor-cloud",
    "categories": ["connectivity","devices","development"],
    "tags": ["virtual machine","virtual desktop","vm","vdi","computing","remote work","monitoring","infrastructure","software as a service","saas","workstation","environment","tv","screen","display"]
  },
  {
    "name": "monitor-cog",
    "categories": ["connectivity","devices"],
    "tags": ["tv","screen","display","virtual machine","vm","executable","settings","cog","edit","gear","configuration","preferences","system","control panel","network","computing"]
  },
  {
    "name": "monitor-dot",
    "categories": ["connectivity","devices"],
    "tags": ["tv","screen","display","desktop","running","active","virtual machine","vm"]
  },
  {
    "name": "monitor-down",
    "categories": ["connectivity","devices"],
    "tags": ["tv","screen","display","desktop","download"]
  },
  {
    "name": "monitor-off",
    "categories": ["connectivity","devices"],
    "tags": ["share"]
  },
  {
    "name": "monitor-pause",
    "categories": ["connectivity","devices","multimedia"],
    "tags": ["tv","screen","display","desktop","video","movie","film","suspend","hibernate","boot","virtual machine","vm"]
  },
  {
    "name": "monitor-play",
    "categories": ["connectivity","devices","multimedia"],
    "tags": ["tv","screen","display","desktop","video","movie","film","running","start","boot","virtual machine","vm"]
  },
  {
    "name": "monitor-smartphone",
    "categories": ["connectivity","devices"],
    "tags": ["smartphone","phone","cellphone","device","mobile","desktop","monitor","responsive","screens"]
  },
  {
    "name": "monitor-speaker",
    "categories": ["connectivity","devices"],
    "tags": ["devices","connect","cast"]
  },
  {
    "name": "monitor-stop",
    "categories": ["connectivity","devices","multimedia"],
    "tags": ["tv","screen","display","desktop","video","movie","film","stop","shutdown","virtual machine","vm"]
  },
  {
    "name": "monitor-up",
    "categories": ["connectivity","devices"],
    "tags": ["tv","screen","display","upload","connect","remote","screen share"]
  },
  {
    "name": "monitor-x",
    "categories": ["connectivity","devices"],
    "tags": ["tv","screen","display","desktop","virtual machine","vm","close","stop","suspend","remove","delete"]
  },
  {
    "name": "monitor",
    "categories": ["connectivity","devices"],
    "tags": ["tv","screen","display","virtual machine","vm"]
  },
  {
    "name": "moon-star",
    "categories": ["accessibility","weather"],
    "tags": ["dark","night","star"]
  },
  {
    "name": "moon",
    "categories": ["accessibility"],
    "tags": ["dark","night"]
  },
  {
    "name": "motorbike",
    "categories": ["transportation"],
    "tags": ["moto","motorcycle","transport","vehicle","drive","ride","trip","race","racing","journey","delivery"]
  },
  {
    "name": "mountain-snow",
    "categories": ["nature"],
    "tags": ["alpine","climb","snow"]
  },
  {
    "name": "mountain",
    "categories": ["nature","gaming"],
    "tags": ["climb","hike","rock"]
  },
  {
    "name": "mouse-off",
    "categories": ["devices"],
    "tags": ["device","scroll","click","disabled"]
  },
  {
    "name": "mouse-pointer-2-off",
    "categories": ["arrows","cursors"],
    "tags": ["pointer","mouse","cursor","off","disable","arrow","navigation","selection","select","click","no-click","interaction"]
  },
  {
    "name": "mouse-pointer-2",
    "categories": ["arrows","cursors"],
    "tags": ["click","select"]
  },
  {
    "name": "mouse-pointer-ban",
    "categories": ["arrows","cursors"],
    "tags": ["wait","busy","loading","blocked","frozen","freeze"]
  },
  {
    "name": "mouse-pointer-click",
    "categories": ["arrows","cursors"],
    "tags": ["click","select"]
  },
  {
    "name": "mouse-pointer",
    "categories": ["arrows","cursors"],
    "tags": ["click","select"]
  },
  {
    "name": "mouse",
    "categories": ["devices"],
    "tags": ["device","scroll","click"]
  },
  {
    "name": "move-3d",
    "categories": ["design"],
    "tags": ["arrows","axis","gizmo","coordinates","transform","translate"]
  },
  {
    "name": "move-diagonal-2",
    "categories": ["arrows","cursors"],
    "tags": ["double","arrow"]
  },
  {
    "name": "move-diagonal",
    "categories": ["arrows","cursors"],
    "tags": ["double","arrow"]
  },
  {
    "name": "move-down-left",
    "categories": ["arrows"],
    "tags": ["arrow","direction"]
  },
  {
    "name": "move-down-right",
    "categories": ["arrows"],
    "tags": ["arrow","direction"]
  },
  {
    "name": "move-down",
    "categories": ["arrows"],
    "tags": ["arrow","direction","downwards","south"]
  },
  {
    "name": "move-horizontal",
    "categories": ["arrows","cursors"],
    "tags": ["double","arrow"]
  },
  {
    "name": "move-left",
    "categories": ["arrows"],
    "tags": ["arrow","direction","back","west"]
  },
  {
    "name": "move-right",
    "categories": ["arrows"],
    "tags": ["arrow","direction","trend flat","east"]
  },
  {
    "name": "move-up-left",
    "categories": ["arrows"],
    "tags": ["arrow","direction"]
  },
  {
    "name": "move-up-right",
    "categories": ["arrows"],
    "tags": ["arrow","direction"]
  },
  {
    "name": "move-up",
    "categories": ["arrows"],
    "tags": ["arrow","direction","upwards","north"]
  },
  {
    "name": "move-vertical",
    "categories": ["arrows","cursors"],
    "tags": ["double","arrow"]
  },
  {
    "name": "move",
    "categories": ["arrows","cursors"],
    "tags": ["arrows"]
  },
  {
    "name": "music-2",
    "categories": ["multimedia","files"],
    "tags": ["quaver","eighth note","note"]
  },
  {
    "name": "music-3",
    "categories": ["multimedia","files"],
    "tags": ["crotchet","minim","quarter note","half note","note"]
  },
  {
    "name": "music-4",
    "categories": ["multimedia","files"],
    "tags": ["semiquaver","sixteenth note","note"]
  },
  {
    "name": "music",
    "categories": ["multimedia","files"],
    "tags": ["note","quaver","eighth note"]
  },
  {
    "name": "navigation-2-off",
    "categories": ["navigation"],
    "tags": ["location","travel"]
  },
  {
    "name": "navigation-2",
    "categories": ["navigation"],
    "tags": ["location","travel"]
  },
  {
    "name": "navigation-off",
    "categories": ["navigation"],
    "tags": ["location","travel"]
  },
  {
    "name": "navigation",
    "categories": ["navigation"],
    "tags": ["location","travel"]
  },
  {
    "name": "network",
    "categories": ["development"],
    "tags": ["tree"]
  },
  {
    "name": "newspaper",
    "categories": ["multimedia","communication"],
    "tags": ["news","feed","home","magazine","article","headline"]
  },
  {
    "name": "nfc",
    "categories": ["communication","finance","devices"],
    "tags": ["contactless","payment","near-field communication"]
  },
  {
    "name": "non-binary",
    "categories": ["medical"],
    "tags": ["gender","nonbinary","enby"]
  },
  {
    "name": "notebook-pen",
    "categories": ["text","social"],
    "tags": ["pencil","notepad","notes","noted","stationery","sketchbook","organizer","organiser","planner","diary","journal","writing","write","written","reading","high school","university","college","academy","student","study","research","homework","eraser","rubber"]
  },
  {
    "name": "notebook-tabs",
    "categories": ["account","communication","social"],
    "tags": ["notepad","notes","people","family","friends","acquaintances","contacts","details","addresses","phone numbers","directory","listing","networking","alphabetical","a-z","organizer","organiser","planner","diary","stationery"]
  },
  {
    "name": "notebook-text",
    "categories": ["text","social"],
    "tags": ["notepad","notes","pages","paper","stationery","sketchbook","organizer","organiser","planner","diary","journal","writing","write","written","reading","high school","university","college","academy","student","study","research","homework","lines","opened"]
  },
  {
    "name": "notebook",
    "categories": ["text","communication","social","design"],
    "tags": ["notepad","notes","stationery","sketchbook","moleskine","closure","strap","band","elastic","organizer","organiser","planner","diary","journal","writing","written","writer","reading","high school","university","college","academy","student","study","homework","research"]
  },
  {
    "name": "notepad-text-dashed",
    "categories": ["text","social"],
    "tags": ["notebook","notes","pages","paper","stationery","diary","journal","writing","write","written","draft","template","lines"]
  },
  {
    "name": "notepad-text",
    "categories": ["text","social"],
    "tags": ["notebook","notes","pages","paper","stationery","sketchbook","organizer","organiser","planner","diary","journal","writing","write","written","reading","high school","university","college","academy","student","study","homework","research","lines","opened"]
  },
  {
    "name": "nut-off",
    "categories": ["food-beverage"],
    "tags": ["hazelnut","acorn","food","allergy","intolerance","diet"]
  },
  {
    "name": "nut",
    "categories": ["food-beverage"],
    "tags": ["hazelnut","acorn","food","diet"]
  },
  {
    "name": "octagon-alert",
    "categories": ["notifications","shapes"],
    "tags": ["warning","alert","danger","exclamation mark"]
  },
  {
    "name": "octagon-minus",
    "categories": ["transportation"],
    "tags": ["stop","forbidden","subtract","remove","decrease","reduce","-","traffic","halt","restricted"]
  },
  {
    "name": "octagon-pause",
    "categories": ["multimedia","shapes"],
    "tags": ["music","audio","stop"]
  },
  {
    "name": "octagon-x",
    "categories": ["math","notifications"],
    "tags": ["delete","stop","alert","warning","times","clear","math"]
  },
  {
    "name": "octagon",
    "categories": ["shapes"],
    "tags": ["stop","shape"]
  },
  {
    "name": "omega",
    "categories": ["math","development","text","science"],
    "tags": ["greek","symbol","mathematics","education","physics","engineering","ohms","electrical resistance","angular frequency","dynamical systems","astronomy","constellations","philosophy"]
  },
  {
    "name": "option",
    "categories": ["development"],
    "tags": ["keyboard","key","mac","alt","button"]
  },
  {
    "name": "orbit",
    "categories": ["science"],
    "tags": ["planet","space","physics","satellites","moons"]
  },
  {
    "name": "origami",
    "categories": ["animals","design"],
    "tags": ["paper","bird"]
  },
  {
    "name": "package-2",
    "categories": ["files","development"],
    "tags": ["box","container","storage","sealed","packed","unopened","undelivered","archive","zip"]
  },
  {
    "name": "package-check",
    "categories": ["development"],
    "tags": ["confirm","verified","done","todo","tick","complete","task","delivered"]
  },
  {
    "name": "package-minus",
    "categories": ["development"],
    "tags": ["delete","remove"]
  },
  {
    "name": "package-open",
    "categories": ["files","development"],
    "tags": ["box","container","storage","unpack","unarchive","unzip","opened","delivered"]
  },
  {
    "name": "package-plus",
    "categories": ["development"],
    "tags": ["new","add","create"]
  },
  {
    "name": "package-search",
    "categories": ["files","development"],
    "tags": ["find","product process","lens"]
  },
  {
    "name": "package-x",
    "categories": ["development"],
    "tags": ["delete","remove"]
  },
  {
    "name": "package",
    "categories": ["files","development"],
    "tags": ["box","container","storage","sealed","delivery","undelivered","unopened","packed","archive","zip","module"]
  },
  {
    "name": "paint-bucket",
    "categories": ["design","tools"],
    "tags": ["fill","paint","bucket","color","colour"]
  },
  {
    "name": "paint-roller",
    "categories": ["text","design","home","tools"],
    "tags": ["brush","color","colour","decoration","diy"]
  },
  {
    "name": "paintbrush-vertical",
    "categories": ["text","design","photography","home","tools"],
    "tags": ["brush","paintbrush","design","color","colour","decoration","diy"]
  },
  {
    "name": "paintbrush",
    "categories": ["text","design","photography","home","tools"],
    "tags": ["brush","paintbrush","design","color","colour","decoration","diy"]
  },
  {
    "name": "palette",
    "categories": ["text","design","photography"],
    "tags": ["colors","colours","theme","scheme","paint","watercolor","watercolour","artist"]
  },
  {
    "name": "panda",
    "categories": ["animals"],
    "tags": ["animal","wildlife","bear","zoo","bamboo"]
  },
  {
    "name": "panel-bottom-close",
    "categories": ["layout","arrows"],
    "tags": ["drawer","dock","hide","chevron","down"]
  },
  {
    "name": "panel-bottom-dashed",
    "categories": ["layout"],
    "tags": ["drawer","dock","show","reveal","padding","margin","guide","layout","bleed"]
  },
  {
    "name": "panel-bottom-open",
    "categories": ["layout","arrows"],
    "tags": ["drawer","dock","show","reveal","chevron","up"]
  },
  {
    "name": "panel-bottom",
    "categories": ["layout"],
    "tags": ["drawer","dock"]
  },
  {
    "name": "panel-left-close",
    "categories": ["layout","arrows"],
    "tags": ["primary","drawer","hide","chevron","<"]
  },
  {
    "name": "panel-left-dashed",
    "categories": ["layout"],
    "tags": ["sidebar","primary","drawer","show","reveal","padding","margin","guide","layout","bleed"]
  },
  {
    "name": "panel-left-open",
    "categories": ["layout","arrows"],
    "tags": ["primary","drawer","show","reveal","chevron","right",">"]
  },
  {
    "name": "panel-left-right-dashed",
    "categories": ["layout"],
    "tags": ["sidebar","primary","drawer","show","reveal","padding","margin","guide","layout","vertical","bleed"]
  },
  {
    "name": "panel-left",
    "categories": ["layout"],
    "tags": ["primary","drawer"]
  },
  {
    "name": "panel-right-close",
    "categories": ["layout","arrows"],
    "tags": ["sidebar","secondary","drawer","hide","chevron",">"]
  },
  {
    "name": "panel-right-dashed",
    "categories": ["layout"],
    "tags": ["sidebar","secondary","drawer","show","reveal","padding","margin","guide","layout","bleed"]
  },
  {
    "name": "panel-right-open",
    "categories": ["layout","arrows"],
    "tags": ["sidebar","secondary","drawer","show","reveal","chevron","left","<"]
  },
  {
    "name": "panel-right",
    "categories": ["layout"],
    "tags": ["sidebar","secondary","drawer"]
  },
  {
    "name": "panel-top-bottom-dashed",
    "categories": ["layout"],
    "tags": ["sidebar","primary","drawer","show","reveal","padding","margin","guide","layout","horizontal","bleed"]
  },
  {
    "name": "panel-top-close",
    "categories": ["layout","arrows"],
    "tags": ["menu bar","drawer","hide","chevron","up"]
  },
  {
    "name": "panel-top-dashed",
    "categories": ["layout"],
    "tags": ["menu bar","drawer","show","reveal","padding","margin","guide","layout","bleed"]
  },
  {
    "name": "panel-top-open",
    "categories": ["layout","arrows"],
    "tags": ["menu bar","drawer","show","reveal","chevron","down"]
  },
  {
    "name": "panel-top",
    "categories": ["layout","design","development"],
    "tags": ["drawer","browser","webpage"]
  },
  {
    "name": "panels-left-bottom",
    "categories": ["layout"],
    "tags": ["drawers","sidebar","primary"]
  },
  {
    "name": "panels-right-bottom",
    "categories": ["layout"],
    "tags": ["drawers","sidebar","secondary"]
  },
  {
    "name": "panels-top-left",
    "categories": ["layout","design","development"],
    "tags": ["menu bar","sidebar","primary","drawers","window","webpage","projects","overview"]
  },
  {
    "name": "paperclip",
    "categories": ["text","design","files","mail"],
    "tags": ["attachment","file"]
  },
  {
    "name": "parentheses",
    "categories": ["development","files","math"],
    "tags": ["code","token","parenthesis","parens","brackets","parameters","arguments","args","input","call","math","formula","function","(",")"]
  },
  {
    "name": "parking-meter",
    "categories": ["transportation","navigation"],
    "tags": ["driving","car park","pay","sidewalk","pavement"]
  },
  {
    "name": "party-popper",
    "categories": ["emoji"],
    "tags": ["emoji","congratulations","celebration","party","tada","🎉","🎊","excitement","exciting","excites","confetti"]
  },
  {
    "name": "pause",
    "categories": ["multimedia"],
    "tags": ["music","stop"]
  },
  {
    "name": "paw-print",
    "categories": ["animals"],
    "tags": ["pets","vets","veterinarian","domesticated","cat","dog","bear"]
  },
  {
    "name": "pc-case",
    "categories": ["devices","gaming"],
    "tags": ["computer","chassis"]
  },
  {
    "name": "pen-line",
    "categories": ["text","design","tools"],
    "tags": ["pencil","change","create","draw","writer","writing","biro","ink","marker","felt tip","stationery","artist"]
  },
  {
    "name": "pen-off",
    "categories": ["text","design","tools"],
    "tags": ["disabled","inactive","non-editable","locked","read-only","unmodifiable","frozen","restricted","pencil","change","create","draw","writer","writing","biro","ink","marker","felt tip","stationery","artist"]
  },
  {
    "name": "pen-tool",
    "categories": ["text","design","cursors"],
    "tags": ["vector","drawing","path"]
  },
  {
    "name": "pen",
    "categories": ["text","design","tools"],
    "tags": ["pencil","change","create","draw","writer","writing","biro","ink","marker","felt tip","stationery","artist"]
  },
  {
    "name": "pencil-line",
    "categories": ["text","design","tools"],
    "tags": ["pencil","change","create","draw","sketch","draft","writer","writing","biro","ink","marker","felt tip","stationery","artist"]
  },
  {
    "name": "pencil-off",
    "categories": ["design","cursors","tools","text"],
    "tags": ["disabled","inactive","non-editable","locked","read-only","unmodifiable","frozen","restricted","rubber","edit","create","draw","sketch","draft","writer","writing","stationery","artist"]
  },
  {
    "name": "pencil-ruler",
    "categories": ["tools","design","layout","text"],
    "tags": ["edit","create","draw","sketch","draft","writer","writing","stationery","artist","measurements","centimeters","cm","millimeters","mm","metre","foot","feet","inches","units","size","length","width","height","dimensions","depth","breadth","extent"]
  },
  {
    "name": "pencil",
    "categories": ["design","cursors","tools","text"],
    "tags": ["rubber","edit","create","draw","sketch","draft","writer","writing","stationery","artist"]
  },
  {
    "name": "pentagon",
    "categories": ["shapes"],
    "tags": ["shape"]
  },
  {
    "name": "percent",
    "categories": ["math","development","finance","shopping"],
    "tags": ["percentage","modulo","modulus","remainder","%","sale","discount","offer","marketing"]
  },
  {
    "name": "person-standing",
    "categories": ["accessibility","people"],
    "tags": ["people","human","accessibility","stick figure"]
  },
  {
    "name": "philippine-peso",
    "categories": ["finance"],
    "tags": ["currency","peso","money","php"]
  },
  {
    "name": "phone-call",
    "categories": ["connectivity","devices","communication"],
    "tags": ["ring"]
  },
  {
    "name": "phone-forwarded",
    "categories": ["arrows","connectivity","devices","communication"],
    "tags": ["call"]
  },
  {
    "name": "phone-incoming",
    "categories": ["arrows","connectivity","devices","communication"],
    "tags": ["call"]
  },
  {
    "name": "phone-missed",
    "categories": ["connectivity","devices","communication"],
    "tags": ["call"]
  },
  {
    "name": "phone-off",
    "categories": ["connectivity","devices","communication"],
    "tags": ["call","mute"]
  },
  {
    "name": "phone-outgoing",
    "categories": ["arrows","connectivity","devices","communication"],
    "tags": ["call"]
  },
  {
    "name": "phone",
    "categories": ["text","connectivity","devices","communication"],
    "tags": ["call"]
  },
  {
    "name": "pi",
    "categories": ["development","math"],
    "tags": ["constant","code","coding","programming","symbol","trigonometry","geometry","formula"]
  },
  {
    "name": "piano",
    "categories": ["multimedia","devices"],
    "tags": ["music","audio","sound","noise","notes","chord","keys","octave","acoustic","instrument","play","pianist","performance","concert"]
  },
  {
    "name": "pickaxe",
    "categories": ["tools","gaming"],
    "tags": ["mining","mine","land worker","extraction","labor","construction","progress","advancement","crafting","building","creation"]
  },
  {
    "name": "picture-in-picture-2",
    "categories": ["multimedia"],
    "tags": ["display","play","video","pop out","always on top","window","inset","multitask"]
  },
  {
    "name": "picture-in-picture",
    "categories": ["multimedia"],
    "tags": ["display","play","video","pop out","always on top","window","inset","multitask"]
  },
  {
    "name": "piggy-bank",
    "categories": ["finance"],
    "tags": ["money","savings"]
  },
  {
    "name": "pilcrow-left",
    "categories": ["text"],
    "tags": ["direction","paragraph","mark","paraph","blind","typography","type","text","prose","symbol"]
  },
  {
    "name": "pilcrow-right",
    "categories": ["text"],
    "tags": ["direction","paragraph","mark","paraph","blind","typography","type","text","prose","symbol"]
  },
  {
    "name": "pilcrow",
    "categories": ["text"],
    "tags": ["paragraph","mark","paraph","blind","typography","type","text","prose","symbol"]
  },
  {
    "name": "pill-bottle",
    "categories": ["medical"],
    "tags": ["medicine","medication","prescription","drug","supplement","vitamin","capsule","jar","container","healthcare","pharmaceutical","tablet"]
  },
  {
    "name": "pill",
    "categories": ["medical"],
    "tags": ["medicine","medication","drug","prescription","tablet","pharmacy"]
  },
  {
    "name": "pin-off",
    "categories": ["navigation"],
    "tags": ["unpin","map","unlock","unfix","unsave","remove"]
  },
  {
    "name": "pin",
    "categories": ["navigation","account"],
    "tags": ["save","map","lock","fix"]
  },
  {
    "name": "pipette",
    "categories": ["text","design","science"],
    "tags": ["eye dropper","color picker","lab","chemistry"]
  },
  {
    "name": "pizza",
    "categories": ["food-beverage"],
    "tags": ["pie","quiche","food"]
  },
  {
    "name": "plane-landing",
    "categories": ["transportation","travel"],
    "tags": ["arrival","plane","trip","airplane","landing"]
  },
  {
    "name": "plane-takeoff",
    "categories": ["transportation","travel"],
    "tags": ["departure","plane","trip","airplane","takeoff"]
  },
  {
    "name": "plane",
    "categories": ["transportation","travel","navigation"],
    "tags": ["plane","trip","airplane"]
  },
  {
    "name": "play",
    "categories": ["arrows","multimedia"],
    "tags": ["music","audio","video","start","run"]
  },
  {
    "name": "plug-2",
    "categories": ["devices","development"],
    "tags": ["electricity","energy","socket","outlet"]
  },
  {
    "name": "plug-zap",
    "categories": ["devices"],
    "tags": ["electricity","energy","electronics","charge","charging","battery","connect"]
  },
  {
    "name": "plug",
    "categories": ["devices","development"],
    "tags": ["electricity","energy","electronics","socket","outlet","power","voltage","current","charger"]
  },
  {
    "name": "plus",
    "categories": ["math","tools","development","text","cursors","gaming"],
    "tags": ["add","new","increase","increment","positive","calculate","toolbar","crosshair","aim","target","scope","sight","reticule","maximum","upgrade","extra","+"]
  },
  {
    "name": "pocket-knife",
    "categories": ["tools"],
    "tags": ["swiss army knife","penknife","multi-tool","multitask","blade","cutter","gadget","corkscrew"]
  },
  {
    "name": "pocket",
    "categories": ["brands"],
    "tags": ["logo","save"]
  },
  {
    "name": "podcast",
    "categories": ["multimedia","social"],
    "tags": ["audio","music","mic","talk","voice","subscribe","subscription","stream"]
  },
  {
    "name": "pointer-off",
    "categories": ["cursors"],
    "tags": ["mouse"]
  },
  {
    "name": "pointer",
    "categories": ["cursors"],
    "tags": ["mouse"]
  },
  {
    "name": "popcorn",
    "categories": ["food-beverage","multimedia"],
    "tags": ["cinema","movies","films","salted","sweet","sugar","candy","snack"]
  },
  {
    "name": "popsicle",
    "categories": ["food-beverage"],
    "tags": ["ice lolly","ice cream","sweet","food"]
  },
  {
    "name": "pound-sterling",
    "categories": ["finance"],
    "tags": ["currency","money","payment"]
  },
  {
    "name": "power-off",
    "categories": ["connectivity"],
    "tags": ["on","off","device","switch"]
  },
  {
    "name": "power",
    "categories": ["connectivity"],
    "tags": ["on","off","device","switch","toggle","binary","boolean","reboot","restart","button","keyboard","troubleshoot"]
  },
  {
    "name": "presentation",
    "categories": ["multimedia","photography","devices","communication","design"],
    "tags": ["screen","whiteboard","marker pens","markers","blackboard","chalk","easel","school","learning","lesson","office","meeting","project","planning"]
  },
  {
    "name": "printer-check",
    "categories": ["devices"],
    "tags": ["fax","office","device","success","printed"]
  },
  {
    "name": "printer-x",
    "categories": ["devices"],
    "tags": ["fax","office","device","cross","cancel","remove","error"]
  },
  {
    "name": "printer",
    "categories": ["devices"],
    "tags": ["fax","office","device"]
  },
  {
    "name": "projector",
    "categories": ["multimedia","photography","devices","communication"],
    "tags": ["cinema","film","movie","home video","presentation","slideshow","office","meeting","project","planning"]
  },
  {
    "name": "proportions",
    "categories": ["layout","design","photography","devices"],
    "tags": ["screens","sizes","rotate","rotation","adjust","aspect ratio","16:9","widescreen","4:3","resolution","responsive","mobile","desktop","dimensions","monitor","orientation","portrait","landscape"]
  },
  {
    "name": "puzzle",
    "categories": ["development","gaming"],
    "tags": ["component","module","part","piece"]
  },
  {
    "name": "pyramid",
    "categories": ["shapes","math","travel"],
    "tags": ["prism","triangle","triangular","hierarchy","structure","geometry","ancient","egyptian","landmark","tourism"]
  },
  {
    "name": "qr-code",
    "categories": ["development","social"],
    "tags": ["barcode","scan","link","url","information","digital"]
  },
  {
    "name": "quote",
    "categories": ["text"],
    "tags": ["quotation"]
  },
  {
    "name": "rabbit",
    "categories": ["animals"],
    "tags": ["animal","rodent","pet","pest","bunny","hare","fast","speed","hop"]
  },
  {
    "name": "radar",
    "categories": ["navigation","security","communication"],
    "tags": ["scan","sonar","detect","find","locate"]
  },
  {
    "name": "radiation",
    "categories": ["science"],
    "tags": ["radioactive","nuclear","fallout","waste","atomic","physics","particle","element","molecule"]
  },
  {
    "name": "radical",
    "categories": ["development","math"],
    "tags": ["calculate","formula","math","operator","root","square","symbol"]
  },
  {
    "name": "radio-receiver",
    "categories": ["devices"],
    "tags": ["device","music","connect"]
  },
  {
    "name": "radio-tower",
    "categories": ["devices","multimedia","social"],
    "tags": ["signal","broadcast","connectivity","live","frequency"]
  },
  {
    "name": "radio",
    "categories": ["devices","multimedia","social"],
    "tags": ["signal","broadcast","connectivity","live","frequency"]
  },
  {
    "name": "radius",
    "categories": ["shapes","math","design","tools"],
    "tags": ["shape","circle","geometry","trigonometry","radii","calculate","measure","size"]
  },
  {
    "name": "rail-symbol",
    "categories": ["transportation","navigation"],
    "tags": ["railway","train","track","line"]
  },
  {
    "name": "rainbow",
    "categories": ["weather"],
    "tags": ["colors","colours","spectrum","light","prism","arc","clear","sunshine"]
  },
  {
    "name": "rat",
    "categories": ["animals"],
    "tags": ["mouse","mice","gerbil","rodent","pet","pest","plague","disease"]
  },
  {
    "name": "ratio",
    "categories": ["layout","design","photography"],
    "tags": ["screens","sizes","rotate","rotation","adjust","aspect ratio","proportions","16:9","widescreen","4:3","resolution","responsive","mobile","desktop","dimensions","monitor","orientation","portrait","landscape"]
  },
  {
    "name": "receipt-cent",
    "categories": ["finance","travel"],
    "tags": ["bill","voucher","slip","check","counterfoil","currency","cents","dollar","usd","$","¢"]
  },
  {
    "name": "receipt-euro",
    "categories": ["finance","travel"],
    "tags": ["bill","voucher","slip","check","counterfoil","currency","€"]
  },
  {
    "name": "receipt-indian-rupee",
    "categories": ["finance","travel"],
    "tags": ["bill","voucher","slip","check","counterfoil","currency","inr","₹"]
  },
  {
    "name": "receipt-japanese-yen",
    "categories": ["finance","travel"],
    "tags": ["bill","voucher","slip","check","counterfoil","currency","jpy","¥"]
  },
  {
    "name": "receipt-pound-sterling",
    "categories": ["finance","travel"],
    "tags": ["bill","voucher","slip","check","counterfoil","british","currency","gbp","£"]
  },
  {
    "name": "receipt-russian-ruble",
    "categories": ["finance","travel"],
    "tags": ["bill","voucher","slip","check","counterfoil","currency","rub","₽"]
  },
  {
    "name": "receipt-swiss-franc",
    "categories": ["finance","travel"],
    "tags": ["bill","voucher","slip","check","counterfoil","currency","chf","₣"]
  },
  {
    "name": "receipt-text",
    "categories": ["finance","travel"],
    "tags": ["bill","voucher","slip","check","counterfoil","details","small print","terms","conditions","contract"]
  },
  {
    "name": "receipt-turkish-lira",
    "categories": ["finance","travel"],
    "tags": ["bill","voucher","slip","check","counterfoil","currency","try","₺"]
  },
  {
    "name": "receipt",
    "categories": ["finance","travel"],
    "tags": ["bill","voucher","slip","check","counterfoil","currency","dollar","usd","$"]
  },
  {
    "name": "rectangle-circle",
    "categories": ["development","text"],
    "tags": ["compose","keyboard","key","button"]
  },
  {
    "name": "rectangle-ellipsis",
    "categories": ["text","development"],
    "tags": ["login","password","authenticate","2fa","field","fill","ellipsis","et cetera","etc","loader","loading","progress","pending","throbber","menu","options","operator","code","spread","rest","more","further","extra","overflow","dots","…","..."]
  },
  {
    "name": "rectangle-goggles",
    "categories": ["devices","gaming","multimedia","connectivity"],
    "tags": ["vr","virtual","augmented","reality","headset","goggles"]
  },
  {
    "name": "rectangle-horizontal",
    "categories": ["shapes","design"],
    "tags": ["rectangle","aspect ratio","16:9","horizontal","shape"]
  },
  {
    "name": "rectangle-vertical",
    "categories": ["shapes","design"],
    "tags": ["rectangle","aspect ratio","9:16","vertical","shape"]
  },
  {
    "name": "recycle",
    "categories": ["sustainability"],
    "tags": ["sustainability","salvage","arrows"]
  },
  {
    "name": "redo-2",
    "categories": ["text","arrows"],
    "tags": ["undo","rerun","history"]
  },
  {
    "name": "redo-dot",
    "categories": ["text","arrows"],
    "tags": ["redo","history","step","over","forward"]
  },
  {
    "name": "redo",
    "categories": ["text","arrows"],
    "tags": ["undo","rerun","history"]
  },
  {
    "name": "refresh-ccw-dot",
    "categories": ["arrows","development"],
    "tags": ["arrows","rotate","reload","synchronise","synchronize","circular","cycle","issue","code","coding","version control"]
  },
  {
    "name": "refresh-ccw",
    "categories": ["arrows"],
    "tags": ["arrows","rotate","reload","rerun","synchronise","synchronize","circular","cycle"]
  },
  {
    "name": "refresh-cw-off",
    "categories": ["arrows"],
    "tags": ["rotate","reload","rerun","synchronise","synchronize","arrows","circular","cycle","cancel","no","stop","error","disconnect","ignore"]
  },
  {
    "name": "refresh-cw",
    "categories": ["arrows"],
    "tags": ["rotate","reload","rerun","synchronise","synchronize","arrows","circular","cycle"]
  },
  {
    "name": "refrigerator",
    "categories": ["food-beverage","home"],
    "tags": ["frigerator","fridge","freezer","cooler","icebox","chiller","cold storage"]
  },
  {
    "name": "regex",
    "categories": ["text","development"],
    "tags": ["search","text","code"]
  },
  {
    "name": "remove-formatting",
    "categories": ["text"],
    "tags": ["text","font","typography","format","x","remove","delete","times","clear"]
  },
  {
    "name": "repeat-1",
    "categories": ["multimedia"],
    "tags": ["replay"]
  },
  {
    "name": "repeat-2",
    "categories": ["arrows","social","multimedia"],
    "tags": ["arrows","retweet","repost","share","repeat","loop"]
  },
  {
    "name": "repeat",
    "categories": ["arrows","multimedia"],
    "tags": ["loop","arrows"]
  },
  {
    "name": "replace-all",
    "categories": ["text"],
    "tags": ["search","substitute","swap","change"]
  },
  {
    "name": "replace",
    "categories": ["text"],
    "tags": ["search","substitute","swap","change"]
  },
  {
    "name": "reply-all",
    "categories": ["mail"],
    "tags": ["email"]
  },
  {
    "name": "reply",
    "categories": ["mail"],
    "tags": ["email"]
  },
  {
    "name": "rewind",
    "categories": ["arrows","multimedia"],
    "tags": ["music"]
  },
  {
    "name": "ribbon",
    "categories": ["social","medical","emoji"],
    "tags": ["awareness","strip","band","tape","strap","cordon"]
  },
  {
    "name": "rocket",
    "categories": ["gaming","development"],
    "tags": ["release","boost","launch","space","version"]
  },
  {
    "name": "rocking-chair",
    "categories": ["home"],
    "tags": ["chair","furniture","seat"]
  },
  {
    "name": "roller-coaster",
    "categories": ["navigation"],
    "tags": ["attraction","entertainment","amusement park","theme park","funfair"]
  },
  {
    "name": "rose",
    "categories": ["nature","seasons","sustainability","home","social"],
    "tags": ["roses","thorns","petals","plant","stem","leaves","spring","bloom","blossom","gardening","botanical","flora","florist","bouquet","bunch","gift","date","romance","romantic","valentines day","special occasion"]
  },
  {
    "name": "rotate-3d",
    "categories": ["design"],
    "tags": ["gizmo","transform","orientation","orbit","axis"]
  },
  {
    "name": "rotate-ccw-key",
    "categories": ["security","account"],
    "tags": ["password","key","refresh","change"]
  },
  {
    "name": "rotate-ccw-square",
    "categories": ["layout","design","photography","tools","arrows"],
    "tags": ["left","counter-clockwise","rotate","image","90","45","degrees","°"]
  },
  {
    "name": "rotate-ccw",
    "categories": ["arrows","design","photography"],
    "tags": ["arrow","left","counter-clockwise","restart","reload","rerun","refresh","backup","undo","replay","redo","retry","rewind","reverse"]
  },
  {
    "name": "rotate-cw-square",
    "categories": ["layout","design","photography","tools","arrows"],
    "tags": ["right","clockwise","rotate","image","90","45","degrees","°"]
  },
  {
    "name": "rotate-cw",
    "categories": ["arrows","design","photography"],
    "tags": ["arrow","right","clockwise","refresh","reload","rerun","redo"]
  },
  {
    "name": "route-off",
    "categories": ["navigation"],
    "tags": ["path","journey","planner","points","stops","stations","reset","clear","cancelled","closed","blocked"]
  },
  {
    "name": "route",
    "categories": ["navigation"],
    "tags": ["path","journey","planner","points","stops","stations"]
  },
  {
    "name": "router",
    "categories": ["development","devices","connectivity","home"],
    "tags": ["computer","server","cloud"]
  },
  {
    "name": "rows-2",
    "categories": ["layout","design","text"],
    "tags": ["lines","list","queue","preview","panel","paragraphs","parallel","series","split","vertical","horizontal","half","center","middle","even","drawer"]
  },
  {
    "name": "rows-3",
    "categories": ["layout","design","text"],
    "tags": ["lines","list","queue","preview","paragraphs","parallel","series","split","vertical","horizontal","half","center","middle","even","drawers"]
  },
  {
    "name": "rows-4",
    "categories": ["layout","design","text"],
    "tags": ["lines","list","queue","preview","paragraphs","parallel","series","split","vertical","horizontal","half","center","middle","even","drawers","grill"]
  },
  {
    "name": "rss",
    "categories": ["development","social"],
    "tags": ["feed","subscribe","news","updates","notifications","content","blog","articles","broadcast","syndication","reader","channels","posts","publishing","digest","alert","following","inbox","newsletter","weblog","podcast"]
  },
  {
    "name": "ruler-dimension-line",
    "categories": ["tools","design","layout"],
    "tags": ["measurements","centimeters","cm","millimeters","mm","metre","foot","feet","inches","units","size","length","width","height","dimensions","depth","breadth","extent","stationery"]
  },
  {
    "name": "ruler",
    "categories": ["tools","design","layout"],
    "tags": ["measurements","centimeters","cm","millimeters","mm","metre","foot","feet","inches","units","size","length","width","height","dimensions","depth","breadth","extent","stationery"]
  },
  {
    "name": "russian-ruble",
    "categories": ["finance"],
    "tags": ["currency","money","payment"]
  },
  {
    "name": "sailboat",
    "categories": ["transportation","travel"],
    "tags": ["ship","boat","harbor","harbour","dock"]
  },
  {
    "name": "salad",
    "categories": ["food-beverage","emoji"],
    "tags": ["food","vegetarian","dish","restaurant","course","meal","side","vegetables","health"]
  },
  {
    "name": "sandwich",
    "categories": ["food-beverage"],
    "tags": ["food","snack","dish","restaurant","lunch","meal"]
  },
  {
    "name": "satellite-dish",
    "categories": ["connectivity","devices","multimedia"],
    "tags": ["antenna","receiver","dish aerial","saucer"]
  },
  {
    "name": "satellite",
    "categories": ["connectivity","science"],
    "tags": ["space station","orbit","transmitter"]
  },
  {
    "name": "saudi-riyal",
    "categories": ["finance"],
    "tags": ["currency","money","payment"]
  },
  {
    "name": "save-all",
    "categories": ["text","files"],
    "tags": ["floppy disks","copy"]
  },
  {
    "name": "save-off",
    "categories": ["text","files"],
    "tags": ["floppy disk","unsalvageable"]
  },
  {
    "name": "save",
    "categories": ["text","files"],
    "tags": ["floppy disk"]
  },
  {
    "name": "scale-3d",
    "categories": ["design"],
    "tags": ["gizmo","transform","size","axis"]
  },
  {
    "name": "scale",
    "categories": ["navigation","science","finance"],
    "tags": ["balance","legal","license","right","rule","law","justice","weight","measure","compare","judge","fair","ethics","decision"]
  },
  {
    "name": "scaling",
    "categories": ["design"],
    "tags": ["scale","resize","design"]
  },
  {
    "name": "scan-barcode",
    "categories": ["shopping","devices"],
    "tags": ["checkout","till","cart","transaction","purchase","buy","product","packaging","retail","consumer"]
  },
  {
    "name": "scan-eye",
    "categories": ["photography","multimedia","accessibility","security","devices","account"],
    "tags": ["preview","zoom","expand","fullscreen","gallery","image","camera","watch","surveillance","retina","focus","lens","biometric","identification","authentication","access","login"]
  },
  {
    "name": "scan-face",
    "categories": ["account","security","devices","social"],
    "tags": ["face","biometric","identification","authentication","2fa","access","login","dashed"]
  },
  {
    "name": "scan-heart",
    "categories": ["medical"],
    "tags": ["health","heart rate","pulse","monitoring","healthiness","screening","dashed"]
  },
  {
    "name": "scan-line",
    "categories": ["devices","shopping"],
    "tags": ["checkout","till","cart","transaction","purchase","buy","product","packaging","retail","consumer","qr-code","dashed"]
  },
  {
    "name": "scan-qr-code",
    "categories": ["account","shopping","devices","security"],
    "tags": ["barcode","scan","qrcode","url","information","digital","scanner"]
  },
  {
    "name": "scan-search",
    "categories": ["photography","multimedia","accessibility"],
    "tags": ["preview","zoom","expand","fullscreen","gallery","image","focus","lens"]
  },
  {
    "name": "scan-text",
    "categories": ["text","devices"],
    "tags": ["recognition","read","translate","copy","lines"]
  },
  {
    "name": "scan",
    "categories": ["devices","shopping","security","social","gaming"],
    "tags": ["qr-code","barcode","checkout","augmented reality","ar","target","surveillance","camera","lens","focus","frame","select","box","boundary","bounds","area","square","dashed"]
  },
  {
    "name": "school",
    "categories": ["buildings","navigation"],
    "tags": ["building","education","childhood","university","learning","campus","scholar","student","lecture","degree","course","academia","study","knowledge","classroom","research","diploma","graduation","professor","tutorial","homework","assignment","exam"]
  },
  {
    "name": "scissors-line-dashed",
    "categories": ["design","tools"],
    "tags": ["cut here","along","snip","chop","stationery","crafts","instructions","diagram"]
  },
  {
    "name": "scissors",
    "categories": ["text","design","tools"],
    "tags": ["cut","snip","chop","stationery","crafts"]
  },
  {
    "name": "scooter",
    "categories": ["transportation"],
    "tags": ["vehicle","drive","trip","journey","transport","electric","ride","urban","commute","speed"]
  },
  {
    "name": "screen-share-off",
    "categories": ["connectivity","devices","communication"],
    "tags": ["desktop","disconnect","monitor"]
  },
  {
    "name": "screen-share",
    "categories": ["connectivity","devices","communication"],
    "tags": ["host","desktop","monitor"]
  },
  {
    "name": "scroll-text",
    "categories": ["gaming","development","text"],
    "tags": ["paper","log","scripture","document","notes","parchment","list","long","script","story","code","coding"]
  },
  {
    "name": "scroll",
    "categories": ["gaming","development","text"],
    "tags": ["paper","log","scripture","document","notes","parchment","list","long","script","story","code","coding"]
  },
  {
    "name": "search-alert",
    "categories": ["text","social"],
    "tags": ["find","scan","magnifier","magnifying glass","stop","warning","alert","error","anomaly","lens"]
  },
  {
    "name": "search-check",
    "categories": ["text","social"],
    "tags": ["find","scan","magnifier","magnifying glass","found","correct","complete","tick","lens"]
  },
  {
    "name": "search-code",
    "categories": ["text","social","development"],
    "tags": ["find","scan","magnifier","magnifying glass","grep","chevrons","<>","lens"]
  },
  {
    "name": "search-slash",
    "categories": ["text","social"],
    "tags": ["find","scan","magnifier","magnifying glass","stop","clear","cancel","abort","/","lens"]
  },
  {
    "name": "search-x",
    "categories": ["text","social"],
    "tags": ["find","scan","magnifier","magnifying glass","stop","clear","cancel","abort","lens"]
  },
  {
    "name": "search",
    "categories": ["text","social"],
    "tags": ["find","scan","magnifier","magnifying glass","lens"]
  },
  {
    "name": "section",
    "categories": ["text"],
    "tags": ["mark","typography","punctuation","legal","type","text","prose","symbol"]
  },
  {
    "name": "send-horizontal",
    "categories": ["mail","communication","connectivity"],
    "tags": ["email","message","mail","paper airplane","paper aeroplane","submit"]
  },
  {
    "name": "send-to-back",
    "categories": ["design","layout"],
    "tags": ["bring","send","move","under","back","backwards","overlap","layer","order"]
  },
  {
    "name": "send",
    "categories": ["mail","communication","connectivity"],
    "tags": ["email","message","mail","paper airplane","paper aeroplane","submit"]
  },
  {
    "name": "separator-horizontal",
    "categories": ["text","arrows","layout"],
    "tags": ["move","split"]
  },
  {
    "name": "separator-vertical",
    "categories": ["text","arrows","layout"],
    "tags": ["move","split"]
  },
  {
    "name": "server-cog",
    "categories": ["development","devices"],
    "tags": ["cloud","storage","computing","cog","gear"]
  },
  {
    "name": "server-crash",
    "categories": ["development","devices"],
    "tags": ["cloud","storage","problem","error"]
  },
  {
    "name": "server-off",
    "categories": ["development","devices"],
    "tags": ["cloud","storage"]
  },
  {
    "name": "server",
    "categories": ["development","devices"],
    "tags": ["cloud","storage"]
  },
  {
    "name": "settings-2",
    "categories": ["account"],
    "tags": ["cog","edit","gear","preferences","slider"]
  },
  {
    "name": "settings",
    "categories": ["account"],
    "tags": ["cog","edit","gear","preferences"]
  },
  {
    "name": "shapes",
    "categories": ["shapes","gaming"],
    "tags": ["triangle","equilateral","square","circle","classification","different","collection","toy","blocks","learning"]
  },
  {
    "name": "share-2",
    "categories": ["account","social"],
    "tags": ["network","connections"]
  },
  {
    "name": "share",
    "categories": ["account","social"],
    "tags": ["network","connections"]
  },
  {
    "name": "sheet",
    "categories": ["text","files"],
    "tags": ["spreadsheets","table","excel"]
  },
  {
    "name": "shell",
    "categories": ["animals","development","nature","science","travel","food-beverage","home"],
    "tags": ["beach","sand","holiday","sealife","fossil","ammonite","biology","ocean","terminal","command line","session","bash","zsh","roll","wrap","chewing gum","bubble gum","sweet","sugar","hosepipe","carpet","string","spiral","spinner","hypnotise","hypnosis"]
  },
  {
    "name": "shield-alert",
    "categories": ["account","security","development","notifications","gaming"],
    "tags": ["unshielded","cybersecurity","insecure","unsecured","safety","unsafe","protection","unprotected","guardian","unguarded","unarmored","unarmoured","defenseless","defenceless","undefended","defender","blocked","stopped","intercepted","interception","saved","thwarted","threat","prevention","unprevented","antivirus","vigilance","vigilant","detection","detected","scanned","found","exploit","vulnerability","vulnerable","weakness","infection","infected","comprimised","data leak","audited","admin","verification","unverified","uncertified","warning","emergency","attention","urgent","alarm","crest","bravery","strength","tough","attacked","damaged","injured","hit","expired","disabled","inactive","error","exclamation mark","!"]
  },
  {
    "name": "shield-ban",
    "categories": ["account","security","development","gaming"],
    "tags": ["unshielded","cybersecurity","insecure","unsecured","safety","unsafe","protection","unprotected","guardian","unguarded","unarmored","unarmoured","defenseless","defenceless","undefended","defender","blocked","stopped","intercepted","interception","saved","thwarted","threat","prevention","unprevented","antivirus","vigilance","vigilant","detection","detected","scanned","found","exploit","vulnerability","vulnerable","weakness","infection","infected","comprimised","data leak","audited","admin","verification","unverified","uncertified","cancel","error","crest","bravery","attacked","damaged","injured","hit","expired","eliminated","disabled","inactive","/"]
  },
  {
    "name": "shield-check",
    "categories": ["account","security","development","gaming"],
    "tags": ["cybersecurity","secured","safety","protection","protected","guardian","guarded","armored","armoured","defense","defence","defended","blocked","threat","prevention","prevented","antivirus","vigilance","vigilant","active","activated","enabled","detection","scanned","found","strength","strong","tough","invincible","invincibility","invulnerable","undamaged","audited","admin","verification","verified","certification","certified","tested","passed","qualified","cleared","cleaned","disinfected","uninfected","task","completed","todo","done","ticked","checked","crest","bravery"]
  },
  {
    "name": "shield-ellipsis",
    "categories": ["account","security","development","gaming"],
    "tags": ["cybersecurity","securing","protecting","guarding","armoring","armouring","defending","blocking","preventing","antivirus","detecting","scanning","finding","auditing","admin","verifying","crest","upgrading","loader","loading","throbber","progress","dots","more","etc","...","…"]
  },
  {
    "name": "shield-half",
    "categories": ["account","security","development","gaming"],
    "tags": ["cybersecurity","secure","safety","protection","guardian","armored","armoured","defense","defence","defender","block","threat","prevention","antivirus","vigilance","vigilant","detection","scan","strength","strong","tough","invincible","invincibility","invulnerable","undamaged","audit","admin","verification","crest","logo","sigil","flag","team","faction","fraternity","university","college","academy","school","education","uniform","bravery","knight","foot soldier","infantry","trooper","pawn","battle","war","military","ranking","army","cadet","scout"]
  },
  {
    "name": "shield-minus",
    "categories": ["account","security","development","gaming"],
    "tags": ["unshield","cybersecurity","unsecure","unguard","unblock","antivirus","clean","clear","disinfect","patch","fix","stop","cancel","remove","relax","admin","crest","bravery","weakened","damaged","hit","unarm","disable","deactivate","decommission","downgraded","minimum","-"]
  },
  {
    "name": "shield-off",
    "categories": ["account","security","development","gaming"],
    "tags": ["unshielded","cybersecurity","insecure","unsecured","safety","unsafe","protection","unprotected","guardian","unguarded","unarmored","unarmoured","defenseless","defenceless","undefended","defender","interception","threat","prevention","unprevented","antivirus","detection","undetected","exploit","vulnerability","vulnerable","weakness","infected","infection","comprimised","data leak","unaudited","admin","verification","unverified","inactive","cancelled","error","crest","bravery","damaged","injured","hit","expired","eliminated"]
  },
  {
    "name": "shield-plus",
    "categories": ["account","security","development","gaming","medical"],
    "tags": ["cybersecurity","secure","safety","protection","guardian","armored","armoured","defense","defence","defender","block","threat","prevention","antivirus","vigilance","vigilant","detection","scan","strength","strong","tough","invincible","invincibility","invulnerable","undamaged","extra","added","professional","enterprise","full","maximum","upgraded","ultra","activate","enable","audit","admin","verification","crest","medic","+"]
  },
  {
    "name": "shield-question-mark",
    "categories": ["account","security","development","gaming"],
    "tags": ["unshielded","cybersecurity","insecure","unsecured","safety","unsafe","protection","unprotected","guardian","unguarded","unarmored","unarmoured","defenseless","defenceless","undefended","defender","threat","prevention","unprevented","antivirus","vigilance","vigilant","detection","undetected","scan","find","exploit","vulnerability","vulnerable","weakness","infection","comprimised","data leak","audit","admin","verification","unverified","uncertified","uncertain","unknown","inactive","crest","question mark","?"]
  },
  {
    "name": "shield-user",
    "categories": ["account","security","development"],
    "tags": ["shield","user","admin","protection","protected","safety","guard"]
  },
  {
    "name": "shield-x",
    "categories": ["account","security","development","gaming"],
    "tags": ["unshielded","cybersecurity","insecure","unsecured","safety","unsafe","protection","unprotected","guardian","unguarded","unarmored","unarmoured","defenseless","defenceless","undefended","defender","blocked","stopped","intercepted","interception","saved","thwarted","threat","prevention","prevented","antivirus","vigilance","vigilant","detection","detected","scanned","found","exploit","vulnerability","vulnerable","weakness","infection","infected","comprimised","data leak","audited","admin","verification","unverified","inactive","cancel","error","wrong","false","crest","bravery","attacked","damaged","injured","hit","dead","deceased","expired","eliminated","exterminated"]
  },
  {
    "name": "shield",
    "categories": ["account","security","development","gaming","shapes"],
    "tags": ["cybersecurity","secure","safety","protection","guardian","armored","armoured","defense","defence","defender","block","threat","prevention","antivirus","vigilance","vigilant","detection","scan","find","strength","strong","tough","invincible","invincibility","invulnerable","undamaged","audit","admin","verification","crest","bravery","knight","foot soldier","infantry","trooper","pawn","battle","war","military","army","cadet","scout"]
  },
  {
    "name": "ship-wheel",
    "categories": ["transportation","navigation","travel"],
    "tags": ["steering","rudder","boat","knots","nautical mile","maritime","sailing","yacht","cruise","ocean liner","tanker","vessel","navy","trip"]
  },
  {
    "name": "ship",
    "categories": ["transportation","navigation","travel"],
    "tags": ["boat","knots","nautical mile","maritime","sailing","yacht","cruise","ocean liner","tanker","vessel","navy","trip","releases"]
  },
  {
    "name": "shirt",
    "categories": ["shopping"],
    "tags": ["t-shirt","shopping","store","clothing","clothes"]
  },
  {
    "name": "shopping-bag",
    "categories": ["shopping"],
    "tags": ["ecommerce","cart","purchase","store"]
  },
  {
    "name": "shopping-basket",
    "categories": ["shopping"],
    "tags": ["cart","e-commerce","store","purchase","products","items","ingredients"]
  },
  {
    "name": "shopping-cart",
    "categories": ["shopping"],
    "tags": ["trolley","cart","basket","e-commerce","store","purchase","products","items","ingredients"]
  },
  {
    "name": "shovel",
    "categories": ["nature","tools","gaming"],
    "tags": ["dig","spade","treasure"]
  },
  {
    "name": "shower-head",
    "categories": ["home","travel"],
    "tags": ["shower","bath","bathroom","amenities","services"]
  },
  {
    "name": "shredder",
    "categories": ["mail","files"],
    "tags": ["file","paper","tear","cut","delete","destroy","remove","erase","document","destruction","secure","security","confidential","data","trash","dispose","disposal","information","waste","permanent"]
  },
  {
    "name": "shrimp",
    "categories": ["animals"],
    "tags": ["seafood","shellfish","crustacean","prawn","scallop","whelk","arthropod","littleneck","quahog","cherrystone"]
  },
  {
    "name": "shrink",
    "categories": ["layout","arrows"],
    "tags": ["scale","fullscreen"]
  },
  {
    "name": "shrub",
    "categories": ["nature"],
    "tags": ["forest","undergrowth","park","nature"]
  },
  {
    "name": "shuffle",
    "categories": ["multimedia","arrows"],
    "tags": ["music","random","reorder"]
  },
  {
    "name": "sigma",
    "categories": ["text","math","science"],
    "tags": ["sum","calculate","formula","math","enumeration","enumerate"]
  },
  {
    "name": "signal-high",
    "categories": ["connectivity"],
    "tags": ["connection","wireless","gsm","phone","2g","3g","4g","5g"]
  },
  {
    "name": "signal-low",
    "categories": ["connectivity"],
    "tags": ["connection","wireless","gsm","phone","2g","3g","4g","5g"]
  },
  {
    "name": "signal-medium",
    "categories": ["connectivity"],
    "tags": ["connection","wireless","gsm","phone","2g","3g","4g","5g"]
  },
  {
    "name": "signal-zero",
    "categories": ["connectivity"],
    "tags": ["connection","wireless","gsm","phone","2g","3g","4g","5g","lost"]
  },
  {
    "name": "signal",
    "categories": ["connectivity"],
    "tags": ["connection","wireless","gsm","phone","2g","3g","4g","5g"]
  },
  {
    "name": "signature",
    "categories": ["text"],
    "tags": ["text","format","input","contract","autograph","handwriting","sign","cursive","ink","scribble","authorize","personal","agreement","legal","document","identity","authentic","approval","verification","unique"]
  },
  {
    "name": "signpost-big",
    "categories": ["arrows","navigation","development","gaming"],
    "tags": ["bidirectional","left","right","east","west"]
  },
  {
    "name": "signpost",
    "categories": ["arrows","navigation","development","gaming"],
    "tags": ["bidirectional","left","right","east","west"]
  },
  {
    "name": "siren",
    "categories": ["medical"],
    "tags": ["police","ambulance","emergency","security","alert","alarm","light"]
  },
  {
    "name": "skip-back",
    "categories": ["multimedia","arrows"],
    "tags": ["arrow","previous","music"]
  },
  {
    "name": "skip-forward",
    "categories": ["multimedia","arrows"],
    "tags": ["arrow","skip","next","music"]
  },
  {
    "name": "skull",
    "categories": ["gaming"],
    "tags": ["death","danger","bone"]
  },
  {
    "name": "slack",
    "categories": ["account","social","brands","development"],
    "tags": ["logo"]
  },
  {
    "name": "slash",
    "categories": ["development","math"],
    "tags": ["divide","division","or","/"]
  },
  {
    "name": "slice",
    "categories": ["design"],
    "tags": ["cutter","scalpel","knife"]
  },
  {
    "name": "sliders-horizontal",
    "categories": ["account"],
    "tags": ["settings","filters","controls"]
  },
  {
    "name": "sliders-vertical",
    "categories": ["account"],
    "tags": ["settings","controls"]
  },
  {
    "name": "smartphone-charging",
    "categories": ["connectivity","devices"],
    "tags": ["phone","cellphone","device","power","screen"]
  },
  {
    "name": "smartphone-nfc",
    "categories": ["communication","finance","devices"],
    "tags": ["contactless","payment","near-field communication","screen"]
  },
  {
    "name": "smartphone",
    "categories": ["connectivity","devices"],
    "tags": ["phone","cellphone","device","screen"]
  },
  {
    "name": "smile-plus",
    "categories": ["emoji","social","notifications","communication"],
    "tags": ["emoji","face","happy","good","emotion","react","reaction","add"]
  },
  {
    "name": "smile",
    "categories": ["emoji","account"],
    "tags": ["emoji","face","happy","good","emotion"]
  },
  {
    "name": "snail",
    "categories": ["animals","food-beverage"],
    "tags": ["animal","insect","slow","speed","delicacy","spiral"]
  },
  {
    "name": "snowflake",
    "categories": ["weather","seasons"],
    "tags": ["cold","weather","freeze","snow","winter"]
  },
  {
    "name": "soap-dispenser-droplet",
    "categories": ["home","travel"],
    "tags": ["wash","bath","water","liquid","fluid","wet","moisture","damp","bead","globule"]
  },
  {
    "name": "sofa",
    "categories": ["home"],
    "tags": ["armchair","furniture","leisure","lounge","loveseat","couch"]
  },
  {
    "name": "solar-panel",
    "categories": ["home","science","sustainability","weather"],
    "tags": ["solar panel","solar","panel","sun","energy","electricity","light"]
  },
  {
    "name": "soup",
    "categories": ["food-beverage"],
    "tags": ["food","dish","restaurant","course","meal","bowl","starter"]
  },
  {
    "name": "space",
    "categories": ["text"],
    "tags": ["text","selection","letters","characters","font","typography"]
  },
  {
    "name": "spade",
    "categories": ["shapes","gaming"],
    "tags": ["shape","suit","playing","cards"]
  },
  {
    "name": "sparkle",
    "categories": ["shapes"],
    "tags": ["star","effect","filter","night","magic","shiny","glitter","twinkle","celebration"]
  },
  {
    "name": "sparkles",
    "categories": ["cursors","multimedia","gaming","weather"],
    "tags": ["stars","effect","filter","night","magic"]
  },
  {
    "name": "speaker",
    "categories": ["multimedia","devices"],
    "tags": ["sound","audio","music","tweeter","subwoofer","bass","production","producer","dj"]
  },
  {
    "name": "speech",
    "categories": ["accessibility","communication"],
    "tags": ["disability","disabled","dda","human","accessibility","people","sound"]
  },
  {
    "name": "spell-check-2",
    "categories": ["text","development"],
    "tags": ["spelling","error","mistake","oversight","typo","correction","code","linter","a"]
  },
  {
    "name": "spell-check",
    "categories": ["text","development"],
    "tags": ["spelling","error","mistake","oversight","typo","correction","code","linter","a"]
  },
  {
    "name": "spline-pointer",
    "categories": ["arrows","cursors","design","tools"],
    "tags": ["path","tool","curve","node","click","pointer","target","vector"]
  },
  {
    "name": "spline",
    "categories": ["design"],
    "tags": ["path","pen","tool","shape","curve","draw"]
  },
  {
    "name": "split",
    "categories": ["development","arrows"],
    "tags": ["break","disband","divide","separate","branch","disunite"]
  },
  {
    "name": "spool",
    "categories": ["communication","tools","social"],
    "tags": ["bobbin","spindle","yarn","thread","string","sewing","needlework"]
  },
  {
    "name": "spotlight",
    "categories": ["devices","photography","multimedia","communication"],
    "tags": ["winner","soapbox","stage","entertainment","drama","podium","actor","actress","singer","light","beam","play","theatre","show","focus","concert","performance","lens","leaderboard","followspot","best","highlight"]
  },
  {
    "name": "spray-can",
    "categories": ["design","tools"],
    "tags": ["paint","color","graffiti","decoration","aerosol","deodorant","shaving foam","air freshener"]
  },
  {
    "name": "sprout",
    "categories": ["nature","gaming","sustainability"],
    "tags": ["eco","green","growth","leaf","nature","plant","seed","spring","sustainability"]
  },
  {
    "name": "square-activity",
    "categories": ["medical","social","science","multimedia"],
    "tags": ["pulse","action","motion","movement","exercise","fitness","healthcare","heart rate monitor","vital signs","vitals","emergency room","er","intensive care","hospital","defibrillator","earthquake","siesmic","magnitude","richter scale","aftershock","tremor","shockwave","audio","waveform","synthesizer","synthesiser","music"]
  },
  {
    "name": "square-arrow-down-left",
    "categories": ["arrows","gaming"],
    "tags": ["direction","south-west","diagonal","sign","turn","keyboard","button"]
  },
  {
    "name": "square-arrow-down-right",
    "categories": ["arrows","gaming"],
    "tags": ["direction","south-east","diagonal","sign","turn","keyboard","button"]
  },
  {
    "name": "square-arrow-down",
    "categories": ["arrows","gaming"],
    "tags": ["backwards","reverse","direction","south","sign","keyboard","button"]
  },
  {
    "name": "square-arrow-left",
    "categories": ["arrows"],
    "tags": ["previous","back","direction","west","sign","keyboard","button","<-"]
  },
  {
    "name": "square-arrow-out-down-left",
    "categories": ["arrows"],
    "tags": ["outwards","direction","south-west","diagonal"]
  },
  {
    "name": "square-arrow-out-down-right",
    "categories": ["arrows"],
    "tags": ["outwards","direction","south-east","diagonal"]
  },
  {
    "name": "square-arrow-out-up-left",
    "categories": ["arrows"],
    "tags": ["outwards","direction","north-west","diagonal"]
  },
  {
    "name": "square-arrow-out-up-right",
    "categories": ["arrows","social"],
    "tags": ["outwards","direction","north-east","diagonal","share","open","external","link"]
  },
  {
    "name": "square-arrow-right",
    "categories": ["arrows"],
    "tags": ["next","forward","direction","west","sign","keyboard","button","->"]
  },
  {
    "name": "square-arrow-up-left",
    "categories": ["arrows"],
    "tags": ["direction","north-west","diagonal","sign","keyboard","button"]
  },
  {
    "name": "square-arrow-up-right",
    "categories": ["arrows","social"],
    "tags": ["direction","north-east","diagonal","sign","keyboard","button","share"]
  },
  {
    "name": "square-arrow-up",
    "categories": ["arrows"],
    "tags": ["forward","direction","north","sign","keyboard","button"]
  },
  {
    "name": "square-asterisk",
    "categories": ["text","security","math","development"],
    "tags": ["password","secret","access","key","multiply","multiplication","glob pattern","wildcard","*"]
  },
  {
    "name": "square-bottom-dashed-scissors",
    "categories": ["text","design","tools","files","development"],
    "tags": ["cut","snippet","chop","stationery","crafts"]
  },
  {
    "name": "square-chart-gantt",
    "categories": ["charts","time","development","design"],
    "tags": ["projects","manage","overview","roadmap","plan","intentions","timeline","deadline","date","event","range","period","productivity","work","agile","code","coding","toolbar","button"]
  },
  {
    "name": "square-check-big",
    "categories": ["notifications"],
    "tags": ["done","todo","tick","complete","task"]
  },
  {
    "name": "square-check",
    "categories": ["notifications"],
    "tags": ["done","todo","tick","complete","task"]
  },
  {
    "name": "square-chevron-down",
    "categories": ["arrows","navigation"],
    "tags": ["back","menu","panel"]
  },
  {
    "name": "square-chevron-left",
    "categories": ["arrows","navigation"],
    "tags": ["back","previous","less than","fewer","menu","panel","button","keyboard","<"]
  },
  {
    "name": "square-chevron-right",
    "categories": ["arrows","navigation","development"],
    "tags": ["forward","next","more than","greater","menu","panel","code","coding","command line","terminal","prompt","shell","console",">"]
  },
  {
    "name": "square-chevron-up",
    "categories": ["arrows","navigation","math"],
    "tags": ["caret","keyboard","button","mac","control","ctrl","superscript","exponential","power","ahead","menu","panel","^"]
  },
  {
    "name": "square-code",
    "categories": ["text","development"],
    "tags": ["gist","source","programming","html","xml","coding"]
  },
  {
    "name": "square-dashed-bottom-code",
    "categories": ["development","files"],
    "tags": ["rectangle","aspect ratio","1:1","shape","snippet","code","coding"]
  },
  {
    "name": "square-dashed-bottom",
    "categories": ["development","files"],
    "tags": ["rectangle","aspect ratio","1:1","shape","snippet","code","coding"]
  },
  {
    "name": "square-dashed-kanban",
    "categories": ["charts","development","design"],
    "tags": ["projects","manage","overview","board","tickets","issues","roadmap","plan","intentions","productivity","work","agile","draft","template","boilerplate","code","coding"]
  },
  {
    "name": "square-dashed-mouse-pointer",
    "categories": ["arrows","cursors","development","tools"],
    "tags": ["inspector","element","mouse","click","pointer","box","browser","selector","target","dom","node"]
  },
  {
    "name": "square-dashed-top-solid",
    "categories": ["design","development","layout"],
    "tags": ["square","border","width","layout","style","design","rectangular","marquee","dashed","box","rectangle","aspect ratio","1:1"]
  },
  {
    "name": "square-dashed",
    "categories": ["text","design"],
    "tags": ["selection","square","rectangular","marquee","tool","dashed","box"]
  },
  {
    "name": "square-divide",
    "categories": ["math"],
    "tags": ["calculate","math","÷","/"]
  },
  {
    "name": "square-dot",
    "categories": ["development"],
    "tags": ["git","diff","modified","."]
  },
  {
    "name": "square-equal",
    "categories": ["math"],
    "tags": ["calculate","="]
  },
  {
    "name": "square-function",
    "categories": ["development","math"],
    "tags": ["programming","code","automation","math"]
  },
  {
    "name": "square-kanban",
    "categories": ["charts","development","design"],
    "tags": ["projects","manage","overview","board","tickets","issues","roadmap","plan","intentions","productivity","work","agile","code","coding","toolbar","button"]
  },
  {
    "name": "square-library",
    "categories": ["text","photography","multimedia","navigation","development"],
    "tags": ["books","reading","written","authors","stories","fiction","novels","information","knowledge","education","high school","university","college","academy","learning","study","research","collection","vinyl","records","albums","music","package"]
  },
  {
    "name": "square-m",
    "categories": ["transportation","navigation"],
    "tags": ["metro","subway","underground","track","line"]
  },
  {
    "name": "square-menu",
    "categories": ["layout"],
    "tags": ["bars","navigation","hamburger","options","menu bar","panel"]
  },
  {
    "name": "square-minus",
    "categories": ["math","development","text","tools","devices"],
    "tags": ["subtract","remove","decrease","reduce","calculator","button","keyboard","line","divider","separator","horizontal rule","hr","html","markup","markdown","---","toolbar","operator","code","coding","minimum","downgrade"]
  },
  {
    "name": "square-mouse-pointer",
    "categories": ["arrows","cursors","development","tools"],
    "tags": ["inspector","element","mouse","click","pointer","box","browser","selector","target","dom","node"]
  },
  {
    "name": "square-parking-off",
    "categories": ["transportation","navigation"],
    "tags": ["parking lot","car park","no parking"]
  },
  {
    "name": "square-parking",
    "categories": ["transportation","navigation"],
    "tags": ["parking lot","car park"]
  },
  {
    "name": "square-pause",
    "categories": ["multimedia"],
    "tags": ["music","audio","stop"]
  },
  {
    "name": "square-pen",
    "categories": ["text"],
    "tags": ["pencil","edit","change","create","draw","sketch","draft","writer","writing","biro","ink","marker","felt tip","stationery","artist"]
  },
  {
    "name": "square-percent",
    "categories": ["social","finance","shopping","math"],
    "tags": ["verified","unverified","sale","discount","offer","marketing","sticker","price tag"]
  },
  {
    "name": "square-pi",
    "categories": ["development","math"],
    "tags": ["constant","code","coding","programming","symbol","trigonometry","geometry","formula"]
  },
  {
    "name": "square-pilcrow",
    "categories": ["text"],
    "tags": ["paragraph","mark","paraph","blind","typography","type","text","prose","symbol"]
  },
  {
    "name": "square-play",
    "categories": ["arrows","multimedia"],
    "tags": ["music","audio","video","start","run"]
  },
  {
    "name": "square-plus",
    "categories": ["math","tools","development","text"],
    "tags": ["add","new","increase","increment","positive","calculate","calculator","button","keyboard","toolbar","maximum","upgrade","extra","operator","join","concatenate","code","coding","+"]
  },
  {
    "name": "square-power",
    "categories": ["connectivity"],
    "tags": ["on","off","device","switch","toggle","binary","boolean","reboot","restart","button","keyboard","troubleshoot"]
  },
  {
    "name": "square-radical",
    "categories": ["development","math"],
    "tags": ["calculate","formula","math","operator","root","square","symbol"]
  },
  {
    "name": "square-round-corner",
    "categories": ["design","development","layout"],
    "tags": ["border","radius","style","design","corner","layout","round","rounded"]
  },
  {
    "name": "square-scissors",
    "categories": ["text","design","tools","files","development"],
    "tags": ["cut","snippet","chop","stationery","crafts","toolbar","button"]
  },
  {
    "name": "square-sigma",
    "categories": ["text","math"],
    "tags": ["sum","calculate","formula","math","enumeration","enumerate"]
  },
  {
    "name": "square-slash",
    "categories": ["development","math"],
    "tags": ["git","diff","ignored","divide","division","shortcut","or","/"]
  },
  {
    "name": "square-split-horizontal",
    "categories": ["layout"],
    "tags": ["split","divide"]
  },
  {
    "name": "square-split-vertical",
    "categories": ["layout"],
    "tags": ["split","divide"]
  },
  {
    "name": "square-square",
    "categories": ["layout"],
    "tags": ["float","center","rectangle"]
  },
  {
    "name": "square-stack",
    "categories": ["text","files","development"],
    "tags": ["versions","clone","copy","duplicate","multiple","revisions","version control","backup","history"]
  },
  {
    "name": "square-star",
    "categories": ["sports","gaming"],
    "tags": ["badge","medal","honour","decoration","order","pin","laurel","trophy","medallion","insignia","bronze","silver","gold"]
  },
  {
    "name": "square-stop",
    "categories": ["multimedia"],
    "tags": ["media","music"]
  },
  {
    "name": "square-terminal",
    "categories": ["development"],
    "tags": ["code","command line","prompt","shell"]
  },
  {
    "name": "square-user-round",
    "categories": ["account"],
    "tags": ["person","account","contact"]
  },
  {
    "name": "square-user",
    "categories": ["account"],
    "tags": ["person","account","contact"]
  },
  {
    "name": "square-x",
    "categories": ["math","notifications"],
    "tags": ["cancel","close","delete","remove","times","clear","math","multiply","multiplication"]
  },
  {
    "name": "square",
    "categories": ["shapes","multimedia"],
    "tags": ["stop","playback","music","audio","video","rectangle","aspect ratio","1:1","shape"]
  },
  {
    "name": "squares-exclude",
    "categories": ["design"],
    "tags": ["square","pathfinder","path","exclude","invert","xor","shape","vector"]
  },
  {
    "name": "squares-intersect",
    "categories": ["design"],
    "tags": ["square","pathfinder","path","intersect","shape","include","vector"]
  },
  {
    "name": "squares-subtract",
    "categories": ["design"],
    "tags": ["square","pathfinder","path","minus","subtract","subtraction","shape","front","vector"]
  },
  {
    "name": "squares-unite",
    "categories": ["design"],
    "tags": ["square","pathfinder","path","unite","union","shape","merge","vector"]
  },
  {
    "name": "squircle-dashed",
    "categories": ["development","shapes","design"],
    "tags": ["shape","pending","progress","issue","draft","code","coding","version control"]
  },
  {
    "name": "squircle",
    "categories": ["shapes"],
    "tags": ["shape"]
  },
  {
    "name": "squirrel",
    "categories": ["animals"],
    "tags": ["animal","rodent","pet","pest","nuts","retrieve","updates","storage","stash"]
  },
  {
    "name": "stamp",
    "categories": ["design","cursors","tools"],
    "tags": ["mark","print","clone","loyalty","library"]
  },
  {
    "name": "star-half",
    "categories": ["social","multimedia"],
    "tags": ["bookmark","favorite","like","review","rating"]
  },
  {
    "name": "star-off",
    "categories": ["multimedia","social"],
    "tags": ["dislike","unlike","remove","unrate"]
  },
  {
    "name": "star",
    "categories": ["account","social","shapes","multimedia","weather","emoji","gaming"],
    "tags": ["bookmark","favorite","like","review","rating"]
  },
  {
    "name": "step-back",
    "categories": ["multimedia","arrows"],
    "tags": ["arrow","previous","music","left","reverse"]
  },
  {
    "name": "step-forward",
    "categories": ["multimedia","arrows"],
    "tags": ["arrow","next","music","right","continue"]
  },
  {
    "name": "stethoscope",
    "categories": ["science","medical"],
    "tags": ["phonendoscope","medical","heart","lungs","sound"]
  },
  {
    "name": "sticker",
    "categories": ["social"],
    "tags": ["reaction","emotion","smile","happy","feedback"]
  },
  {
    "name": "sticky-note",
    "categories": ["text","social"],
    "tags": ["post-it","comment","annotation","reaction","memo","reminder","todo","task","idea","brainstorm","document","page","paper","sheet","stationary","office"]
  },
  {
    "name": "stone",
    "categories": ["nature"],
    "tags": ["mineral","geology","nature","solid","pebble","crystal","ore","hard","coal","stone","rock","boulder"]
  },
  {
    "name": "store",
    "categories": ["buildings","navigation","shopping"],
    "tags": ["shop","supermarket","stand","boutique","building"]
  },
  {
    "name": "stretch-horizontal",
    "categories": ["layout"],
    "tags": ["items","flex","justify","distribute"]
  },
  {
    "name": "stretch-vertical",
    "categories": ["layout"],
    "tags": ["items","flex","justify","distribute"]
  },
  {
    "name": "strikethrough",
    "categories": ["text"],
    "tags": ["cross out","delete","remove","format"]
  },
  {
    "name": "subscript",
    "categories": ["text"],
    "tags": ["text"]
  },
  {
    "name": "sun-dim",
    "categories": ["accessibility","weather"],
    "tags": ["brightness","dim","low","brightness low"]
  },
  {
    "name": "sun-medium",
    "categories": ["accessibility","weather"],
    "tags": ["brightness","medium"]
  },
  {
    "name": "sun-moon",
    "categories": ["accessibility"],
    "tags": ["dark","light","moon","sun","brightness","theme","auto theme","system theme","appearance"]
  },
  {
    "name": "sun-snow",
    "categories": ["weather"],
    "tags": ["weather","air conditioning","temperature","hot","cold","seasons"]
  },
  {
    "name": "sun",
    "categories": ["accessibility","weather","seasons","sustainability"],
    "tags": ["brightness","weather","light","summer"]
  },
  {
    "name": "sunrise",
    "categories": ["arrows","weather","time"],
    "tags": ["weather","time","morning","day"]
  },
  {
    "name": "sunset",
    "categories": ["arrows","weather"],
    "tags": ["weather","time","evening","night"]
  },
  {
    "name": "superscript",
    "categories": ["text"],
    "tags": ["text","exponent"]
  },
  {
    "name": "swatch-book",
    "categories": ["design","home","photography"],
    "tags": ["colors","colours","swatches","pantone","shades","tint","hue","saturation","brightness","theme","scheme","palette","samples","textile","carpet"]
  },
  {
    "name": "swiss-franc",
    "categories": ["finance"],
    "tags": ["currency","money","payment"]
  },
  {
    "name": "switch-camera",
    "categories": ["communication","devices"],
    "tags": ["photo","selfie","front","back"]
  },
  {
    "name": "sword",
    "categories": ["gaming","tools"],
    "tags": ["battle","challenge","game","war","weapon"]
  },
  {
    "name": "swords",
    "categories": ["gaming","tools"],
    "tags": ["battle","challenge","game","war","weapon"]
  },
  {
    "name": "syringe",
    "categories": ["science","medical"],
    "tags": ["medicine","medical","needle","pump","plunger","nozzle","blood"]
  },
  {
    "name": "table-2",
    "categories": ["text","files"],
    "tags": ["spreadsheet","grid"]
  },
  {
    "name": "table-cells-merge",
    "categories": ["text","files"],
    "tags": ["spreadsheet","grid","row"]
  },
  {
    "name": "table-cells-split",
    "categories": ["text","files"],
    "tags": ["spreadsheet","grid","row"]
  },
  {
    "name": "table-columns-split",
    "categories": ["text","files"],
    "tags": ["spreadsheet","grid","cut","break","divide","separate","segment"]
  },
  {
    "name": "table-of-contents",
    "categories": ["text"],
    "tags": ["toc","outline","navigation","document structure","index","overview","sections","chapters","content","documentation","manual","knowledge base","faq"]
  },
  {
    "name": "table-properties",
    "categories": ["text","development","files"],
    "tags": ["property list","plist","spreadsheet","grid","dictionary","object","hash"]
  },
  {
    "name": "table-rows-split",
    "categories": ["text","files"],
    "tags": ["spreadsheet","grid","cut","break","divide","separate","segment"]
  },
  {
    "name": "table",
    "categories": ["text","files"],
    "tags": ["spreadsheet","grid"]
  },
  {
    "name": "tablet-smartphone",
    "categories": ["devices","design","development","tools"],
    "tags": ["responsive","screens","browser","testing","mobile"]
  },
  {
    "name": "tablet",
    "categories": ["devices"],
    "tags": ["device"]
  },
  {
    "name": "tablets",
    "categories": ["medical"],
    "tags": ["medicine","medication","drug","prescription","pills","pharmacy"]
  },
  {
    "name": "tag",
    "categories": ["account"],
    "tags": ["label","badge","ticket","mark"]
  },
  {
    "name": "tags",
    "categories": ["account"],
    "tags": ["labels","badges","tickets","marks","copy","multiple"]
  },
  {
    "name": "tally-1",
    "categories": ["math","gaming"],
    "tags": ["count","score","enumerate","days","one","1","first","bar","prison","cell","sentence"]
  },
  {
    "name": "tally-2",
    "categories": ["math","gaming"],
    "tags": ["count","score","enumerate","days","two","2","second","double","bars","prison","cell","sentence"]
  },
  {
    "name": "tally-3",
    "categories": ["math","gaming"],
    "tags": ["count","score","enumerate","days","three","3","third","triple","bars","prison","cell","sentence"]
  },
  {
    "name": "tally-4",
    "categories": ["math","gaming"],
    "tags": ["count","score","enumerate","days","4","fourth","quadruple","bars","prison","cell","sentence"]
  },
  {
    "name": "tally-5",
    "categories": ["math","gaming"],
    "tags": ["count","score","enumerate","days","five","5","fifth","bars","prison","cell","sentence","slash","/"]
  },
  {
    "name": "tangent",
    "categories": ["shapes","math","design","tools"],
    "tags": ["tangential","shape","circle","geometry","trigonometry","bezier curve"]
  },
  {
    "name": "target",
    "categories": ["brands","gaming"],
    "tags": ["logo","bullseye","deadline","projects","overview","work","productivity"]
  },
  {
    "name": "telescope",
    "categories": ["science","development","tools"],
    "tags": ["astronomy","space","discovery","exploration","explore","vision","perspective","focus","stargazing","observe","view"]
  },
  {
    "name": "tent-tree",
    "categories": ["travel","nature"],
    "tags": ["camping","campsite","holiday","retreat","nomadic","wilderness","outdoors"]
  },
  {
    "name": "tent",
    "categories": ["travel","nature","sustainability"],
    "tags": ["tipi","teepee","wigwam","lodge","camping","campsite","holiday","retreat","nomadic","native american","indian","wilderness","outdoors"]
  },
  {
    "name": "terminal",
    "categories": ["development"],
    "tags": ["code","command line","prompt","shell"]
  },
  {
    "name": "test-tube-diagonal",
    "categories": ["science"],
    "tags": ["tube","vial","phial","flask","ampoule","ampule","lab","chemistry","experiment","test"]
  },
  {
    "name": "test-tube",
    "categories": ["science"],
    "tags": ["tube","vial","phial","flask","ampoule","ampule","lab","chemistry","experiment","test"]
  },
  {
    "name": "test-tubes",
    "categories": ["science"],
    "tags": ["tubes","vials","phials","flasks","ampoules","ampules","lab","chemistry","experiment","test"]
  },
  {
    "name": "text-align-center",
    "categories": ["text"],
    "tags": ["text","alignment","center"]
  },
  {
    "name": "text-align-end",
    "categories": ["text"],
    "tags": ["text","alignment","right"]
  },
  {
    "name": "text-align-justify",
    "categories": ["text"],
    "tags": ["text","alignment","justified","menu","list"]
  },
  {
    "name": "text-align-start",
    "categories": ["text"],
    "tags": ["text","alignment","left","list"]
  },
  {
    "name": "text-cursor-input",
    "categories": ["text","layout"],
    "tags": ["select"]
  },
  {
    "name": "text-cursor",
    "categories": ["text","cursors"],
    "tags": ["select"]
  },
  {
    "name": "text-initial",
    "categories": ["text"],
    "tags": ["drop cap","text","format","typography","letter","font size"]
  },
  {
    "name": "text-quote",
    "categories": ["text"],
    "tags": ["blockquote","quotation","indent","reply","response"]
  },
  {
    "name": "text-search",
    "categories": ["text"],
    "tags": ["find","data","copy","txt","pdf","document","scan","magnifier","magnifying glass","lens"]
  },
  {
    "name": "text-select",
    "categories": ["text","cursors"],
    "tags": ["find","search","selection","dashed"]
  },
  {
    "name": "text-wrap",
    "categories": ["text","arrows"],
    "tags": ["words","lines","break","paragraph"]
  },
  {
    "name": "theater",
    "categories": ["buildings","social"],
    "tags": ["theater","theatre","entertainment","podium","stage","musical"]
  },
  {
    "name": "thermometer-snowflake",
    "categories": ["weather"],
    "tags": ["temperature","celsius","fahrenheit","weather","cold","freeze","freezing"]
  },
  {
    "name": "thermometer-sun",
    "categories": ["weather"],
    "tags": ["temperature","celsius","fahrenheit","weather","warm","hot"]
  },
  {
    "name": "thermometer",
    "categories": ["weather"],
    "tags": ["temperature","celsius","fahrenheit","weather"]
  },
  {
    "name": "thumbs-down",
    "categories": ["account","social","emoji"],
    "tags": ["dislike","bad","emotion"]
  },
  {
    "name": "thumbs-up",
    "categories": ["account","social","emoji"],
    "tags": ["like","good","emotion"]
  },
  {
    "name": "ticket-check",
    "categories": ["transportation"],
    "tags": ["entry","pass","voucher","event","concert","show","booked","purchased","receipt","redeemed","validated","verified","certified","checked","used"]
  },
  {
    "name": "ticket-minus",
    "categories": ["transportation"],
    "tags": ["entry","pass","voucher","event","concert","show","remove","cancel","unbook","subtract","decrease","-"]
  },
  {
    "name": "ticket-percent",
    "categories": ["transportation","shopping"],
    "tags": ["discount","reduced","offer","voucher","entry","pass","event","concert","show","book","purchase","%"]
  },
  {
    "name": "ticket-plus",
    "categories": ["transportation"],
    "tags": ["entry","pass","voucher","event","concert","show","book","purchase","add","+"]
  },
  {
    "name": "ticket-slash",
    "categories": ["transportation"],
    "tags": ["entry","pass","voucher","event","concert","show","redeemed","used","marked","checked","verified","spoiled","invalidated","void","denied","refused","banned","barred","forbidden","prohibited","cancelled","cancellation","refunded","delete","remove","clear","error"]
  },
  {
    "name": "ticket-x",
    "categories": ["transportation"],
    "tags": ["entry","pass","voucher","event","concert","show","cancelled","cancellation","refunded","used","void","invalidated","spoiled","denied","refused","banned","barred","forbidden","prohibited","delete","remove","clear","error","x"]
  },
  {
    "name": "ticket",
    "categories": ["account","transportation"],
    "tags": ["entry","pass","voucher","event","concert","show","perforated","dashed"]
  },
  {
    "name": "tickets-plane",
    "categories": ["transportation","travel"],
    "tags": ["plane","trip","airplane","flight","travel","fly","takeoff","vacation","passenger","pass","check-in","airport"]
  },
  {
    "name": "tickets",
    "categories": ["travel","account","transportation"],
    "tags": ["trip","travel","pass","entry","voucher","event","concert","show","perforated","dashed"]
  },
  {
    "name": "timer-off",
    "categories": ["time"],
    "tags": ["time","timer","stopwatch"]
  },
  {
    "name": "timer-reset",
    "categories": ["time"],
    "tags": ["time","timer","stopwatch"]
  },
  {
    "name": "timer",
    "categories": ["time"],
    "tags": ["time","timer","stopwatch"]
  },
  {
    "name": "toggle-left",
    "categories": ["layout","account","development"],
    "tags": ["on","off","switch","boolean"]
  },
  {
    "name": "toggle-right",
    "categories": ["layout","account","development"],
    "tags": ["on","off","switch","boolean"]
  },
  {
    "name": "toilet",
    "categories": ["devices","home"],
    "tags": ["toilet","potty","bathroom","washroom"]
  },
  {
    "name": "tool-case",
    "categories": ["tools","development","home"],
    "tags": ["tools","maintenance","repair"]
  },
  {
    "name": "toolbox",
    "categories": ["tools","home"],
    "tags": ["toolkit","tools","trunk","chest","box","storage","utility","utilities","container","kit","set","repair","fix","service","maintenance","mechanic","workshop","construction","hardware","equipment","gear","handyman","engineering","craft","diy"]
  },
  {
    "name": "tornado",
    "categories": ["weather"],
    "tags": ["weather","wind","storm","hurricane"]
  },
  {
    "name": "torus",
    "categories": ["shapes","design","tools","food-beverage"],
    "tags": ["donut","doughnut","ring","hollow","3d","fast food","junk food","snack","treat","sweet","sugar","dessert"]
  },
  {
    "name": "touchpad-off",
    "categories": ["devices"],
    "tags": ["trackpad","cursor"]
  },
  {
    "name": "touchpad",
    "categories": ["devices"],
    "tags": ["trackpad","cursor"]
  },
  {
    "name": "tower-control",
    "categories": ["travel","transportation"],
    "tags": ["airport","travel","tower","transportation","lighthouse"]
  },
  {
    "name": "toy-brick",
    "categories": ["gaming","development"],
    "tags": ["lego","block","addon","plugin","integration"]
  },
  {
    "name": "tractor",
    "categories": ["transportation","sustainability","food-beverage"],
    "tags": ["farming","farmer","ranch","harvest","equipment","vehicle"]
  },
  {
    "name": "traffic-cone",
    "categories": ["transportation"],
    "tags": ["roadworks","tarmac","safety","block"]
  },
  {
    "name": "train-front-tunnel",
    "categories": ["transportation","navigation"],
    "tags": ["railway","metro","subway","underground","speed","bullet","fast","track","line"]
  },
  {
    "name": "train-front",
    "categories": ["transportation"],
    "tags": ["railway","metro","subway","underground","high-speed","bullet","fast","track","line"]
  },
  {
    "name": "train-track",
    "categories": ["transportation","navigation"],
    "tags": ["railway","line"]
  },
  {
    "name": "tram-front",
    "categories": ["transportation"],
    "tags": ["railway","metro","subway","underground","track","line","tourism"]
  },
  {
    "name": "transgender",
    "categories": ["medical","accessibility"],
    "tags": ["gender","inclusive"]
  },
  {
    "name": "trash-2",
    "categories": ["files","mail"],
    "tags": ["garbage","delete","remove","bin"]
  },
  {
    "name": "trash",
    "categories": ["files","mail"],
    "tags": ["empty","deletion","cleanup","junk","clear","garbage","delete","remove","bin","waste","recycle","discard","binoculars","rubbish"]
  },
  {
    "name": "tree-deciduous",
    "categories": ["nature","sustainability"],
    "tags": ["tree","forest","park","nature"]
  },
  {
    "name": "tree-palm",
    "categories": ["nature","sustainability"],
    "tags": ["vacation","leisure","island"]
  },
  {
    "name": "tree-pine",
    "categories": ["nature","sustainability"],
    "tags": ["tree","pine","forest","park","nature"]
  },
  {
    "name": "trees",
    "categories": ["nature","sustainability"],
    "tags": ["tree","forest","park","nature"]
  },
  {
    "name": "trello",
    "categories": ["account","brands","development"],
    "tags": ["logo","brand"]
  },
  {
    "name": "trending-down",
    "categories": ["charts","arrows"],
    "tags": ["statistics"]
  },
  {
    "name": "trending-up-down",
    "categories": ["charts","arrows"],
    "tags": ["arrows","estimated","indeterminate","data fluctuation","uncertain","forecast","variable","prediction","dynamic","volatile"]
  },
  {
    "name": "trending-up",
    "categories": ["charts","arrows"],
    "tags": ["statistics"]
  },
  {
    "name": "triangle-alert",
    "categories": ["notifications","shapes","development"],
    "tags": ["warning","alert","danger","exclamation mark","linter"]
  },
  {
    "name": "triangle-dashed",
    "categories": ["shapes"],
    "tags": ["equilateral","delta","shape","pyramid","hierarchy","dashed"]
  },
  {
    "name": "triangle-right",
    "categories": ["shapes","math"],
    "tags": ["volume","controls","controller","tv remote","geometry","delta","ramp","slope","incline","increase"]
  },
  {
    "name": "triangle",
    "categories": ["shapes"],
    "tags": ["equilateral","delta","shape","pyramid","hierarchy"]
  },
  {
    "name": "trophy",
    "categories": ["sports","gaming"],
    "tags": ["prize","sports","winner","achievement","award","champion","celebration","victory"]
  },
  {
    "name": "truck-electric",
    "categories": ["transportation"],
    "tags": ["delivery","van","shipping","haulage","lorry","electric"]
  },
  {
    "name": "truck",
    "categories": ["transportation"],
    "tags": ["delivery","van","shipping","haulage","lorry"]
  },
  {
    "name": "turkish-lira",
    "categories": ["finance"],
    "tags": ["currency","money","payment"]
  },
  {
    "name": "turntable",
    "categories": ["multimedia","home"],
    "tags": ["record player","gramophone","stereo","phonograph","vinyl","lp","disc","platter","cut","music","analog","retro","dj deck","disc jockey","scratch","spinning"]
  },
  {
    "name": "turtle",
    "categories": ["animals"],
    "tags": ["animal","pet","tortoise","slow","speed"]
  },
  {
    "name": "tv-minimal-play",
    "categories": ["devices","multimedia"],
    "tags": ["flatscreen","television","stream","display","widescreen","high-definition","hd","1080p","4k","8k","smart","digital","video","movie","live","ott","running","start","film","home cinema","entertainment","showtime","channels","catchup"]
  },
  {
    "name": "tv-minimal",
    "categories": ["devices","multimedia"],
    "tags": ["flatscreen","television","stream","display","widescreen","high-definition","hd","1080p","4k","8k","smart","digital","video","home cinema","entertainment","showtime","channels","catchup"]
  },
  {
    "name": "tv",
    "categories": ["devices","multimedia","communication"],
    "tags": ["television","stream","display","widescreen","high-definition","hd","1080p","4k","8k","smart","digital","video","entertainment","showtime","channels","terrestrial","satellite","cable","broadcast","live","frequency","tune","scan","aerial","receiver","transmission","signal","connection","connectivity"]
  },
  {
    "name": "twitch",
    "categories": ["brands","social","account","gaming"],
    "tags": ["logo","social"]
  },
  {
    "name": "twitter",
    "categories": ["brands","social","account"],
    "tags": ["logo","social"]
  },
  {
    "name": "type-outline",
    "categories": ["text"],
    "tags": ["text","font","typography","silhouette","profile","contour","stroke","line"]
  },
  {
    "name": "type",
    "categories": ["text"],
    "tags": ["text","font","typography"]
  },
  {
    "name": "umbrella-off",
    "categories": ["weather"],
    "tags": ["rain","weather","uncovered","uninsured","antivirus","unprotected","risky"]
  },
  {
    "name": "umbrella",
    "categories": ["weather"],
    "tags": ["rain","weather"]
  },
  {
    "name": "underline",
    "categories": ["text"],
    "tags": ["text","format"]
  },
  {
    "name": "undo-2",
    "categories": ["text","arrows"],
    "tags": ["redo","rerun","history","back","return","reverse","revert","direction","u-turn"]
  },
  {
    "name": "undo-dot",
    "categories": ["text","arrows"],
    "tags": ["redo","history","step","back"]
  },
  {
    "name": "undo",
    "categories": ["text","arrows"],
    "tags": ["redo","rerun","history"]
  },
  {
    "name": "unfold-horizontal",
    "categories": ["arrows","layout"],
    "tags": ["arrow","collapse","fold","vertical","dashed"]
  },
  {
    "name": "unfold-vertical",
    "categories": ["arrows","layout"],
    "tags": ["arrow","expand","vertical","dashed"]
  },
  {
    "name": "ungroup",
    "categories": ["shapes","files"],
    "tags": ["cubes","packages","parts","units","collection","cluster","separate"]
  },
  {
    "name": "university",
    "categories": ["buildings","navigation"],
    "tags": ["building","education","childhood","school","college","academy","institute"]
  },
  {
    "name": "unlink-2",
    "categories": ["text"],
    "tags": ["url","unchain"]
  },
  {
    "name": "unlink",
    "categories": ["text"],
    "tags": ["url","unchain"]
  },
  {
    "name": "unplug",
    "categories": ["devices","development"],
    "tags": ["electricity","energy","electronics","socket","outlet","disconnect"]
  },
  {
    "name": "upload",
    "categories": ["arrows","files"],
    "tags": ["file"]
  },
  {
    "name": "usb",
    "categories": ["devices","multimedia","home"],
    "tags": ["universal","serial","bus","controller","connector","interface"]
  },
  {
    "name": "user-check",
    "categories": ["account"],
    "tags": ["followed","subscribed","done","todo","tick","complete","task"]
  },
  {
    "name": "user-cog",
    "categories": ["account"],
    "tags": ["settings","edit","cog","gear"]
  },
  {
    "name": "user-lock",
    "categories": ["account","security"],
    "tags": ["person","lock","locked","account","secure"]
  },
  {
    "name": "user-minus",
    "categories": ["account"],
    "tags": ["delete","remove","unfollow","unsubscribe"]
  },
  {
    "name": "user-pen",
    "categories": ["account"],
    "tags": ["person","account","contact","profile","edit","change"]
  },
  {
    "name": "user-plus",
    "categories": ["account"],
    "tags": ["new","add","create","follow","subscribe"]
  },
  {
    "name": "user-round-check",
    "categories": ["account"],
    "tags": ["followed","subscribed","done","todo","tick","complete","task"]
  },
  {
    "name": "user-round-cog",
    "categories": ["account"],
    "tags": ["settings","edit","cog","gear"]
  },
  {
    "name": "user-round-minus",
    "categories": ["account"],
    "tags": ["delete","remove","unfollow","unsubscribe"]
  },
  {
    "name": "user-round-pen",
    "categories": ["account"],
    "tags": ["person","account","contact","profile","edit","change"]
  },
  {
    "name": "user-round-plus",
    "categories": ["account"],
    "tags": ["new","add","create","follow","subscribe"]
  },
  {
    "name": "user-round-search",
    "categories": ["account","social"],
    "tags": ["person","account","contact","find","scan","magnifier","magnifying glass","lens"]
  },
  {
    "name": "user-round-x",
    "categories": ["account"],
    "tags": ["delete","remove","unfollow","unsubscribe","unavailable"]
  },
  {
    "name": "user-round",
    "categories": ["account"],
    "tags": ["person","account","contact"]
  },
  {
    "name": "user-search",
    "categories": ["account","social"],
    "tags": ["person","account","contact","find","scan","magnifier","magnifying glass","lens"]
  },
  {
    "name": "user-star",
    "categories": ["account"],
    "tags": ["person","account","favorite","contact","like","review","rating","admin"]
  },
  {
    "name": "user-x",
    "categories": ["account"],
    "tags": ["delete","remove","unfollow","unsubscribe","unavailable"]
  },
  {
    "name": "user",
    "categories": ["account"],
    "tags": ["person","account","contact"]
  },
  {
    "name": "users-round",
    "categories": ["account"],
    "tags": ["group","people"]
  },
  {
    "name": "users",
    "categories": ["account"],
    "tags": ["group","people"]
  },
  {
    "name": "utensils-crossed",
    "categories": ["food-beverage","travel","navigation"],
    "tags": ["fork","knife","cutlery","flatware","tableware","silverware","food","restaurant","meal","breakfast","dinner","supper"]
  },
  {
    "name": "utensils",
    "categories": ["food-beverage","travel","navigation"],
    "tags": ["fork","knife","cutlery","flatware","tableware","silverware","food","restaurant","meal","breakfast","dinner","supper"]
  },
  {
    "name": "utility-pole",
    "categories": ["buildings","home","sustainability"],
    "tags": ["electricity","energy","transmission line","telegraph pole","power lines","phone"]
  },
  {
    "name": "van",
    "categories": ["transportation"],
    "tags": ["minivan","cart","wagon","truck","lorry","trailer","camper","vehicle","drive","trip","journey","van","transport","carriage","delivery","travel"]
  },
  {
    "name": "variable",
    "categories": ["development","math"],
    "tags": ["code","coding","programming","symbol","calculate","algebra","x","parentheses","parenthesis","brackets","parameter","(",")"]
  },
  {
    "name": "vault",
    "categories": ["security","travel","home"],
    "tags": ["safe","lockbox","deposit","locker","coffer","strongbox","safety","secure","storage","valuables","bank"]
  },
  {
    "name": "vector-square",
    "categories": ["shapes","math","design","tools"],
    "tags": ["shape","geometry","art","width","height","size","calculate","measure","select","graphics","box"]
  },
  {
    "name": "vegan",
    "categories": ["food-beverage","sustainability"],
    "tags": ["vegetarian","fruitarian","herbivorous","animal rights","diet"]
  },
  {
    "name": "venetian-mask",
    "categories": ["account","gaming"],
    "tags": ["mask","masquerade","impersonate","secret","incognito"]
  },
  {
    "name": "venus-and-mars",
    "categories": ["medical"],
    "tags": ["gender","sex","intersex","androgynous","hermaphrodite"]
  },
  {
    "name": "venus",
    "categories": ["medical"],
    "tags": ["gender","sex","female","feminine","woman","girl"]
  },
  {
    "name": "vibrate-off",
    "categories": ["devices","connectivity","account"],
    "tags": ["smartphone","notification","rumble","haptic feedback","notifications","screen"]
  },
  {
    "name": "vibrate",
    "categories": ["devices","connectivity","account","notifications"],
    "tags": ["smartphone","notification","rumble","haptic feedback","screen"]
  },
  {
    "name": "video-off",
    "categories": ["devices","communication","connectivity","photography"],
    "tags": ["camera","movie","film"]
  },
  {
    "name": "video",
    "categories": ["devices","communication","connectivity","photography"],
    "tags": ["camera","movie","film","recording","motion picture","camcorder","reel"]
  },
  {
    "name": "videotape",
    "categories": ["devices","communication","connectivity","photography","files"],
    "tags": ["vhs","movie","film","recording","motion picture","showreel","cassette"]
  },
  {
    "name": "view",
    "categories": ["design","photography"],
    "tags": ["eye","look"]
  },
  {
    "name": "voicemail",
    "categories": ["connectivity","devices","social"],
    "tags": ["phone","cassette","tape","reel","recording","audio"]
  },
  {
    "name": "volleyball",
    "categories": ["sports","gaming","travel"],
    "tags": ["beach","sand","net","holiday","vacation","summer","soccer","football","futbol","kick","pitch","goal","score","bounce","leather","wool","yarn","knitting","sewing","thread","embroidery","textile"]
  },
  {
    "name": "volume-1",
    "categories": ["connectivity","communication","multimedia"],
    "tags": ["music","sound","speaker"]
  },
  {
    "name": "volume-2",
    "categories": ["connectivity","communication","multimedia"],
    "tags": ["music","sound","speaker"]
  },
  {
    "name": "volume-off",
    "categories": ["connectivity","communication","multimedia"],
    "tags": ["music","sound","mute","speaker"]
  },
  {
    "name": "volume-x",
    "categories": ["connectivity","communication","multimedia"],
    "tags": ["music","sound","mute","speaker"]
  },
  {
    "name": "volume",
    "categories": ["connectivity","communication","multimedia"],
    "tags": ["music","sound","mute","speaker"]
  },
  {
    "name": "vote",
    "categories": ["social"],
    "tags": ["vote","poll","ballot","political","social","check","tick"]
  },
  {
    "name": "wallet-cards",
    "categories": ["account","finance"],
    "tags": ["money","finance","pocket","credit","purchase","payment","shopping","retail","consumer","cc"]
  },
  {
    "name": "wallet-minimal",
    "categories": ["account","finance"],
    "tags": ["finance","pocket"]
  },
  {
    "name": "wallet",
    "categories": ["account","finance"],
    "tags": ["money","finance","pocket"]
  },
  {
    "name": "wallpaper",
    "categories": ["account","devices"],
    "tags": ["background","texture","image","art","design","visual","decor","pattern","screen","cover","lock screen"]
  },
  {
    "name": "wand-sparkles",
    "categories": ["design","gaming","cursors","photography"],
    "tags": ["magic","wizard","magician"]
  },
  {
    "name": "wand",
    "categories": ["design","gaming","cursors","photography"],
    "tags": ["magic","selection"]
  },
  {
    "name": "warehouse",
    "categories": ["buildings","navigation"],
    "tags": ["storage","storehouse","depot","depository","repository","stockroom","logistics","building"]
  },
  {
    "name": "washing-machine",
    "categories": ["home","devices","travel"],
    "tags": ["tumble dryer","amenities","electronics","cycle","clothes","rinse","spin","drum"]
  },
  {
    "name": "watch",
    "categories": ["time"],
    "tags": ["clock","time"]
  },
  {
    "name": "waves-arrow-down",
    "categories": ["weather","sustainability"],
    "tags": ["water","sea","level","sound","hertz","wavelength","vibrate","low","tide","ocean","rising","down","falling"]
  },
  {
    "name": "waves-arrow-up",
    "categories": ["weather","sustainability"],
    "tags": ["water","sea","level","sound","hertz","wavelength","vibrate","high","tide","ocean","rising"]
  },
  {
    "name": "waves-ladder",
    "categories": ["sports","home"],
    "tags": ["swimming","water","pool","lifeguard","ocean","🌊","🏊‍♂️","🏊‍♀️","🏊","🥽"]
  },
  {
    "name": "waves",
    "categories": ["weather","navigation","multimedia","sustainability"],
    "tags": ["water","sea","sound","hertz","wavelength","vibrate"]
  },
  {
    "name": "waypoints",
    "categories": ["security","account","navigation","development","social"],
    "tags": ["indirection","vpn","virtual private network","proxy","connections","bounce","reroute","path","journey","planner","stops","stations","shared","spread","viral"]
  },
  {
    "name": "webcam",
    "categories": ["connectivity","devices","communication"],
    "tags": ["camera","security"]
  },
  {
    "name": "webhook-off",
    "categories": ["development","social","account"],
    "tags": ["push api","interface","callback"]
  },
  {
    "name": "webhook",
    "categories": ["development","social","account"],
    "tags": ["push api","interface","callback"]
  },
  {
    "name": "weight-tilde",
    "categories": ["math"],
    "tags": ["measure","scale","estimate","load","balance","size","measurement","quantity","mass"]
  },
  {
    "name": "weight",
    "categories": ["math"],
    "tags": ["mass","heavy","lead","metal","measure","geometry","scales","balance"]
  },
  {
    "name": "wheat-off",
    "categories": ["food-beverage"],
    "tags": ["corn","cereal","grain","gluten free","allergy","intolerance","diet"]
  },
  {
    "name": "wheat",
    "categories": ["food-beverage"],
    "tags": ["corn","cereal","grain","gluten"]
  },
  {
    "name": "whole-word",
    "categories": ["text"],
    "tags": ["text","selection","letters","characters","font","typography"]
  },
  {
    "name": "wifi-cog",
    "categories": ["connectivity","devices","files"],
    "tags": ["connection","signal","wireless","directory","settings","control","preferences","cog","edit","gear"]
  },
  {
    "name": "wifi-high",
    "categories": ["connectivity","devices"],
    "tags": ["connection","signal","wireless"]
  },
  {
    "name": "wifi-low",
    "categories": ["connectivity","devices"],
    "tags": ["connection","signal","wireless"]
  },
  {
    "name": "wifi-off",
    "categories": ["connectivity","devices"],
    "tags": ["disabled"]
  },
  {
    "name": "wifi-pen",
    "categories": ["connectivity","devices"],
    "tags": ["edit","wifi","pen","change","network"]
  },
  {
    "name": "wifi-sync",
    "categories": ["connectivity","devices"],
    "tags": ["connection","signal","wireless","synchronize","reconnect","reset","restart"]
  },
  {
    "name": "wifi-zero",
    "categories": ["connectivity","devices"],
    "tags": ["connection","signal","wireless"]
  },
  {
    "name": "wifi",
    "categories": ["connectivity","devices"],
    "tags": ["connection","signal","wireless"]
  },
  {
    "name": "wind-arrow-down",
    "categories": ["weather","sustainability"],
    "tags": ["weather","air","pressure","blow"]
  },
  {
    "name": "wind",
    "categories": ["weather","sustainability"],
    "tags": ["weather","air","blow"]
  },
  {
    "name": "wine-off",
    "categories": ["food-beverage"],
    "tags": ["alcohol","beverage","drink","glass","alcohol free","abstinence","abstaining","teetotalism","allergy","intolerance"]
  },
  {
    "name": "wine",
    "categories": ["food-beverage"],
    "tags": ["alcohol","beverage","bar","drink","glass","sommelier","vineyard","winery"]
  },
  {
    "name": "workflow",
    "categories": ["development"],
    "tags": ["action","continuous integration","ci","automation","devops","network","node","connection"]
  },
  {
    "name": "worm",
    "categories": ["animals","security"],
    "tags": ["invertebrate","grub","larva","snake","crawl","wiggle","slither","pest control","computer virus","malware"]
  },
  {
    "name": "wrench",
    "categories": ["account","development","tools"],
    "tags": ["account","settings","spanner","diy","toolbox","build","construction"]
  },
  {
    "name": "x",
    "categories": ["notifications","math"],
    "tags": ["cancel","close","cross","delete","ex","remove","times","clear","math","multiply","multiplication"]
  },
  {
    "name": "youtube",
    "categories": ["multimedia","social","brands"],
    "tags": ["logo","social","video","play"]
  },
  {
    "name": "zap-off",
    "categories": ["connectivity","devices","photography","weather"],
    "tags": ["flash","camera","lightning","electricity","energy"]
  },
  {
    "name": "zap",
    "categories": ["connectivity","devices","photography","weather"],
    "tags": ["flash","camera","lightning","electricity","energy"]
  },
  {
    "name": "zoom-in",
    "categories": ["accessibility","layout","design","text","photography"],
    "tags": ["magnifying glass","plus"]
  },
  {
    "name": "zoom-out",
    "categories": ["accessibility","layout","design","text","photography"],
    "tags": ["magnifying glass","plus"]
  }
    ];